<template>
  <div class="projects">
    <div class="content">
      <div class="wrapper">
        <div class="wrap">
          <div class="wrap__tree" ref="wrap__tree">
            <div class="nav-project">
              <div class="nav-project_first-row" style="width: 100%; margin-right: 20px;">
                <div v-if="!isWorkDay" id="fade-in" style="width: 100%">
                  <div style="display:flex">
<!--                    <el-tooltip-->
<!--                        v-if="rowData.length"-->
<!--                        effect="dark"-->
<!--                        placement="bottom-start">-->
<!--                      <div slot="content" class="project-tooltip-content">-->
<!--                        <div class="project-tooltip-item">-->
<!--                          {{$t('modal_projectName')}}:<span>{{rowData[0].name}}</span>-->
<!--                        </div>-->
<!--                        <div class="project-tooltip-item">-->
<!--                          {{$t('modal_projectOwnerProj')}}:<span>{{rowData[0].leader.fullName}}</span>-->
<!--                        </div>-->
<!--                        <div class="project-tooltip-item">-->
<!--                          {{$t('general_region')}}:<span>{{rowData[0].projectRegion}}</span>-->
<!--                        </div>-->
<!--                        <div class="project-tooltip-item">-->
<!--                          {{$t('general_phase')}}:<span>{{rowData[0].projectPhase}}</span>-->
<!--                        </div>-->
<!--                        <div class="project-tooltip-item">-->
<!--                          {{$t('general_status')}}:<span>{{rowData[0].projectStatus}}</span>-->
<!--                        </div>-->
<!--                        <div class="project-tooltip-item">-->
<!--                          {{$t('general_priority')}}:<span>{{rowData[0].projectPriority}}</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <el-button-->
<!--                          size="small"-->
<!--                          icon="el-icon-edit-outline">-->
<!--                        {{$t('project_data')}}-->
<!--                      </el-button>-->
<!--                    </el-tooltip>-->
                    <el-dropdown v-if="rowData.length && activeProjectRowData" size="medium" >
                      <el-button
                        size="small"
                        icon="el-icon-edit-outline">
                        {{$t('project_data')}}
                      </el-button>
                      <el-dropdown-menu slot="dropdown" class="project-info-menu">
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('modal_projectName')}}:<span>{{activeProjectRowData.name}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('modal_projectNo')}}:<span>{{activeProjectRowData.no}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('general_region')}}:<span>{{activeProjectRowData.projectRegion}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('general_phase')}}:<span>{{activeProjectRowData.projectPhase}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('general_status')}}:<span>{{activeProjectRowData.projectStatus}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('general_priority')}}:<span>{{activeProjectRowData.projectPriority}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('modal_projectOwnerProj')}}:<span>{{activeProjectRowData.projectOwner}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('modal_assignedTo')}}:<span>{{activeProjectRowData.leader.fullName}}</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="project-tooltip-item">
                            {{$t('modal_projectsSupportBus')}}:<span>{{activeProjectRowData.buManager.join(', ')}}</span>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
<!--                    <el-input-->
<!--                        prefix-icon="el-icon-search"-->
<!--                        style="margin-left: 20px;"-->
<!--                        size="mini"-->
<!--                        :placeholder="$t('general_search')"-->
<!--                        v-model="searchInputGrid">-->
<!--                    </el-input>-->
                    <div style="width: 100%; margin-left:20px; display: flex; align-items: flex-end">
                      <projectSearchComponent
                          ref="projectSearchComponent"
                          @submit="putProjectIntoTable" />
                    </div>
<!--                    <el-select class="inputs-projects" no-data-text="no data" v-model="valueProject" :placeholder="$t('project_select_project')" size="mini">-->
<!--                      <el-option-->
<!--                          v-for="item in project"-->
<!--                          :key="item.id"-->
<!--                          :label="item.no + ' - ' + item.name"-->
<!--                          :value="item.id"-->
<!--                          @click.native="setProjectRowDataInput(item.id, 'first')">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
                  </div>

<!--                  <el-select class="inputs" no-data-text="no data" v-model="clientListId" :placeholder="$t('project_select_clients')" size="mini">-->
<!--                    <el-option-->
<!--                            v-for="item in clientList"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id"-->
<!--                            @click.native="setClients(item.id)">-->
<!--                    </el-option>-->
<!--                  </el-select>-->

<!--                  <el-select class="inputs" no-data-text="no data" v-model="valueRegion" :placeholder="$t('project_select_region')" size="mini">-->
<!--                    <el-option-->
<!--                            v-for="item in region"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id"-->
<!--                            @click.native="setFilter(item.id, valueStages)">-->
<!--                    </el-option>-->
<!--                  </el-select>-->

<!--                  <el-select class="inputs" no-data-text="no data" v-model="valueStages" :placeholder="$t('project_select_stages')" size="mini">-->
<!--                    <el-option-->
<!--                            v-for="item in stages"-->
<!--                            :key="item.id"-->
<!--                            :label="item.name"-->
<!--                            :value="item.id"-->
<!--                            @click.native="setFilter(valueRegion, item.id)">-->
<!--                    </el-option>-->
<!--                  </el-select>-->

<!--                  <el-select class="inputs-projects" no-data-text="no data" v-model="valueProject" :placeholder="$t('project_select_project')" size="mini">-->
<!--                    <el-option-->
<!--                            v-for="item in project"-->
<!--                            :key="item.id"-->
<!--                            :label="item.no + ' - ' + item.name"-->
<!--                            :value="item.id"-->
<!--                            @click.native="setProjectRowDataInput(item.id, 'first')">-->
<!--                    </el-option>-->
<!--                  </el-select>-->

                </div>
                <div v-if="isWorkDay" class="work-day-block">
                  <el-button class="close-work-day-btn" @click="closeMyWorkDay" size="mini" border type="primary" plain>{{$t('project_btn_close_my_workday')}}</el-button>
                  <router-link :to="`/users?companyId=${this.$route.query.companyId}`">
                    <el-button @click="setMyWorkDay" size="mini" type="primary" plain>{{$t('project_btn_set_my_workday')}}</el-button>
                  </router-link>
                </div>
              </div>
              <div>
                <!--<el-button @click="tester">click</el-button>-->
                <el-dropdown @command="handleCommand">
                  <el-button class="nav-tree__item" size="small" type="menu" icon="el-icon-edit-outline">{{$t('project_dropdown_action')}}</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <!--<el-dropdown-item  v-if="companyLayout" command="changeWorkDay" :disabled="isWorkDay || !projectPermission.actionMyWorkday" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-tickets">{{$t('project_dropdown_action_my_workday')}}</el-dropdown-item>-->
                    <!-- <el-dropdown-item  v-if="companyLayout" command="createProject" :disabled="isWorkDay || !companyLayout.permission.addProjects" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_action_create_project')}}</el-dropdown-item> -->
                    <el-dropdown-item  v-if="companyLayout" command="editProject" :disabled="!companyLayout.permission.updateProjects" v-show="selectedRow.type === 'project' && rowData.length > 0" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('project_dropdown_action_edit_project')}}</el-dropdown-item>
                    <el-dropdown-item  v-if="companyLayout" command="removeBUProject" :disabled="!companyLayout.permission.updateProjects" v-show="selectedRow.type === 'project' && rowData.length > 0" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('project_dropdown_action_remove_BU_project')}}</el-dropdown-item>
                    <el-dropdown-item  v-if="companyLayout" :disabled="!companyLayout.permission.deleteProjects" command="deleteProject" v-show="selectedRow.type === 'project' && rowData.length > 0" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-delete">{{$t('project_dropdown_action_delete_project')}}</el-dropdown-item>
                    <el-dropdown-item  command="addTask" :disabled="disabledBtn || isWorkDay || !projectPermission.createTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('project_dropdown_action_add_task')}}</el-dropdown-item>
                    <el-dropdown-item  command="duplicateTask" :disabled="isProject || disabledBtn || isWorkDay || !projectPermission.createTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('project_dropdown_action_duplicate_task')}}</el-dropdown-item>
                    <el-dropdown-item  command="copyTask" :disabled="isProject || disabledBtn || isWorkDay || !projectPermission.createTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">Copy Task</el-dropdown-item>
                    <el-dropdown-item  command="editTask" :disabled="isProject || disabledBtn || isWorkDay || !projectPermission.updateTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-edit">{{$t('project_dropdown_action_edit_task')}}</el-dropdown-item>
<!--                    <el-dropdown-item  command="shareTask" :disabled="isProject || disabledBtn || selectedRow.allowSharing !== 1 || !projectPermission.shareTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-share">{{$t('project_dropdown_action_share_task')}}</el-dropdown-item>-->
<!--                    <el-dropdown-item  command="unShareTask" :disabled="isProject || disabledBtn || selectedRow.allowSharing !== 1 || !projectPermission.unshareTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-close">{{$t('project_dropdown_action_un_share_task')}}</el-dropdown-item>-->
                    <el-dropdown-item  command="deleteTask" :disabled="isProject || disabledBtn || isWorkDay || selectedRow.type !== 'task' || !projectPermission.deleteTask" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-delete">{{$t('project_dropdown_action_delete_task')}}</el-dropdown-item>
                    <el-dropdown-item  v-if="companyLayout" command="saveTaskTree" :disabled="disabledBtn || isWorkDay || !projectPermission.actionSaveTree" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-star-off">{{$t('project_dropdown_action_save_task_tree')}}</el-dropdown-item>
                    <el-dropdown-item command="inviteUser" :disabled="isProject || disabledBtn || !companyLayout.permission.inviteUser" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-plus">{{$t('project_dropdown_action_invite_user')}}</el-dropdown-item>
                    <!-- <el-dropdown-item v-if="companyLayout" command="exportProject" :disabled="!companyLayout.permission.exportProjects" v-show="selectedRow.type === 'project' && rowData.length > 0" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-upload2">{{$t('project_dropdown_action_export_project')}}</el-dropdown-item>
                    <el-dropdown-item v-if="companyLayout" command="importProject" :disabled="isWorkDay || !companyLayout.permission.importProjects" class="nav-tree__item  " size="mini" type="primary" plain icon="el-icon-download">{{$t('project_dropdown_action_import_project')}}</el-dropdown-item> -->
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div style="width:100%; height: calc(100% - 113px); position: relative;">
              <span v-if="!isWorkDay" class="own-btn" @click="showMyTasks(ownTasks)">{{ownTasks ? $t('project_showAllTasks') : $t('project_showMyTasks')}}</span>
              <span v-if="!isWorkDay" class="collapse-btn" @click="expandAll">{{expand ? $t('project_closeAllTasks') : $t('project_showAllTasks')}}</span>
              <ag-grid-vue style="width: 100%; height: 100%" class="ag-theme-balham" id="myGrid"
                           ref="agGrid"
                           :suppressMultiSort="false"
                           :components="components"
                           :getRowNodeId="getRowNodeId"
                           :getContextMenuItems="getContextMenuItems"
                           :rowSelection="rowSelection"
                           :floatingFilter="true"
                           @row-drag-move="onRowDragMove"
                           @row-drag-leave="onRowDragLeave"
                           @selection-changed="onSelectionChanged"
                           :gridOptions="gridOptions"
                           @grid-ready="onGridReady"
                           :columnDefs="columnDefs"
                           :rowData="rowData"
                           :defaultColDef="defaultColDef"
                           :frameworkComponents="frameworkComponents"
                           :modules="modules"
                           :getRowHeight="getRowHeight"
                           :getDataPath="getDataPath"
                           :autoGroupColumnDef="autoGroupColumnDef"
                           :groupDefaultExpanded="groupDefaultExpanded"
                           :animateRows="true"
                           @row-drag-end="onRowDragEnd"
                           :treeData="true"
                           :suppressHorizontalScroll="true"
                           :rowClassRules="rowClassRules">
              </ag-grid-vue>
            </div>
            <!--{{isProject}}-->
            <!--{{documentList}}-->
            <!--{{rowData}}-->
            <!--{{activeSCMTab}}-->
            <!--{{activeAccountTHINKTab}}-->
            <!--{{activeCRMTab}}-->
            <!--{{activeTaskInfoTab}}-->
            <!--{{activeInfoTab}}-->
<!--            {{activeTab}}-->
          </div>
          <div class="wrap__info">
            <div class="nav-project">
              <div>
                <el-dropdown placement="bottom-start" @command="handleCommand">
                  <el-button style="margin-right: 20px;" size="small" type="menu" icon="el-icon-edit-outline">{{$t('project_dropdown_function')}}</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="selectedRow.type !== 'project'" command="toggleProjectBookmark" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_projectBookmark')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionCreateEstimate || true" command="createProjectEstimate" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_create_estimate')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionCreateQuotation || true" command="createProjectQuotation" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_create_quotation')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionCreateSalesOrder || true" command="createProjectSalesOrder" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_create_sales_order')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionCreateInvoice || false" command="createProjectInvoice" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_create_invoice')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionRequestPurchase || true" command="purchaseRequest" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_purchase_request')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionAddPayment || true" command="addProjectPayment" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_add_payment')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionCreateCreditNote || true" command="createProjectCreditNote" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_create_credit_note')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="businessUnitSelected || !projectPermission.functionAddExpense || true" command="addProjectExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_add_expense')}}</el-dropdown-item>
                    <!--tasks-->
                    <el-dropdown-item :disabled="isProject" command="toggleProjectTaskBookmark" divided class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_bookmarkTask')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionCreateTaskEstimate || true" command="createTaskEstimate" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_create_task_estimate')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="!projectPermission.functionRequestCashAdvance || true" command="createCashAdvance" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_request_cash_advance')}}</el-dropdown-item>
                    <el-dropdown-item :disabled="isProject || !projectPermission.functionAddTaskExpense || true" command="addTaskExpense" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_add_task_expense')}}</el-dropdown-item>
                    <el-dropdown-item command="addTaskTimer" :disabled="isProject || selectedRow.type !== 'task' || (selectedRow.taskStatus !== 2 && selectedRow.taskStatus !== 5)  || !projectPermission.functionStartTaskTimer" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-edit-outline">{{$t('project_dropdown_function_start_task_timer')}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button class="nav-tree__item" size="mini" @click="openCalendar" type="menu2" icon="el-icon-menu">Project Calander</el-button> -->
                <el-button :disabled="!projectPermission.functionCalander || !$route.query.projectId" @click="openScheduler" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('project_btn_calander')}}</el-button>
                <el-button :disabled="!projectPermission.functionCharts || !$route.query.projectId" @click="openGant" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('project_btn_gant')}}</el-button>
                <el-button :disabled="!projectPermission.functionReports" @click="underDevelopment" class="nav-tree__item" size="small" type="menu2" icon="el-icon-menu">{{$t('project_btn_reports')}}</el-button>
              </div>
            </div>
              <el-tabs type="border-card" v-model="activeTab" @tab-click="handleClick">
                <el-tab-pane v-if="isProject" :disabled="disabledBtn || !projectPermission.viewInfo" :label="$t('project_tab_info')" name="first">
                  <InfoTab ref="infoTab"
                           v-model="activeInfoTab"
                           v-if="!disabledBtn"
                           :companyLayout="companyLayout"
                           :selectedRow="selectedRow"
                           :selectedTaskForInfo="selectedTaskForInfo"
                           :projectInfo="projectInfo"
                           :taskInfo="taskInfo"
                           @setNewPermissions="setNewPermissions"
                           :projectPermission="projectPermission"/>
                </el-tab-pane>
                <el-tab-pane v-else :disabled="disabledBtn || !projectPermission.viewTaskInfo" :label="$t('project_tab_info')" name="taskInfoTab">
                  <info-project-task-tab
                          ref="taskInfoTab"
                          v-model="activeTaskInfoTab"
                          v-if="!disabledBtn"
                          :selectedRow="selectedRow"
                          :taskInfo="taskInfo"
                          :bookmarkList="bookmarkList"
                          @submit="getTaskInfo"
                          @submitAbout="getTaskInfo"
                          :projectPermission="projectPermission"

                          :sharedProjecttaskNoteId="sharedProjecttaskNoteId"
                          :progressData="progressData"
                          :selectedTaskForInfo="selectedTaskForInfo"
                          :selectedRowId="selectedRow.id"
                          :activeProjectId="activeProjectId"
                          @getProjects="setProjectRowDataInput"
                  />
                </el-tab-pane>
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewFiles" v-if="isProject" :label="$t('project_tab_files')" name="third">
                  <projectsFilesTabNew
                          :projectPermission="projectPermission"
                          v-if="!disabledBtn"
                          :bookmarkListProject="bookmarkListProject"
                          :selectedRow="selectedRow"/>
                </el-tab-pane>
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewTaskFiles" v-else :label="$t('project_tab_files')" name="four">
                  <taskFilesTabNew
                          :projectPermission="projectPermission"
                          :bookmarkList="bookmarkList"
                          v-if="!disabledBtn"
                          :selectedRow="selectedRow" />
                </el-tab-pane>
                <!-- v-if="selectedRow.type === 'task'" -->
                <el-tab-pane :disabled="disabledBtn" v-if="false" :label="$t('project_tab_progress')" name="second" id="progresses">
                  <projProgressTab
                          :projectPermission="projectPermission"
                          :sharedProjecttaskNoteId="sharedProjecttaskNoteId"
                          v-if="!disabledBtn"
                          :selectedRow="selectedRow"
                          :progressData="progressData"
                          :selectedTaskForInfo="selectedTaskForInfo"
                          :selectedRowId="selectedRow.id"
                          :activeProjectId="activeProjectId"
                          :bookmarkList="bookmarkList"
                          @submit="setProjectRowDataInput" />
                </el-tab-pane>

                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewComments" v-if="isProject" :label="$t('project_tab_comments')" name="projectCommentTab">
                  <projectCommentsTab ref="projectCommentTab" :projectPermission="projectPermission" :bookmarkListProject="bookmarkListProject" :selectedRow="selectedRow" v-if="!disabledBtn" />
                </el-tab-pane>
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewTaskComments" v-else :label="$t('project_tab_comments')" name="projectTaskCommentTab">
                  <taskCommentsTab ref="projectTaskCommentTab" :projectPermission="projectPermission" :bookmarkList="bookmarkList" v-if="!disabledBtn" :selectedRow="selectedRow" :activeProjectId="activeProjectId"/>
                </el-tab-pane>

                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewMessages" v-if="isProject" :label="$t('project_tab_messages')" name="seven">
                  <MessagesProject v-if="!disabledBtn" type="project" :bookmarkListProject="bookmarkListProject" :selectedRow="selectedRow" ref="MessagesProject" :activeProjectId="activeProjectId"/>
                </el-tab-pane>
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewTaskMessages" v-else :label="$t('project_tab_messages')" name="eight">
                  <MessagesTask :bookmarkList="bookmarkList" v-if="!disabledBtn" type="task" :selectedRow="selectedRow" ref="MessagesTask" :activeProjectId="activeProjectId"/>
                </el-tab-pane>

                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewMeetings" v-if="isProject" :label="$t('project_tab_meetings')" name="nine">
                  <projectMeetings
                          ref="projectMeetingTab"
                          :projectPermission="projectPermission"
                          :projectCompanyVendorList="projectCompanyVendorList"
                          :projectCompanyClientList="projectCompanyClientList"
                          :selectedRow="selectedRow"
                          :bookmarkListProject="bookmarkListProject"/>
                </el-tab-pane>
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewTaskMeetings" v-else :label="$t('project_tab_meetings')" name="ten">
                  <projectTaskMeetings
                          ref="projectTaskMeetingTab"
                          :projectPermission="projectPermission"
                          :selectedRow="selectedRow"
                          :projectTaskPersonVendorList="projectTaskPersonVendorList"
                          :projectTaskCompanyClientPersonList="projectTaskCompanyClientPersonList"
                          :bookmarkList="bookmarkList"/>
                </el-tab-pane>
                <!-- v-if="!isProject" -->
                <!--<el-tab-pane :disabled="disabledBtn || !projectPermission.viewDocuments" v-if="false" :label="$t('project_tab_documents')" name="fourteen">-->
                  <!--<DocumentsTask ref="docs" :projectPermission="projectPermission" :selectedRow="selectedRow" :bookmarkList="bookmarkList"/>-->
                <!--</el-tab-pane>-->

                <!-- CRM -->
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewCRM || !projectPermission.viewTaskCRM" :label="$t('project_tab_crm')" name="crm">
                  <CRM
                          v-model="activeCRMTab"
                          :isProject="isProject"
                          :selectedRow="selectedRow"
                          ref="crm"
                          :bookmarkList="bookmarkList"
                          :bookmarkListProject="bookmarkListProject"
                          :projectPermission="projectPermission"/>
                </el-tab-pane>

                <!-- SCM -->
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewSCM || !projectPermission.viewTaskSCM" :label="$t('project_tab_scm')" name="scm">
                  <SCM
                          v-model="activeSCMTab"
                          :isProject="isProject"
                          :selectedRow="selectedRow"
                          ref="scm"
                          :bookmarkList="bookmarkList"
                          :bookmarkListProject="bookmarkListProject"
                          :projectPermission="projectPermission"/>
                </el-tab-pane>

                <!-- aTHINK -->
                <el-tab-pane :disabled="disabledBtn || !projectPermission.viewAT || !projectPermission.viewTaskAT" :label="$t('project_tab_at')" name="aTHINK">
                  <aTHINKTab
                          v-model="activeAccountTHINKTab"
                          :isProject="isProject"
                          :selectedRow="selectedRow"
                          ref="aTHINK"
                          :bookmarkList="bookmarkList"
                          :bookmarkListProject="bookmarkListProject"
                          :projectPermission="projectPermission"/>
                </el-tab-pane>

              </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- [ Modal Share Project Task start -->
    <ShareProjectTaskModal
            ref="shareProjectTaskModal"
            @submit="setProjectRowDataInput"
            :selectedRowId="selectedRow.id"/>
    <!-- [ Modal Share Project Task end -->

    <!-- [ Modal Unshare Project Task start -->
    <UnShareProjectTaskModal
            ref="unShareProjectTaskModal"
            @submit="setProjectRowDataInput"
            :selectedRow="selectedRow"/>
    <!-- [ Modal Unshare Project Task end -->


    <!-- [ Modal form Create Project start -->
    <CreateProjectModalWizard
            ref="modal"
            :projectState = "projectState"
            @permissionsPromptMessage="openPermissionsTab"
            @submit="putProjectIntoTable"
            @refreshBlock="refreshBlock"/>
    <!-- [ Modal form Create Project] end -->

    <!-- [ Modal form Create Task start -->
    <CreateTaskModal
            ref="taskModal"
            :selectedRow="selectedRow"
            :stateTask = "stateTask"
            :activeProjectId="activeProjectId"
            @submit="setProjectRowDataInput" />
    <!-- [ Modal form Create Task start -->

    <!-- [ Modal form Before Create ADD PARENT Task start -->
    <sweet-modal blocking ref="addParent" class="modal-parent">
      Task already started, add sub task not permited, do you want to insert task?
      <el-button slot="button" v-on:click="$refs.addParent.close(),  addTaskOpen('insert')">Insert task</el-button>
    </sweet-modal>
    <!-- [ Modal form Before Create ADD PARENT Task end -->

      <!-- [ Modal Reassign Tasks start -->
      <ReassignTasksModal
              :selectedRows="selectedRows"
              :activeProjectId="activeProjectId"
              ref="ReassignTasksModal"
              @submit="setProjectRowDataInput"/>
      <!-- [ Modal Reassign Tasks end -->

      <add-users-to-tasks-modal
              :selectedRows="selectedRows"
              :activeProjectId="activeProjectId"
              ref="addNewUserToTasksModal"
              @submit="setProjectRowDataInput"/>

      <!-- [ Modal Edit Task List Confirmation end -->
    <CreateProjectTemplate ref="modal777" @getTreeScreen="getTreeScreen"/>
    <!-- [ Modal form Edit Vendor ] end -->

    <!-- [ Modal after drag end ] start-->
    <projectExpenseModal :selectedRow="selectedRow" ref="projectExpenseModal"/>

    <projectExpenseRequestModal
            :selectedRow="selectedRow"
            ref="projectExpenseRequest"/>

    <projectCashAdvanceModal :selectedRow="selectedRow" ref="projectCashAdvanceModal"/>

    <requestProjectCashAdvanceModal :selectedRow="selectedRow" ref="requestProjectCashAdvanceModal"/>

    <!--PURCHASE REQUEST MODAL-->
    <purchaseRequest :selectedRow="selectedRow" :activeProject="rowData[0]" ref="purchaseRequest" @refreshPurchase="refreshPurchase"/>
    <!--PURCHASE REQUEST MODAL-->

    <!--PURCHASE ORDER MODAL-->
    <purchaseOrder :selectedRow="selectedRow" :activeProject="rowData[0]" ref="purchaseOrder" @refreshPurchase="refreshPurchase"/>
    <!--PURCHASE ORDER MODAL-->

    <!--REMOVE BU FROM PROJECT MODAL-->
    <remove-b-u-from-project-modal ref="removeBuFromProjectModal" @loadList="loadList"/>
    <!--REMOVE BU FROM PROJECT MODAL-->

    <!-- [ Modal task not found ] start-->
    <sweet-modal ref="taskNotFound" icon="warning">
      <div class="task-not-found-block">
        <h3>Task has been deleted</h3>
      </div>
    </sweet-modal>
    <!-- [ Modal task not found ] start-->
    <inviteUserModal ref="inviteUserModal"/>

    <!-- [ Modal importProject start ] start-->
    <sweet-modal blocking :title="$t('modal_importProject')" width="400" ref="importProject" class="modal">
      <form class="importProject">
        <label for="fileImport" class="importProject__label">
          <i class="el-icon-upload"></i> {{$t('modal_uploadFile')}}
        </label>
        <input v-show="false" @change="handleFileImport" ref="fileImport" id="fileImport" name="myFileImport" type="file">
      </form>

    </sweet-modal>
    <!-- [ Modal importProject end ] start-->

    <!-- [ Modal Ask Before Exp start ] start-->
    <sweet-modal blocking width="400" ref="askBeforeExp">
      <div class="ask-before-exp">
        <h1>{{$t('general_action')}}</h1>
        <el-button @click="openProjectExpenseRequest('requestProjectTaskExpenses')" class="modal__btn btn" type="primary" plain size="mini">{{$t('general_requestExpense')}}</el-button>
        <div><p>{{$t('general_or')}}</p></div>
        <el-button @click="openProjectExpense('projectTaskExpenses')" class="modal__btn btn" type="primary" plain size="mini">{{$t('general_addExpense')}}</el-button>
      </div>
    </sweet-modal>
    <!-- [ Modal Ask Before Exp end ] start-->

    <!-- [ Modal Ask Before Purchase start ] start-->
    <sweet-modal blocking width="400" ref="askBeforePurch">
      <div class="ask-before-purch">
        <h1>{{$t('general_action')}}</h1>
        <el-button @click="openProjectPurchaseRequest()" class="modal__btn btn" type="primary" plain size="mini">{{$t('general_purchaseRequest')}}</el-button>
        <div><p>{{$t('general_or')}}</p></div>
        <el-button @click="openProjectPurchase()" class="modal__btn btn" type="primary" plain size="mini">{{$t('general_purchaseOrder')}}</el-button>
      </div>
    </sweet-modal>
    <!-- [ Modal Ask Before Purchase end ] start-->




    <!-- document modal -->
    <!--<el-dialog-->
            <!--:title="(documentList.type)"-->
            <!--:visible.sync="dialogVisible"-->
            <!--width="40%"-->
            <!--:before-close="handleClose">-->
      <!--<span>You have documents that require action.</span>-->
      <!--<span slot="footer" class="dialog-footer">-->
        <!--&lt;!&ndash; <el-button @click="dialogVisible = false">Cancel</el-button> &ndash;&gt;-->
        <!--<el-button type="primary" @click="signDocument">Go</el-button>-->
      <!--</span>-->
    <!--</el-dialog>-->

    <!-- [ Modal Under Development ] end -->
    <sweet-modal blocking ref="underDevelopment" icon="warning">
        <div class="task-not-found-block">
            <h3>Current Service Under Development</h3>
        </div>
    </sweet-modal>

    <sweet-modal blocking width="400" ref="copyTask">
      <div>
        <el-select v-model="selectedProjectForCopy" placeholder="Select Projects" clearable filterable style="width: 100%; margin-bottom: 20px;">
          <el-option v-for="item in this.allProjectList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>

        <el-button :disabled="!selectedProjectForCopy" type="primary" size="default" @click="copy">Copy Task</el-button>
      </div>
    </sweet-modal>

    <later-document-modal ref="laterDocumentModal"/>

    <gant-chart-modal
        ref="gantChartModal"
        :projectPermission="projectPermission"
        :rowData="rowData"
        @refreshTree="setProjectRowDataInput"/>

    <scheduler-modal ref="schedulerModal"/>
  </div>
</template>

<script>
  import log from '@/log/log.js'
  import { mapGetters } from 'vuex'
  import jsPDF from 'jspdf'
  import html2canvas from "html2canvas"
  import requestProjectCashAdvanceModal from '@/components/Projects/requestProjectCashAdvanceModal.vue'
  import projectMeetings from '@/components/Projects/projectMeetings.vue'
  import projectTaskMeetings from '@/components/Projects/projectTaskMeetings.vue'
  // import VueDragResize from 'vue-drag-resize';
  // import Header from '@/components/Header.vue';
  // import Menu from '@/components/Menu.vue'
  import CreateProjectModalWizard from '@/components/Projects/CreateProjectModalWizard.vue';
  import CreateTaskModal from '@/components/Projects/CreateTaskModal.vue'
  import ReassignTasksModal from '@/components/Projects/ReassignTasksModal.vue'
  import ShareProjectTaskModal from '@/components/Projects/ShareProjectTaskModal.vue';
  import UnShareProjectTaskModal from '@/components/Projects/UnShareProjectTaskModal.vue';
  // import ShareProjectTaskModalSteps from '@/components/Projects/shareProjectTaskModalSteps.vue';
  import CreateProjectTaskProgressModal from '@/components/Projects/CreateProjectTaskProgressModal.vue';
  import CreateProjectTemplate from '@/components/Projects/CreateProjectTemplate.vue';
  import InfoTab from '@/components/Projects/InfoTab.vue'
  import projProgressTab from '@/components/Projects/projProgressTab.vue'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import { AgGridVue } from 'ag-grid-vue';
  import { AllModules } from "@ag-grid-enterprise/all-modules";
  import axios from 'axios';
  import moment from 'moment'
  import { VueEditor } from 'vue2-editor'
  // import projectsFilesTab from '@/components/Projects/projectsFilesTab.vue'
  import projectsFilesTabNew from '@/components/Projects/projectsFilesTabNew.vue'
  import _ from 'lodash';
  // import taskFilesTab from '@/components/Projects/taskFilesTab.vue'
  import taskFilesTabNew from '@/components/Projects/taskFilesTabNew.vue'
  import projectCommentsTab from '@/components/Projects/projectCommentsTab.vue'
  import taskCommentsTab from '@/components/Projects/taskCommentsTab.vue'
  import projectExpenseModal from '@/components/Projects/projectExpenseModal.vue'
  import projectExpenseRequestModal from '@/components/Projects/projectExpenseRequestModal.vue'
  import projectCashAdvanceModal from '@/components/Projects/projectCashAdvanceModal'
  import projectSearchComponent from '@/components/Projects/projectSearchComponent.vue'
  import purchaseRequest from '@/components/Projects/accountTHINK/purchase/purchaseProjectTaskRequestModal.vue'
  import purchaseOrder from '@/components/Projects/accountTHINK/purchase/purchaseProjectTaskOrderModal.vue'

  // Messages
  import MessagesProject from '@/components/Projects/messages/MessagesProject.vue'
  import MessagesTask from '@/components/Projects/messages/MessagesTask.vue'
  import projectHistory from '@/components/Projects/projectHistoryTab.vue'
  import projectTaskHistory from '@/components/Projects/projectTaskHistoryTab.vue'
  // import DocumentsTask from '@/components/Projects/DocumentsTask.vue'

  // accountTHINK
  // import accountTHINKTab from '@/components/Projects/accountTHINK/accountTHINKTab.vue'

  // aTHINKTab
  import aTHINKTab from '@/components/Projects/accountTHINK/aTHINKTab.vue'

  // CRM
  import CRM from '@/components/Projects/CRM/CRM.vue'

  // SCM
  import SCM from '@/components/Projects/SCM/SCM.vue'

  // Estimate
  // import estimateTab from '@/components/Projects/estimate/estimateTab.vue'

  import inviteUserModal from '@/components/users/inviteUserModal.vue'

  // NEW AG-GRID
  import gridMessageBox from '@/components/Projects/gridMessageBox/main.js';

  import customTooltip from "../components/ag-grid-components/components/customTooltip";
  import userDefault from '@/assets/img/user-default.jpg'
  import start from "@/assets/img/grid/start.svg"
  import inProgress from "@/assets/img/grid/progress_icn.svg"
  import stop from "@/assets/img/grid/stop.svg"
  import pause from "@/assets/img/grid/pause.svg"
  import done from "@/assets/img/grid/marked.svg"
  import share from "@/assets/img/grid/shared.svg"
  import sharedWidth from "@/assets/img/grid/share_with.svg"
  import empty from "@/assets/img/grid/empty.svg"
  import timer from "@/assets/img/grid/timer.svg"
  import masterTaskIcon from "@/assets/img/grid/folder_icn.svg"
  import InfoProjectTaskTab from "../components/Projects/infoTaskTab";
  import LaterDocumentModal from "../components/documents/laterDocumentModal";
  import AddUsersToTasksModal from "../components/Projects/AddUsersToTasksModal";
  import GantChartModal from "../components/Projects/gantChart/GantChartModal";
  import SchedulerModal from "../components/Projects/calendar/SchedulerModal";
  import RemoveBUFromProjectModal from "../components/Projects/RemoveBUFromProject";

  var potentialParent = null;

  function createNewRowData() {
    var newData = {
      id: 999,
      name: "&&&&&&",
      filePath: ["0", "546", "999"],
      allowSharing: 1,
      daysTotal: 29,
      projectId:3,
      orderIndex:2,
      daysRemaning: 25,
      progress: 0,
      type: 'task',
      sharedCount:1,
      timerCount: 0,
      taskStatus: 1,
      myType: 'folder'
    };
    // newCount++;
    return newData;
  }

  function printResult(res) {
    return new Promise((resolve, reject) =>{
      console.log("---------------------------------------", res);
      if (res.add) {
        res.add.forEach(function(rowNode) {
          resolve('add');
          console.log("Added Row Node", rowNode);
        });
      }
      if (res.remove) {
        res.remove.forEach(function(rowNode) {
          console.log("Removed Row Node", rowNode);
        });
      }
      if (res.update) {
        res.update.forEach(function(rowNode) {
          resolve('update')
          console.log("Updated Row Node", rowNode);
        });
      }
    })
  }

  function moveToPath(newParentPath, node, allUpdatedNodes) {
    var oldPath = node.data.filePath;
    var fileName = oldPath[oldPath.length - 1];
    var newChildPath = newParentPath.slice();
    newChildPath.push(fileName);
    node.data.filePath = newChildPath;
    allUpdatedNodes.push(node.data);
    if (node.childrenAfterGroup) {
      node.childrenAfterGroup.forEach(function(childNode) {
        moveToPath(newChildPath, childNode, allUpdatedNodes);
      });
    }
  }

  function isSelectionParentOfTarget(selectedNode, targetNode) {
    var children = selectedNode.childrenAfterGroup;
    for (var i = 0; i < children.length; i++) {
      if (targetNode && children[i].key === targetNode.key) return true;
      isSelectionParentOfTarget(children[i], targetNode);
    }
    return false;
  }

  function arePathsEqual(path1, path2) {
    if (path1.length !== path2.length) {
      return false;
    }
    var equal = true;
    path1.forEach(function(item, index) {
      if (path2[index] !== item) {
        equal = false;
      }
    });
    return equal;
  }

  function setPotentialParentForNode(api, overNode) {
    var newPotentialParent;
    if (overNode) {
      newPotentialParent = overNode.data.myType === "folder" ? overNode : overNode.parent;
    } else {
      newPotentialParent = null;
    }
    var alreadySelected = potentialParent === newPotentialParent;
    if (alreadySelected) {
      return;
    }
    var rowsToRefresh = [];
    if (potentialParent) {
      rowsToRefresh.push(potentialParent);
    }
    if (newPotentialParent) {
      rowsToRefresh.push(newPotentialParent);
    }
    potentialParent = newPotentialParent;
    refreshRows(api, rowsToRefresh);
  }

  function refreshRows(api, rowsToRefresh) {
    const params = {
      rowNodes: rowsToRefresh,
      force: true
    };
    api.refreshCells(params);
  }

  function getFileCellRenderer() {
    function FileCellRenderer() {}
    FileCellRenderer.prototype.init = function(params) {
      var tempDiv = document.createElement("div");
      var value = params.value;
      var icon = getFileIcon(params.value);
      // tempDiv.innerHTML = icon ? '<i class="' + icon + '"/>' + '<span class="filename">' + value + "</span>" : value;
      tempDiv.innerHTML = icon ? '<span class="filename">' + value + "</span>" : value;
      this.eGui = tempDiv.firstChild;
    };
    FileCellRenderer.prototype.getGui = function() {
      return this.eGui;
    };
    return FileCellRenderer;
  }

  function getFileIcon(filename) {
    return "fa fa-file-audio-o";
    /*  return filename.endsWith(".mp3") || filename.endsWith(".wav")
        ? "fa fa-file-audio-o"
        : filename.endsWith(".xls")
        ? "fa fa-file-excel-o"
        : filename.endsWith(".txt")
        ? "fa fa fa-file-o"
        : filename.endsWith(".pdf")
        ? "fa fa-file-pdf-o"
        : "fa fa-folder";*/
  }

  function getDateFromTimestamp(timestamp) {
    if (_.isString(timestamp) && timestamp.match(/^[0-9]+$/)) {
      return new Date(parseInt(timestamp));
    }
    if (_.isNumber(timestamp)) {
      return new Date(timestamp);
    }
  }

  function daysBetween(dateFrom, dateTo) {
    dateFrom = getDateFromTimestamp(dateFrom);
    dateTo = getDateFromTimestamp(dateTo);
    var dayTime = 1000 * 60 * 60 * 24;
    return Math.round((dateTo.getTime() - dateFrom.getTime()) / dayTime);
  }

  function calcProjectProgress(projectTaskList) {
    if (projectTaskList.length == 0) {
      return 100;
    }
    var count = 0;
    var sum = projectTaskList.reduce(function (sumOfElements, item) {
      if (item.parentProjectTaskId == 0) {
        count++;
        return sumOfElements + parseInt(item.progress);
      }
      return sumOfElements;
    }, 0);
    return Math.round(sum / count);
  }

  function countDaysTotal(startDate, deadlineDate){
    var startTask = '';
    var endTask = '';
    // if (startDate.toString().length < 8) {
    //   startTask = '0' + startDate.toString()
    // } else {
    //   startTask = startDate.toString()
    // }
    // if (deadlineDate.toString().length < 8) {
    //   endTask = '0' + deadlineDate.toString()
    // } else {
    //   endTask = deadlineDate.toString()
    // }
    startTask = moment(startDate).format("DDMMYYYY");
    endTask = moment(deadlineDate).format("DDMMYYYY");
    const daysTotal = Math.floor(moment.duration(endTask.diff(startTask)).asDays());
    return daysTotal
  }

  function countTaskDaysRemaning(deadlineDate, status, type, endedDate){
    var todaysdate = moment();
    var endTask = '';

    // if (deadlineDate.toString().length < 8) {
    //   endTask = '0' + deadlineDate.toString()
    // } else {
    //   endTask = deadlineDate.toString()
    // }
    endTask = moment(deadlineDate).format("DDMMYYYY");

    var tillTaskEnd = moment.duration(endTask.diff(todaysdate)).asDays();

    if(status === 4 && type === 0){
      var dateString = moment.unix(endedDate).format("DDMMYYYY");
      dateString = moment(dateString, 'DDMMYYYY');
      tillTaskEnd = moment.duration(dateString.diff(endTask)).asDays();
      if(tillTaskEnd > 0){
        tillTaskEnd = '+' + tillTaskEnd
      }
      tillTaskEnd = '(' + tillTaskEnd + ')'
    }else{
      tillTaskEnd = Math.ceil(tillTaskEnd)
    }

    return tillTaskEnd
  }

  function toId(value) {
    if (_.isNumber(value)) {
      return parseInt(value);
    }
    if (_.isNull(value) || _.isUndefined(value)) {
      return 0;
    }
    return 0;
  }
  // function buildTree2(projectTaskList) {
  //   var resultProjectTaskTree = [];
  //   var todaysdate = moment();
  //   for (var index = 0; index < projectTaskList.length; index++) {
  //     var startTask = '';
  //     var endTask = '';
  //     if (projectTaskList[index].startDate.toString().length < 8) {
  //       startTask = '0' + projectTaskList[index].startDate.toString()
  //     } else {
  //       startTask = projectTaskList[index].startDate.toString()
  //     }
  //     if (projectTaskList[index].deadlineDate.toString().length < 8) {
  //       endTask = '0' + projectTaskList[index].deadlineDate.toString()
  //     } else {
  //       endTask = projectTaskList[index].deadlineDate.toString()
  //     }
  //
  //     startTask = moment(startTask, 'DDMMYYYY');
  //     endTask = moment(endTask, 'DDMMYYYY');
  //     let myDaysTotal = moment.duration(endTask.diff(startTask)).asDays();
  //
  //     var tillTaskEnd = moment.duration(endTask.diff(todaysdate)).asDays();
  //
  //     if(projectTaskList[index].status === 4){
  //       // console.log('deadlineDate', projectTaskList[index].deadlineDate)
  //       // console.log('MYdeadlineDate', endTask)
  //       // console.log('WHEN WAS HOLDED', projectTaskList[index].endedDate)
  //       var dateString = moment.unix(projectTaskList[index].endedDate).format("DDMMYYYY");
  //       // console.log('MY WHEN WAS HOLDED', Number(dateString))
  //
  //       dateString = moment(dateString, 'DDMMYYYY');
  //       tillTaskEnd = moment.duration(endTask.diff(dateString)).asDays();
  //       tillTaskEnd = '(' + tillTaskEnd + ')'
  //       // console.log('DIFFERENCESSSSSSSS!!!!!!!!!!!!!!!!!!!!!!!!!:::::', tillTaskEnd)
  //     }else{
  //       tillTaskEnd = Math.ceil(tillTaskEnd)
  //     }
  //
  //     let leader = {};
  //
  //     leader = projectTaskList[index].leader === null ? null : projectTaskList[index].leader.user;
  //
  //     let row = {
  //       id: projectTaskList[index].id,
  //       name: projectTaskList[index].name,
  //       allowSharing: projectTaskList[index].allowSharing,
  //       filePath: [index],
  //       projectId:projectTaskList[index].projectId,
  //       // daysTotal: Math.floor(myDaysTotal),
  //       access: true,
  //       daysTotal: countDaysTotal(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
  //       orderIndex:projectTaskList[index].orderIndex,
  //       // daysTotal: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
  //       // daysRemaning: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
  //       leader:leader,
  //       daysRemaning: tillTaskEnd,
  //       progress: Math.floor(projectTaskList[index].progress),
  //       type: 'task',
  //       timerCount: projectTaskList[index].timerCount,
  //       taskStatus: projectTaskList[index].status,
  //       myType: 'folder'
  //     };
  //     resultProjectTaskTree.push(row);
  //   }
  //
  //   for (let i = 0; i < resultProjectTaskTree.length; i++){
  //     resultProjectTaskTree[i].myIndex = (1 + i).toString()
  //   }
  //
  //   return resultProjectTaskTree;
  // }

  export default {
    name: 'projects',
    components: {
      RemoveBUFromProjectModal,
      GantChartModal,
      SchedulerModal,
      AddUsersToTasksModal,
      LaterDocumentModal,
      InfoProjectTaskTab,
      projectMeetings,
      projectTaskMeetings,
      // VueDragResize,
      inviteUserModal,
      // Header,
      AgGridVue,
      SweetModal,

      CreateProjectModalWizard,
      CreateProjectTaskProgressModal,
      requestProjectCashAdvanceModal,
      ShareProjectTaskModal,
      ReassignTasksModal,
      UnShareProjectTaskModal,
      // ShareProjectTaskModalSteps,
      projectExpenseModal,
      projectExpenseRequestModal,
      projectCashAdvanceModal,
      purchaseRequest,
      purchaseOrder,
      InfoTab,
      projProgressTab,
      CreateProjectTemplate,
      // Menu,
      VueEditor,
      // projectsFilesTab,
      // taskFilesTab,
      taskFilesTabNew,
      projectsFilesTabNew,
      projectCommentsTab,
      taskCommentsTab,
      CreateTaskModal,
      MessagesProject,
      MessagesTask,
      projectHistory,
      projectTaskHistory,
      // DocumentsTask,
      projectSearchComponent,
      // estimateTab,
      // accountTHINKTab,
      //Grid
      gridMessageBox,
      CRM,
      aTHINKTab,
      SCM
    },
    create() {

    },
    beforeCreate() {

    },
    computed: {
      ...mapGetters([
        'getStateId'
      ]),
      // myFirstCompanys() {
      //   return this.$store.state.myCompanys
      // }
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      user() {
        return this.$store.state.user
      },
      projectCompanyVendorList() {
          return this.projectInfo.projectCompanyVendorList.length ? this.projectInfo.projectCompanyVendorList : []
      },
      projectTaskPersonVendorList() {
          return this.taskInfo.projectTaskCompanyVendorPersonList.length ? this.taskInfo.projectTaskCompanyVendorPersonList : []
      },
      projectCompanyClientList() {
          return this.projectInfo.projectCompanyClientList.length ? this.projectInfo.projectCompanyClientList : []
      },
      projectTaskCompanyClientPersonList() {
          return this.taskInfo.projectTaskCompanyClientPersonList.length ? this.taskInfo.projectTaskCompanyClientPersonList : []
      }
    },
    beforeMount() {
      // this.$store.dispatch('setMyFirstCompanys')
      this.gridOptions = {
        suppressCellSelection: true,
        isRowSelectable: function(rowNode) {
          // console.log('rowNode.data.access', rowNode.data.access, rowNode.data.name);
          return rowNode.data.access
        },
        overlayNoRowsTemplate: this.$i18n.t('general_noRowsToShow'),
        // enableBrowserTooltips: true
      };
      this.columnDefs = [
        {
          headerName: "",
          field: "myIndex",
          tooltipField: "myIndex",
          tooltipComponentParams: { fieldName: "Index" },
          // cellRenderer: "txtRenderer",
          cellRenderer: function(params) {
              // params.node.data.myIndex = params.node.rowIndex;
            if (params.data.id !== 0) {
              return `<span class="txtRender">${params.node.data.myIndex}</span>`
            }
          },
          width:20,
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          cellStyle: function(params) {
            return {'text-align': 'center; display: flex; justify-content:start; margin-left:10px;'}
          }
        },
        {
          headerName: "",
          field: "leader",
          // cellRenderer: "avatarRenderer",
          cellRenderer: function(params) {
            if(params.node.data.leader !== null ){
              if(params.node.data.leader.avatarUrl) return `<img class="imageRender" src=${params.node.data.leader.avatarUrl} />`;
              else return `<img class="imageRender" src=${userDefault} />`
            }else {
              return null
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "leader.fullName",
          tooltipComponentParams: { fieldName: "Assigner" },
          width: 12
        },
        {
          headerName: "",
          field: "daysTotal",
          // cellRenderer: "dayRenderer",
          tooltipField: "daysTotal",
          tooltipComponentParams: { fieldName: "Days Total" },
          cellRenderer: function(params) {
            switch(params.node.data.type) {
              case 'project':
                return `<span class="dayRender">${params.node.data.daysTotal}</span>`
              case 'task' :
                return `<span class="dayRender">${params.node.data.daysTotal}</span>`
              case 'masterTask' :
                return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
            }
          },
          cellClassRules: {
            "hover-over": params => {
              return params.node === potentialParent;
            }
          },
          width:12,
          // cellStyle: function(params) {
          //   if (params.data.taskStatus === 4){
          //     return {'color': 'red', 'text-align': 'center;'}
          //   }else{
          //     return {'text-align': 'center;'}
          //   }
          // },
        },
        {
          headerName: "",
          field: "daysRemaning",
          // cellRenderer: "dayRenderer",
          tooltipField: "daysRemaning",
          tooltipComponentParams: function (params) {
            let numb = params.value.toString().match(/\d/g);
            numb = numb.join("");
            console.log('!!! PARAMS !!!', numb)
            console.log('!!! PARAMS !!!', params.value[0])
            if (params.value[0] === '(' && params.value[1] === '+') {
              return { fieldName: `Completed ${numb} Days Late` }
            }

            if (params.value[0] === '(' && params.value[1] === '-') {
              return { fieldName: `Completed ${numb} Days Early` }
            }

            if (params.value === '(0)') {
              return { fieldName: `Completed on Time` }
            }

            if (params.value === '0') {
              return { fieldName: `Due Today` }
            }

            if (params.value[0] === '+') {
              return { fieldName: `Overdue by ${numb} Days` }
            }

            if (params.value.toString() === '1'){
              return { fieldName: `Due in ${numb} Day` }
            }

            else {
              return { fieldName: `Due in ${numb} Days`}
            }
          },
          // headerClass: 'header-center',
          cellRenderer: function(params) {
            function isEqualTwo(elem){
              return elem === '+'
            }
            const isTooLong = Array.from(params.node.data.daysRemaning.toString()).some(isEqualTwo);
            switch(params.node.data.type) {
              case 'project':
                if(isTooLong){
                  return `<div class="dayRemaningRender">${params.node.data.daysRemaning}</div>`
                }else{
                  return `<div class="dayRemaningRender">${params.node.data.daysRemaning}</div>`
                }
              case 'task' :
                if(isTooLong){
                  return `<div class="dayRemaningRender">${params.node.data.daysRemaning}</div>`
                }else{
                  return `<div class="dayRemaningRender">${params.node.data.daysRemaning}</div>`
                }
              case 'masterTask' :
                return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          width:12,
          // cellStyle: function(params) {
          //   if (params.data.taskStatus === 4){
          //     return {'color': 'red', 'text-align': 'center;'}
          //   }else{
          //     return {'text-align': 'center;'}
          //   }
          // },
        },
        {
          headerName: "",
          field: "taskStatus",
          // cellRenderer: "taskStatusRenderer",
          tooltipField: "taskStatus",
          cellRenderer: function(params) {
            let childTasks = [];
            let doneCount = [];
            // different conditions for task and masterTask
            switch(params.node.data.type){
              case 'task' :
                switch(params.node.data.taskStatus) {
                  // created
                  case 1:
                      return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
                  //started
                  case 2:
                    // if in progress
                    if(params.node.data.progress) {
                      return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
                    }else{
                      return `<img v-if="taskStatus" class="imageRender" src=${start} />`

                    }
                  // holded
                  case 3:
                    return `<img v-if="taskStatus" class="imageRender" src=${pause} />`
                  // done
                  case 4:
                    return `<img v-if="taskStatus" class="imageRender" src=${done} />`
                  case 5:
                    return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
                }
              break;
              case 'masterTask':
                params.api.forEachNode(function(rowNode, index) {
                  let childTask = '';
                  let doneChildTask = '';
                  if (rowNode.data.type === 'task') {
                    childTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if (rowNode.data.type === 'task' && rowNode.data.taskStatus === 4) {
                    doneChildTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                  }
                  if(childTask) childTasks.push(childTask);
                  if(doneChildTask) doneCount.push(doneChildTask)
                });
                // return `<img v-if="taskStatus" class="imageRender" src=${masterTaskIcon} />`
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              case 'project':
                params.api.forEachNode(function(rowNode, index) {
                  if (rowNode.data.type === 'task'){
                    childTasks.push(rowNode.data)
                  }
                  if (rowNode.data.type === 'task' && rowNode.data.taskStatus === 4){
                    doneCount.push(rowNode.data)
                  }
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
                // return `<img v-if="taskStatus" class="imageRender" src=${inProgress} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipComponentParams: { fieldName: "Task Status" },
          width: 12
        },
        {
          headerName: "",
          field: "progress",
          // cellRenderer: "progressRenderer",
          cellRenderer: function(params) {
            let childTasks = [];
            let doneCount = [];
            switch(params.node.data.type) {
              case 'project' :
                // return `<div class="progress--circle progress--${params.node.data.progress}">
                //         <div class="progress__number">${params.node.data.progress}%</div>
                //     </div>`
                params.api.forEachNode(function(rowNode, index) {
                  if (rowNode.data.type === 'task'){
                    childTasks.push(rowNode.data)
                  }
                  if (rowNode.data.type === 'task' && rowNode.data.progress === 100){
                    doneCount.push(rowNode.data)
                  }
                });
                return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
              case 'task' :
                return `<div class="progress--circle progress--${params.node.data.progress}">
                        <div class="progress__number">${params.node.data.progress}%</div>
                    </div>`
              case 'masterTask' :
                // return `<div class="progress--circle progress--${params.node.data.progress}">
                //         <div class="progress__number">${params.node.data.progress}%</div>
                //     </div>`
                      params.api.forEachNode(function(rowNode, index) {
                        let childTask = '';
                        let doneChildTask = '';
                        if (rowNode.data.type === 'task') {
                          childTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                        }
                        if (rowNode.data.type === 'task' && rowNode.data.progress === 100) {
                          doneChildTask = rowNode.data.filePath.find(val => val === params.node.data.id.toString())
                        }
                        if(childTask) childTasks.push(childTask);
                        if(doneChildTask) doneCount.push(doneChildTask)
                      });
              return `<div class="progress--circle progress--0">
                        <div class="progress__number-mt">${doneCount.length}/${childTasks.length}</div>
                     </div>`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "progress",
          tooltipComponentParams: { fieldName: "Progress" },
          width: 12
        },
        // {
        //   field: "progress",
        //   resizable: true,
        //   cellClassRules: {
        //     "hover-over": function(params) {
        //       return params.node === potentialParent;
        //     }
        //   },
        //   cellStyle: function(params) {
        //     if (params.value === null) {
        //       return
        //     } else if (params.value < 25) {
        //       return {'font-weight': 'bold', 'color':'#409EFF', 'background-image': `linear-gradient(to right, rgba(64,158,255,.3) 0%, rgba(64,158,255,.4) ${params.value}%, transparent ${params.value}%, transparent 100%)`};
        //     } else if (params.value < 75) {
        //       return {'font-weight': 'bold', 'color':'#409EFF', 'background-image': `linear-gradient(to right, rgba(64,158,255,.3) 0%, rgba(64,158,255,.4) ${params.value}%, transparent ${params.value}%, transparent 100%)`};
        //     } else {
        //       return {'font-weight': 'bold', 'color':'#67C23A', 'background-image': `linear-gradient(to right, rgba(103,194,58,.3) 0%, rgba(103,194,58,.4) ${params.value}%, transparent ${params.value}%, transparent 100%)`};
        //     }
        //   },
        //   valueFormatter: function(params) {
        //     var rowData = params.node.data;
        //     if (rowData.type == 'project') {
        //       return rowData.progress + "%";
        //     }
        //     if (rowData.type == 'masterTask') {
        //       return rowData.progress + "%";
        //     }
        //     if (rowData.taskStatus == 1) {
        //       return 'Task not started';
        //     }
        //     if (rowData.taskStatus == 2) {
        //       return rowData.progress + "%";
        //     }
        //     if (rowData.taskStatus == 3) {
        //       return 'Task on hold';
        //     }
        //     if (rowData.taskStatus == 4) {
        //       return 'Task done';
        //     }
        //   },
        // },
        // {
        //   headerName: "",
        //   field: "type",
        //   cellRenderer: "typeRenderer",
        //   tooltipField: "type",
        //   tooltipComponentParams: { fieldName: "Task Type" },
        //   width: 12
        // },
        {
          headerName: "",
          field: "sharedCount",
          // cellRenderer: "sharedCountRenderer",
          tooltipField: "sharedCount",
          cellRenderer: function(params) {
            if (params.node.data.allowSharing && params.node.data.sharedCount > 0){
              return `<div class="sharedRender">
                        <div class="el-badge item" id="badge">
                            <sup class="el-badge__content" >
                            ${params.node.data.sharedCount}
                            </sup>
                        </div>
                        <img class="timerRender" src=${sharedWidth} />
                      </div>`            }else if(params.node.data.allowSharing){
              return `<img class="imageRender" src=${share} />`
            }else {
              return `<img class="imageRender" src=${empty} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipComponentParams: { fieldName: "Shared" },
          width: 12
        },
        {
          headerName: "",
          field: "timerCount",
          // cellRenderer: "timerCountRenderer",
          cellRenderer: function(params) {
            switch(params.node.data.type) {
              case 'project':
                return `<img class="imageRender" src=${empty} />`
              case 'task' :
                if(params.node.data.timerCount){
                  return `<div class="timerBlock">
                        <div class="el-badge item" id="badge">
                            <sup class="el-badge__content" >
                            ${params.node.data.timerCount}
                            </sup>
                        </div>
                        <img class="timerRender" src=${timer} />
                      </div>`
                }else {
                  return `<img class="imageRender" src=${empty} />`
                }
              case 'masterTask' :
                return `<img v-if="taskStatus" class="imageRender" src=${empty} />`
            }
          },
          cellClassRules: {
            "hover-over": function(params) {
              return params.node === potentialParent;
            }
          },
          tooltipField: "timerCount",
          tooltipComponentParams: { fieldName: "Timer" },
          width: 15
        },
        // {
        //   headerName: "",
        //   field: "allowSharing",
        //   width: 50,
        //   // tooltipField: 'allowSharing',
        //   resizable: true,
        //   cellRenderer: function(params) {
        //     if (params.node.data.allowSharing == 1){
        //       return '<span><i class="el-icon-share"></i></span>';
        //     }
        //   },
        //   cellClassRules: {
        //     "hover-over": function(params) {
        //       return params.node === potentialParent;
        //     }
        //   },
        //   cellStyle: function(params) {
        //     if(params.data.sharedCount){
        //       return {'color': '#67C23A', 'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '17px'}
        //     }else{
        //       return {'color': '#409EFF', 'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '17px'}
        //     }
        //   }
        // },
        // {
        //   headerName: "",
        //   field: "timerCount",
        //   width: 50,
        //   // tooltipField: 'allowSharing',
        //   resizable: true,
        //   cellRenderer: function(params) {
        //     if (params.node.data.timerCount == 1){
        //       return '<span><i class="fas fa-history"></i></span>';
        //     }
        //   },
        //   cellClassRules: {
        //     "hover-over": function(params) {
        //       return params.node === potentialParent;
        //     }
        //   },
        //   cellStyle: function(params) {
        //     return {'color': '#67C23A', 'display': 'flex', 'align-items': 'center', 'justify-content': 'center', 'font-size': '17px'}
        //   }
        // }
      ];
      this.rowSelection = "multiple";
      this.defaultColDef = {
        tooltipComponent: "customTooltip",
        suppressMovable: true,
        suppressMenu: true,
        resizable: true,
        editable: function (node){
          if(node.data.access && node.colDef.cellClass === 'name-cell' && node.data.type !== 'project'){
            return true
          }
        },
        onCellValueChanged : function (node){
          const that = this;
          if (!node.newValue) {
            console.log('node', node)
            node.api.setFocusedCell(node.data.myIndex, node.colDef, false);
            node.api.startEditingCell({
              rowIndex: node.node.rowIndex,
              colKey: node.colDef,
              charPress: node.oldValue
            });
            return;
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          let uri = window.location.search.substring(1);
          let params = new URLSearchParams(uri);
          const companyId = params.get("companyId");
          axios.get(`/api/v1/projectTasks/updateName?companyId=${companyId}&projectId=${node.data.projectId}&projectTaskId=${node.data.id}&newName=${node.newValue}`)
                  .then(response => {
                  }).catch(err => {
            console.log(err)
          })
        },
        // field: 'name',
        // sortable: true,
        // filter: false,
        // width:164
      };
      this.components = { fileCellRenderer: getFileCellRenderer() };
      this.groupDefaultExpanded = -1;
      this.getDataPath = data => {
        return data.filePath;
      };
      this.getRowNodeId = data => {
        return data.id;
      };
      this.getRowHeight = params => {
        return 40;
      };
      this.autoGroupColumnDef = {
        filter: 'agTextColumnFilter',
        rowDrag: function(params) {
          if(params.data.id === 0){
            return false
          }else if(!params.data.access){
            return false
          }else{
            return true
          }
        },
        headerName: this.$i18n.t('project_task'),
        field: 'name',
        width: 110,
        cellRendererParams: {
          suppressCount: true,
          // innerRenderer: "fileCellRenderer"
          // innerRenderer: "txtRenderer"
          innerRenderer: function(params) {
            return `<span class="txtRender">${params.node.data.name}</span>`
          }
        },
        cellClass: 'name-cell',
        tooltipField: "name",
        tooltipComponentParams: { fieldName: "Name" },
        cellClassRules: {
          "hover-over": params => {
            return params.node === potentialParent;
          }
        }
      };
      this.frameworkComponents = {
        customTooltip: customTooltip
      };
      this.rowClassRules = {
        'no-access': '!data.access',
      };
    },
    mounted() {
      // const myElement = document.getElementsByClassName('ag-floating-filter-input')[0]
      // myElement.addEventListener('click', this.handleClickOnInput(myElement))
      // document.document.getElementsByClassName('ag-floating-filter-input')[0].addEventListener("click", this.handleClickOnInput(alert('hello')))
      // console.log("this.$refs.wrap__tree.clientWidth", myElement)

      // this.resizeWidth = this.$refs.wrap__tree.clientWidth;
      // this.resizeHeight = this.$refs.wrap__tree.clientHeight;

      // alert(this.wrapTree.innerWidth)
      // alert(this.wrapTree.innerHeight)
      // setTimeout(() => {
      //   if(localStorage.getItem('companyId')){
      //     this.companyIdFunc(localStorage.getItem('companyId'))
      //   }
      //   }, 100)
      // setTimeout(() => {
      // this.$store.dispatch('getCompanyLayout')
      if(localStorage.getItem('isWorkDay')){
        this.isWorkDay = true;
        this.handleCommand('changeWorkDay');
        this.activeInfoTab = 'first';
        //TODO will be error if first time enter
        this.seletedProject = this.companyLayout.lastProjectId;
        this.getProjects(this.$route.query.companyId);
        localStorage.removeItem('isWorkDay')
      }else if(this.$route.query.companyId){
        // let projectId = localStorage.getItem('selectedProjectId') || this.$route.query.projectId
        // this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${projectId}`).then(data => {
        //   console.log('router data', data)
        // }).catch(err => {
        //   console.log('navigation error', err)
        // })
        // this.getProjects("first");
        this.loadCompanyData(this.$route.query.companyId)
      }
      this.gridApi = this.gridOptions.api;
      console.log("GRID API", this.gridApi);
      this.gridColumnApi = this.gridOptions.columnApi;
      this.gridApi.sizeColumnsToFit();
      this.gridColumnApi.moveColumn("myIndex", 0);

      // DYNAMIC CHANGING DATA START
      this.$options.sockets.companyInternalEvent = (data) => {
        if(!this.isWorkDay && this.valueProject === data.projectId && this.companyLayout.companyUserId !== data.companyUserId && !this.ownTasks){
          switch (data.action){
            case 'updateProjectTask'://+
            case 'updateNameProjectTask'://+
            case 'startProjectTask'://+
            case 'doneProjectTask'://+
            case 'holdProjectTask'://+
            case 'acceptProjectTaskShare'://+
            case 'unshareProjectTask'://+
            case 'createProjectTaskTimer'://+
            case 'stopProjectTaskTimer'://+
              this.dynamicChangeRow(data.projectTask, data.action);
              break;
            case 'createProjectTask'://+
            case 'createParentProjectTask'://+
            case 'insertProjectTask': //+
            case 'createProjectTaskProgress'://+
            case 'changeProjectTaskParent'://+
            case 'restartProjectTask'://+
            case 'deleteProjectTaskProgress'://+
            case 'updateProjectTaskList'://-
              new Promise (async (resolve, reject)=> {
                try {
                  const treeList = await this.getTreeList(this.$route.query.companyId, data.projectId);

                  this.rowData = await this.buildNewTree(treeList);
                  resolve('ok')
                } catch (err){
                  console.log(err)
                }
              }).then(resultOfUpdate => {
                this.dynamicChangeData(data.projectTaskId, data.action);
              });
              break;
            case 'deleteProjectTask'://+
              this.dynamicDeleteFromData(data.projectTaskId, data.action).then(async done => {
                try {
                  const treeList = await this.getTreeList(this.$route.query.companyId, data.projectId);

                  this.rowData = await this.buildNewTree(treeList);
                }catch(err){
                  console.log(err)
                }
              });
              break;
            case 'updateProject'://+
              try {
                new Promise (async (resolve, reject) => {
                  const treeList = await this.getTreeList(this.$route.query.companyId, data.projectId);

                  this.rowData = await this.buildNewTree(treeList);

                  resolve('ok')
                }).then(data2 => {
                  this.onFlashRow(0).then(id => {
                    this.selectCreatedTask(id || this.rowData[0].id)
                  })
                });
              } catch (err) {
                console.log(err)
              }
              break;
            case 'deleteProject'://+
              this.rowData = [];
              this.valueProject = '';
              this.valueRegion = '';
              this.valueStages = '';
              this.selectedRow = {};
              localStorage.removeItem('selectedProjectId');
              this.seletedProject = '';
              this.$router.push(`/projects?companyId=${this.$route.query.companyId}`);
              this.getProjects(this.$route.query.companyId);
              this.$alert('Project was deleted!', 'Warning', {
                confirmButtonText: 'OK',
                type: 'info'
              });
              break
          }
        }
      }
      // DYNAMIC CHANGING DATA END
    },
    data() {
      return {
        selectedProjectForCopy: null,
        allProjectList: [],

        // client
        clientListId: null,
        clientList: [],
        // document
        dialogVisible: false,
        documentList: {
          companyId: null,
          projectId: null,
          projectTaskId: null,
          type: '',
          taskType: '',
          level: null
        },

        importProjectModal: {
          file: '',
        },
        // resizeHeight: 100,
        // resizeWidth: 100,
        width: 0,
        height: 0,
        isWorkDay:false,
        businessUnitSelected:true,
        // companyId: '',
        sharedProjecttaskNoteId: false,
        // companyNameSelect: '',
        projectInfo: {
          name: null,
          companyStage:{
            name: null,
          },
          projectStatus: {
            name: null,
          },
          priority: {
            name: null
          },
          description: null,
          progress: 0,
          projectCompanyVendorList: [],
          projectCompanyClientList: []
        },
        taskInfo: {
          name: null,
          priority: {
            name: null
          },
          companyStage:{
            name: null
          },
          progress: 0,
          projectTaskCompanyVendorPersonList: [],
          projectTaskCompanyClientPersonList: []
        },

        potentialParent: false,
        event: '',
        projectState: 'add',
        stateTask: 'add',
        // open: false,
        firstEntering: false,

        progressTab: null,
        progressTabInfo: null,
        activeInfoTab: 'first',
        activeTaskInfoTab: 'first',
        activeEstimateTab: '',
        activeAccountTHINKTab: '',
        activeCRMTab: '',
        activeSCMTab: '',
        project: [],
        stages: [],
        region: [],
        valueProject: '',
        valueStages: '',
        valueStagesId: '',
        valueRegion: '',
        valueRegionId: '',
        activeProjectId: '',
        projectTaskId: '0',
        // Tree
        gridOptions: null,
        gridApi: null,
        columnApi: null,
        columnDefs: null,
        rowData: [],
        defaultColDef: null,
        frameworkComponents: null,
        getRowHeight: null,
        components: null,
        groupDefaultExpanded: null,
        getDataPath: null,
        getRowNodeId: null,
        autoGroupColumnDef: null,
        rowSelection: null,
        expand: true,
        ownTasks: false,
        rowClassRules: null,
        // Tabs
        progressData: false,
        seletedProject: null,
        activeTab: 'first',
        isProject: true,
        // isOnProgress: false,
        newCreatedProjectTask: 'first',

        //selectedRow
        disabledBtn : true,
        selectedRows:null,
        selectedRow: {},
        selectedProjectForInfo:false,
        selectedTaskForInfo:false,

        // editTaskList:{
        //   changeAssignedTo: false,
        //   changeEditedTaskTeam: false,
        //   editAssignedToId: null,
        //   editAssignedTo: [],
        //   editedTaskTeam: [],
        //   editedTaskTeamId: []
        // },

        // Periods
        statusPeriods: false,
        statusPeriodsTimer: false,
        bookmarkList: {},
        bookmarkListProject:{},
        projectPermission:{},
        modules: AllModules,
        // searchInputGrid: null,
        activeProjectRowData: null,
      }
    },
    methods: {
      openPermissionsTab() {
        this.activeTab = 'first';
        this.activeInfoTab = 'permissions';
        this.$store.dispatch('getProjectPermissionsList', this.$route.query.projectId);
        this.$refs.infoTab.loadPermissionData();
      },
      click(){
        console.log(this)
      },
      async getTreeScreen(){
        try {
          let loader = this.$loading.show();
          let eGridDiv = await document.querySelector('#myGrid');
          eGridDiv.style.height = '';
          await this.gridApi.setDomLayout('print');

          const canvas = await html2canvas(document.querySelector("#myGrid"));
          const fileUrl = await new Promise((resolve) => {
          const that = this;
            canvas.toBlob(function(blob) {
              try {
                const formData = new FormData();
                formData.append('file', blob, 'filename.png');
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                    .post(`/api/v1/files/create?companyId=${that.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
                    .then(response => {
                       resolve(response.data.fileUrl);
                    }).catch(error => {
                       loader.hide();
                       console.log('An error occurred:', error);
                    });
              } catch (err){
                loader.hide();
                console.log(err)
              }
            });
          });
          eGridDiv.style.height = '100%';
          eGridDiv.style.width = '100%';
          await this.gridApi.setDomLayout(null);
          loader.hide();
          await this.$refs['modal777'].submitFormWithFileUrl(fileUrl)
        }catch (err){
          console.log(err)
        }
      },
      getTreeList(companyId, projectId){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        return axios.post(`/api/v1/projectTasks/list?companyId=${companyId}&projectId=${projectId}`)
                .then(response => {
                  this.activeProjectRowData = response.data.newlist.find(val => val.type === 'project')
                  return response.data.newlist;
                }).catch(err => {
            console.log(err)
        })
      },
      clicker(){
        console.log('new row data', this.rowData);
        console.log(this.gridApi)
        const newData = {
          id: 999,
          name: "&&&&&&",
          filePath: ["0", "546", "999"],
          allowSharing: 1,
          daysTotal: 29,
          projectId:3,
          orderIndex:2,
          daysRemaning: 25,
          progress: 0,
          type: 'task',
          sharedCount:1,
          timerCount: 0,
          taskStatus: 1,
          myType: 'folder',
          myIndex: 6
        };
        this.rowData.push(newData)
      },
      underDevelopment() {
        this.$refs.underDevelopment.open()
      },
      expandAll(){
        this.expand = !this.expand;
        if(this.expand){
          this.gridApi.forEachNode((node) => {
              node.setExpanded(true);
          })
        }else {
          this.gridApi.forEachNode((node) => {
            if(node.data.filePath.length === 2) {
              node.setExpanded(false);
            }
          })
        }
      },
      cl(){
        this.$router.push({name: 'login'})
      },
      async loadCompanyData(companyId){
        try {
          //Load Region List
          this.getClientsList();
          this.getRegions();

          //Load Stage List
          this.getProjectStages();

          // Load Project List
          const projectList = await this.getProjects(companyId);

          //Check If Company Without Projects
          if(projectList.length === 0){
            this.valueProject = "";
            this.project = [];
          }else {
            this.project = projectList
          }

          //Check If Project Selected in route
          if(this.$route.query.projectId){
            const rowData = await this.setProjectRowData(Number(this.$route.query.projectId));
            this.activeInfoTab = 'first';
            this.activeTaskInfoTab = 'first';

            //Select Active Row
            if(rowData.length > 0){
              const selectedRow = await this.selectCreatedTask(Number(this.$route.query.taskId) || 0)
            }

            switch (this.$route.query.tabName){
              case 'projectInfoTab':
                this.activeTab = 'first';
                this.activeInfoTab = 'first';
                break;
              case 'projectTaskInfoTab':
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'first';
                break;
              case 'setShared' :
                this.isProject = false;
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'progress';
                break;
              case 'createProjectComment':
                this.activeTab = 'projectCommentTab';
                break;
              case 'createProjectTaskComment':
                this.activeTab = 'projectTaskCommentTab';
                break;
              case 'createProjectMessage':
                this.activeTab = 'seven';
                break;
              case 'createProjectTaskMessage':
                this.activeTab = 'eight';
                break;
              case 'createProjectFile':
                this.activeTab = 'third';
                break;
              case 'createProjectTaskFile':
                this.activeTab = 'four';
                break;
              case 'createProjectMeeting':
                this.activeTab = 'nine';
                break;
              case 'createProjectTaskMeeting':
                this.activeTab = 'ten';
                break;
              case 'createProjectHistory':
                this.activeTab = 'eleven';
                break;
              case 'createProjectTaskHistory':
                this.activeTab = 'twelve';
                break;
              case 'reviewProjectTaskDocument':
                this.isProject = false;
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'documents';
                break;
              case 'createProjectCrm':
                this.activeTab = 'crm';
                this.activeCRMTab = 'sellingProject';
                break;
              case 'createProjectScm':
                this.isProject = true;
                this.activeTab = 'scm';
                this.activeSCMTab = 'purchaseProject';
                break;
              case 'createProjectAccountTHINK':
                this.activeTab = 'aTHINK';
                this.activeAccountTHINKTab = 'budget';
                break;
              case 'customReminderProjectMeeting':
              case 'createProjectMeetings':
                this.isProject = true;
                this.activeTab = 'nine';
                break;
              case 'approveProjectTaskMeetings':
              case 'createProjectTaskMeetings':
                this.isProject = false;
                this.activeTab = 'ten';
            }
          }

        }catch(err){
          console.log('loadData', err)
        }
      },
      // document
      handleClose(done) {
        this.dialogVisible = false
      },
      async signDocument() {
        try {

          this.dialogVisible = false;

          switch (this.documentList.taskType) {
            case 'BUSINESSUNIT':
              this.$router.push(`/business-units/?companyId=${this.documentList.companyId}&businessUnitId=${this.documentList.projectId}&taskId=${this.documentList.projectTaskId}&tabName=reviewBusinessUnitTaskDocument&activeDocumentTab=${this.documentList.type}`);
              break;
            case 'ENGAGEMENT':
              this.$router.push(`/engagements/?companyId=${this.documentList.companyId}&engagementId=${this.documentList.projectId}&taskId=${this.documentList.projectTaskId}&tabName=reviewEngagementTaskDocument&activeDocumentTab=${this.documentList.type}`);
              break;
            default:
              if (this.$route.query.taskId.toString() === this.documentList.projectTaskId.toString()) {
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'documents';
                // setTimeout(()=>{
                //   this.$refs['taskInfoTab'].$refs.docs.selectTab(this.documentList.type);
                // },1500);

                this.$store.dispatch('getDocuments', this.documentList.projectTaskId).then(data => {
                  if (this.getStateId && this.getStateId === 'sop' ||
                          this.getStateId && this.getStateId === 'policy' ||
                          this.getStateId && this.getStateId === 'healthsafety' ||
                          this.getStateId && this.getStateId === 'riskAssesment' ||
                          this.getStateId && this.getStateId === 'general' ||
                          this.getStateId && this.getStateId === 'commercial' ||
                          this.getStateId && this.getStateId === 'envirenmental') {
                    this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                    this.$store.dispatch('setStateId', null)
                  } else {
                    this.$store.dispatch('setStateId', null)
                  }
                })
              } else {
                this.$router.push({query: {companyId: this.documentList.companyId, projectId: this.documentList.projectId, taskId: this.documentList.projectTaskId, tabName: 'reviewProjectTaskDocument', activeDocumentTab: this.documentList.type}}).then(data => {
                  console.log('this.$emit(rerenderMainLayout)');
                  this.$emit('rerenderMainLayout')
                })
              }
          }
        } catch (err){
          console.log(err)
        }
      },
      openModalAskExp(){
        this.$refs['askBeforeExp'].open()
      },
      handleClickOnInput(myElement){
        // alert(myElement)
        myElement.focus()
        // alert('hello')
      },
      async dynamicChangeData(projectTaskId, action){
        try {
            const taskIndex = await this.buildNewRowData2(projectTaskId);
            console.log('!!!!taskIndex', taskIndex);

            const taskId = await this.onFlashRow(taskIndex);
            console.log('!!!!taskId', taskId);

            const selectedNode = await this.selectCreatedTask(taskId ||this.rowData[0].id);
            console.log('!!!!selectedNode', selectedNode);
        } catch (err){
         console.log(err)
        }
      },
      refreshTreeAfterDeleteTimer(projectId){
        if(this.isWorkDay || this.valueProject === projectId){
          this.setProjectRowData(Number(this.$route.query.projectId), 0, Number(this.$route.query.taskId));
        }
      },
      setActiveTabs(data){
        console.log('MA DATA', data);
        return new Promise (async (resolve, reject) => {
          try {
            switch (data.notificationType) {
              case 'projectInfoTab':
                this.activeTab = 'first';
                this.activeInfoTab = 'first';
                resolve('success');
                break;
              case 'projectTaskInfoTab':
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'first';
                resolve('success');
                break;
              case 'createProjectComment':
                this.activeTab = 'projectCommentTab';
                resolve('success');
                break;
              case 'createProjectMessage':
                this.activeTab = 'seven';
                resolve('success');
                break;
              case 'createProjectFile':
                this.activeTab = 'third';
                resolve('success');
                break;
              case 'createProjectMeeting':
                this.activeTab = 'nine';
                resolve('success');
                break;
              case 'createProjectHistory':
                this.activeTab = 'nine';
                resolve('success');
                break;
              case 'setShared':
                // this.isProject = false;
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'progress';
                // this.$refs.taskInfoTab.handleClick({name: 'progress'});
                resolve('success');
                break;
              case 'createProjectTaskComment':
                this.activeTab = 'projectTaskCommentTab';
                resolve('success');
                break;
              case 'createProjectTaskMessage':
                this.activeTab = 'eight';
                resolve('success');
                break;
              case 'createProjectTaskFile':
                this.activeTab = 'four';
                resolve('success');
                break;
              case 'createProjectTaskMeeting':
                this.activeTab = 'ten';
                resolve('success');
                break;
              case 'createProjectTaskHistory':
                this.activeTab = 'twelve';
                resolve('success');
                break;
              case 'createProjectCrm':
                this.activeTab = 'crm';
                this.activeCRMTab = 'sellingProject';
                resolve('success');
                break;
              case 'createProjectScm':
                this.isProject = true;
                this.activeTab = 'scm';
                this.activeSCMTab = 'purchaseProject';
                resolve('success');
                break;
              case 'createProjectAccountTHINK':
                this.activeTab = 'aTHINK';
                this.activeAccountTHINKTab = 'budget';
                resolve('success');
                break;
              case 'reviewProjectTaskDocument':
                this.isProject = false;
                this.activeTab = 'taskInfoTab';
                this.activeTaskInfoTab = 'documents';
                this.$refs['taskInfoTab'].$refs.docs.selectTab(data.stateId);
                resolve('success');
                break;
              case 'customReminderProjectMeeting':
              case 'createProjectMeetings':
                this.isProject = true;
                this.activeTab = 'nine';
                resolve('success');
                break;
              case 'approveProjectTaskMeetings':
              case 'createProjectTaskMeetings':
                this.isProject = false;
                this.activeTab = 'ten';
                resolve('success');
                break;
              default:
                this.activeInfoTab = 'first';
                this.activeTaskInfoTab = 'first';
                resolve('success')
            }
          } catch (err){
            console.log(err)
            reject(err)
          }
        })
      },
      dynamicDeleteFromData(projectTaskId, action){
        return new Promise ((resolve, reject) =>{
          if(action === 'deleteProjectTask'){
            this.buildNewRowData2(projectTaskId).then(index => this.onFlashRowDelete(index)).then(id => {
              setTimeout(()=>{
                resolve('done')
              }, 500);
              setTimeout(()=>{
                let selectedId = id;
                if(this.selectedRow.id === selectedId){
                  this.selectCreatedTask(this.rowData[0].id)
                }else{
                  this.selectCreatedTask(this.selectedRow.id)
                }
              }, 1000)
            })
          }
        })
      },
      dynamicDNDData(projectTaskId, action){
        return new Promise ((resolve, reject) =>{
          if(action === 'changeProjectTaskParent' || action === 'createProjectTaskProgress' || action === 'restartProjectTask' ){
            this.buildNewRowData2(projectTaskId).then(index => this.onFlashRowDelete(index)).then(id => {
              setTimeout(()=>{
                resolve('done')
              }, 500);
              setTimeout(()=>{
                console.log('index jjjj', id, this.selectedRow.id)
                this.selectCreatedTask(this.selectedRow.id)
              }, 1000)
            })
          }
        })
      },
      async rebuildNewRowDataForProgress(project, projectTaskList){
        try {
          let itemsToUpdate = [];
          // find project to update
          const changedProject = await this.findProjectInRowData(project);
          // find updated tasks
          const changedProjectTaskList = await this.findTasksInRowData(projectTaskList);
          // concat arrays
          itemsToUpdate = changedProject.concat(changedProjectTaskList);
          // update row data
          const resultOfUpdate = await this.gridApi.updateRowData({ update: itemsToUpdate });
        } catch (err){
          console.log(err)
        }
      },
      findProjectInRowData(project){
        let changedProject = [];
        this.gridApi.forEachNodeAfterFilterAndSort(function(rowNode, index) {
          if (rowNode.data.id === 0) {
            rowNode.data.progress = Math.floor(project.progress);
            changedProject.push(rowNode.data)
          }
        });
        return changedProject
      },
      findTasksInRowData(projectTaskList){
        const changedProjectTaslList = [];
        this.gridApi.forEachNodeAfterFilterAndSort(function(rowNode, index) {
          projectTaskList.forEach(val => {
            if (rowNode.data.id === val.id) {
              rowNode.data.progress = Math.floor(val.progress);
              rowNode.data.orderIndex = val.orderIndex;
              changedProjectTaslList.push(rowNode.data)
            }
          })
        });
        return changedProjectTaslList
      },
      dynamicChangeRow(changedRow, action){
        if(action === 'updateProjectTask' ||
                action === 'startProjectTask' ||
                action === 'doneProjectTask' ||
                action === 'holdProjectTask' ||
                action === 'acceptProjectTaskShare' ||
                action === 'unshareProjectTask' ||
                action === 'holdProjectTask' ||
                action === 'createProjectTaskTimer' ||
                action === 'updateNameProjectTask' ||
                action === 'stopProjectTaskTimer') {
          console.log('action', action, changedRow);
          var itemsToUpdate = [];
          var newItem = changedRow;

          // CHECK USER ACCESS TO TASK START (updateProjectTask, startProjectTask, doneProjectTask)
          let ifUserInTaskTeam = null;
          const companyUserId = this.companyLayout.companyUserId;
          if(changedRow.taskTeamList) {
            const even = (element) => element.id.toString() === companyUserId.toString();
            ifUserInTaskTeam = changedRow.taskTeamList.some(even);
          }
          // CHECK USER ACCESS TO TASK END

          // CHECK IF USER INN MANAGERS TEAM START OR COMPANY OWNER
          if (!ifUserInTaskTeam) {
            const project = this.rowData[0];
            const even = (element) => element.toString() === companyUserId.toString();
            ifUserInTaskTeam = project.userList.some(even);
            // check for company owner
            if (this.companyLayout.isLeader) ifUserInTaskTeam = true
          }
          // CHECK IF USER INN MANAGERS TEAM END
          this.gridApi.forEachNodeAfterFilterAndSort(function(rowNode, index) {
            if (rowNode.data.id === changedRow.id ) {
              var data = rowNode.data;
              data.name = changedRow.name;
              data.daysTotal = countDaysTotal(changedRow.startDate, changedRow.deadlineDate);
              data.daysRemaning = countTaskDaysRemaning(changedRow.deadlineDate, changedRow.status, changedRow.isMasterTask, changedRow.endedDate);
              data.taskStatus = changedRow.status;
              data.orderIndex = changedRow.orderIndex;
              data.progress = Math.floor(changedRow.progress);
              data.type = changedRow.isMasterTask ? "masterTask" : "task";
              data.sharedCount = changedRow.sharedCount;
              data.timerCount = changedRow.timerCount;
              if (changedRow.leader) {
                data.leader = changedRow.leader === null ? null : changedRow.leader.user
              }
              // IF ACCESS CHANGED
              if (changedRow.taskTeamList) {
                data.access = ifUserInTaskTeam
              }
              data.allowSharing = changedRow.allowSharing;
              itemsToUpdate.push(data);
            }
          });
          // TODO COMMIT 28/02/2020
          this.gridApi.updateRowData({ update: itemsToUpdate });
          this.buildNewRowData(changedRow).then(index => this.onFlashRow(index)).then(id => this.selectCreatedTask(id ||this.rowData[0].id))
        }
      },
      buildNewRowData2(projectTaskId) {
        return new Promise((resolve, reject) => {
          // var rowData = [];
          // let i = 0;
          this.gridApi.forEachNode(function(node, index) {
            // node.data.myIndex = index;
            // console.log('node.data.id', node.data.id, index);
            // console.log('projectTaskId', projectTaskId);
            // console.log('node.data', node.data);
            // rowData.push(node.data);
            if(projectTaskId === node.data.id){
              resolve(index)
            }
            // i++
          })
        })
      },
      buildNewRowData(newItem) {
        return new Promise((resolve, reject) => {
          var rowData = [];
          let i = 0;
          this.gridApi.forEachNode(function(node) {
            // node.data.myIndex = i.toString()
            rowData.push(node.data);
            if(newItem.id === node.data.id) resolve(i);
            i++
          });
          this.rowData = rowData;
        })
      },
      onFlashRow(index) {
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode]
          });
          resolve(this.selectedRow.id)
        })
      },
      onFlashRowDelete(index) {
        console.log('-----1', index)
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode]
          });
          resolve(rowNode.id)
        })
      },
      onFlashOneCell(index) {
        console.log('index', index)
        return new Promise((resolve, reject) => {
          var rowNode = this.gridApi.getDisplayedRowAtIndex(index);
          this.gridApi.flashCells({
            rowNodes: [rowNode],
            columns: ["daysTotal"]
          });
          resolve(this.selectedRow.id)
        })
      },
      // * Delete Project
      deleteProject() {
        this.$confirm('This will permanently delete project. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/projects/delete?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                  .then(response => {
                    // this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${this.project[0].id}`)
                    // this.getProjects('first').then(data => {
                    //   console.log('litre', data)
                    // })
                    localStorage.removeItem('selectedProjectId');
                    localStorage.removeItem('selectedProjectTaskId');
                    this.$router.push(`/projects?companyId=${this.$route.query.companyId}`);
                    this.refreshBlock();
                    this.$store.dispatch('getMenuStatistics');
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      removeBUFromProject(){
        this.$refs.removeBuFromProjectModal.openModal(this.$route.query.companyId, this.$route.query.projectId)
      },
      exportProject() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projects/export?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                .then(response => {
                  console.log('---/projects/export', response.data.exportData);
                  // alert(JSON.stringify(response.data.exportData))

                  var textFileAsBlob = new Blob([ JSON.stringify(response.data.exportData) ], { type: 'text/plain' });
                  var fileNameToSaveAs = "ecc.plist";

                  var downloadLink = document.createElement("a");
                  downloadLink.download = fileNameToSaveAs;
                  downloadLink.innerHTML = "Download File";
                  if (window.webkitURL != null) {
                    // Chrome allows the link to be clicked without actually adding it to the DOM.
                    downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob);
                  } else {
                    // Firefox requires the link to be added to the DOM before it can be clicked.
                    downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
                    downloadLink.onclick = this.destroyClickedElement();
                    downloadLink.style.display = "none";
                    document.body.appendChild(downloadLink);
                  }

                  downloadLink.click();

                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      },
      destroyClickedElement(event) {
        document.body.removeChild(event.target);
      },
      handleFileImport(e) {
        // TODO:
        let file = e.target.files[0]
        console.log('---FILE', e.target.files[0]);

        var formData = new FormData();
        formData.append('file', e.target.files[0]);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projects/import?companyId=${this.$route.query.companyId}`, formData)
                .then(response => {
                  console.log('---/projects/import', response.data);
                  this.notification("Success", "File upload", "success")
                  this.$refs.fileImport.value = ''
                  this.$refs.importProject.close()

                  let projectId = response.data.projectId

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/projects/item?companyId=${this.$route.query.companyId}&projectId=${projectId}`)
                          .then(response => {
                            console.log('---/projects/item', response.data.item);
                            // alert(response.data.item.projectRegionId);
                            // alert(response.data.item.companyStageId);
                            this.getProjects(projectId, response.data.item.projectRegionId, response.data.item.companyStageId, 'first')
                            this.$router.push({ path: `/projects?companyId=${this.$route.query.companyId}&projectId=${projectId}` })
                            loader.hide()
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                            loader.hide()
                          });

                  // this.getProjects(response.data.projectId, response.data.item.projectRegionId, response.data.item.companyStageId, 'first')
                  // this.$router.push({ path: `/projects?companyId=${this.$route.query.companyId}&projectId=${response.data.projectId}` })
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  this.$refs.fileImport.value = ''
                  loader.hide()
                });

        // this.$refs.importProject.close()
      },
      importProject() {
        this.$refs.importProject.open()
      },
      // resize(newRect) {
      //   this.$refs.wrap__tree.classList.add("activeted")
      //   this.width = newRect.width;
      //   console.log('this.$refs.wrap__tree.clientHeight', this.$refs.wrap__tree.clientHeight)
      //   this.resizeHeight = this.$refs.wrap__tree.clientHeight;
      //   newRect.height = this.$refs.wrap__tree.clientHeight
      // console.log('resizeHeight', newRect.height)
      // console.log('resizeWidth', newRect)
      // },
      changeWorkDay(val, event, activeTask){
        this.selectedRow = {};
        // let animBlock = document.getElementById('fade-in')
        if(val){
          this.$store.dispatch('getCompanyLayout').then(response => {
            // animBlock.classList.add("hide")
            console.log('this.gridApi', this.autoGroupColumnDef);
            // this.gridApi.setSuppressRowDrag(true);
            // this.gridOptions.suppressContextMenu = true
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/projectTaskWorkDayItems/list?companyId=${this.$route.query.companyId}&companyUserId=${response.companyUserId}`)
                    .then(response => {
                      // this.rowData = response.data.list;
                      this.gridApi.setRowData(response.data.list);
                      if (response.data.list.length) {
                        this.gridApi.forEachNode((node, index) =>  {
                          if (node.data.id === activeTask || node.data.id === response.data.list[0].id) {
                            this.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
                            node.setSelected(true);
                          }
                        });
                      }
                      // if (response.data.list.length) {
                      //   setTimeout(() => {
                      //     this.selectCreatedTask(activeTask || this.rowData[0].id);
                      //   }, 500);
                      // }
                      loader.hide()
                    })
                    .catch(error => {
                      loader.hide();
                      console.log('An error occurred:', error);
                    });
          })
        }else{
          // animBlock.classList.remove("hide")
          // alert(val)
          // this.gridApi.setSuppressRowDrag(false);
          // this.gridOptions.suppressContextMenu = false
          console.log('this.seletedProject', this.seletedProject)
          // this.valueProject = this.seletedProject
          if(this.seletedProject){
            this.setProjectRowDataInput(this.seletedProject, 'first')
          }
          this.getClientsList();
          this.getRegions();
          this.getProjectStages();
        }
      },
      async showMyTasks(ownTasks){
        console.log('ownTasks', ownTasks)
        try {
          this.selectedRow = {};
          if(!ownTasks){
            let loader = await this.$loading.show();
            // await this.gridApi.setSuppressRowDrag(true);

            new Promise((resolve)=>{
              const newRowData = this.sortRowData(this.rowData.filter(val => val.access).map((val, index) => ({ ...val, filePath: [index] })))
              this.rowData = newRowData;
              resolve()
            }).then(async () =>{
              try {
                await this.selectCreatedTask(this.rowData[0].id);
                this.ownTasks = true;
                await loader.hide()

              } catch (err){
                console.log(err);
                await loader.hide()
              }
            });
          }else {
            this.gridApi.setSuppressRowDrag(false);

            this.setProjectRowDataInput(Number(this.$route.query.projectId), 'first')

            this.getClientsList();
            this.getRegions();
            this.getProjectStages();
            this.ownTasks = false;
          }
        } catch (err){
          console.log(err)
        }
      },
      sortRowData(arr) {
        let arrCopy = [...arr]
        arrCopy.sort((a, b) => {
          const aParts = a.myIndex.toString().split('.').map(Number)
          const bParts = b.myIndex.toString().split('.').map(Number)

          for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
            const aPart = aParts[i] || 0
            const bPart = bParts[i] || 0

            if (isNaN(aPart) || isNaN(bPart)) {
              return a.localeCompare(b)
            }

            if (aPart !== bPart) {
              return aPart - bPart;
            }
          }

          return 0
        })
        return arrCopy
      },
      closeMyWorkDay(){
        this.ownTasks = false;
        this.isWorkDay = false;
        this.changeWorkDay(this.isWorkDay)
      },
      setMyWorkDay(){
        localStorage.setItem('isWorkDay', 'projectWorkDayOpen')
      },
      startPeriods() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectPeriods/start?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                .then(response => {
                  console.log('---/projectPeriods/start', response.data)

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/projectLayout/getData?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                          .then(response => {
                            console.log('---/projectLayout/getData', response.data)
                            this.statusPeriodsTimer = response.data.hasProjectPeriod
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                          });
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
      },
      stopPeriods() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectPeriods/stop?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                .then(response => {
                  console.log('---/projectPeriods/stop', response.data);

                  axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                  axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                  axios.post(`/api/v1/projectLayout/getData?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                          .then(response => {
                            console.log('---/projectLayout/getData', response.data)
                            this.statusPeriodsTimer = response.data.hasProjectPeriod
                          })
                          .catch(error => {
                            console.log('An error occurred:', error);
                          });
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
      },
      // openChat(){
      //   this.$emit('openChat')
      // },
      // openDialog(){
      //   this.$emit('openChat2')
      // },
      openProjectExpense(state){
        this.$refs['askBeforeExp'].close();
        this.$refs['projectExpenseModal'].openModal(state)
      },
      openProjectPurchase(){
        this.$refs['askBeforePurch'].close();
        this.$refs.purchaseOrder.openModal()
      },
      openProjectExpenseRequest(state){
        this.$refs['askBeforeExp'].close()
        this.$refs['projectExpenseRequest'].openModal(state)
      },
      openProjectPurchaseRequest(){
        this.$refs['askBeforePurch'].close()
        this.$refs.purchaseRequest.openModal()
      },
      openProjectCashAdvance(){
        // this.$refs['projectCashAdvanceModal'].openModal('requestProjectTasksCashAdvance')
        this.$refs['requestProjectCashAdvanceModal'].openModal('requestProjectTasksCashAdvance')
      },
      openCalendar() {
        this.$router.push(`/calendar?companyId=${this.$route.query.companyId}`);
      },
      taskNotFoundOpenModal(){
        this.$refs.taskNotFound.open()
        setTimeout(() => {
          this.activeTab = 'first';
          this.activeInfoTab= 'first';
          this.gridOptions.api.deselectAll();
          this.selectCreatedTask(0);
          this.$refs.taskNotFound.close()
        }, 2000)
      },
      handleCommand(command){
        switch (command) {
          case 'changeWorkDay':
            this.isWorkDay = true;
            this.seletedProject = this.valueProject;
            this.changeWorkDay(this.isWorkDay);
            break;
          case 'createProject':
            this.TEST('add');
            break;
          case 'editProject':
            this.TEST('edit');
            break;
          case 'addTask':
            this.TESTING('add');
            break;
          case 'duplicateTask':
            this.duplicateTask('duplicate');
            break;
          case 'copyTask':
            this.copyTask();
            break;
          case 'editTask':
            this.TESTING('edit');
            break;
          case 'shareTask':
            this.openShareProjectTask();
            break;
          case 'unShareTask':
            this.openUnShareProjectTask();
            break;
          case 'deleteTask':
            this.removeTask();
            break;
          case 'saveTaskTree':
            this.saveTaskTree();
            break;
          case 'addProjectExpense':
            // this.openProjectExpense()
            this.openModalAskExp();
            break;
          case 'addTaskExpense':
            // this.openProjectExpense()
            this.openModalAskExp();
            break;
          case 'createCashAdvance':
            this.openProjectCashAdvance();
            break;
          case 'inviteUser':
            this.inviteUser();
            break;
          case 'createProjectEstimate':
            this.$router.push(`/project-estimate?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
            break;
          case 'purchaseRequest':
            this.$refs['askBeforePurch'].open();
            break;
          case 'createProjectQuotation':
            this.$router.push(`/project-quotation?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
            break;
          case 'createProjectSalesOrder':
            this.$router.push(`/project-salesOrder?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
            break;
          case 'createProjectInvoice':
            // this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
            this.$router.push(`/invoices?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`);
            break;
          case 'addTaskTimer':

            this.$confirm('Start your timer for this task?', 'Warning', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              type: 'info'
            }).then(() => {
              // this.$message({
              //   type: 'success',
              //   message: 'Task start time'
              // });

              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/projectTaskTimers/create?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRow.id}`)
                .then(response => {
                  console.log('---projectTaskTimers/create', response.data);
                  this.$store.dispatch('getTimerList', {projectId: this.$route.query.projectId, projectTaskId: this.selectedRow.id})
                  this.notification("Success", "Task start time", "success");
                  this.setProjectRowData(Number(this.$route.query.projectId), 0, Number(this.$route.query.taskId));
                  // this.activeTab = 'second'
                  this.activeTab = 'first'
                  this.activeTaskInfoTab = 'progress'

                  this.$message({
                    type: 'success',
                    message: 'Task start time'
                  });
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: 'Task start time canceled'
              });
            });

            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            // axios.post(`/api/v1/projectTaskTimers/create?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRow.id}`)
            //         .then(response => {
            //           console.log('---projectTaskTimers/create', response.data);
            //           this.$store.dispatch('getTimerList', {projectId: this.$route.query.projectId, projectTaskId: this.selectedRow.id})
            //           this.notification("Success", "Task start time", "success");
            //           this.setProjectRowData(Number(this.$route.query.projectId), 0, Number(this.$route.query.taskId));
            //           this.activeTab = 'second'
            //         })
            //         .catch(error => {
            //           console.log('An error occurred:', error);
            //         });
            break;
          case 'exportProject':
            this.exportProject();
            break;
          case 'importProject':
            this.importProject();
            break;
          case 'deleteProject':
            this.deleteProject();
            break;
          case 'removeBUProject':
            this.removeBUFromProject()
            break;
          case 'toggleProjectBookmark':
            this.changeBookMarkProject(this.$route.query.companyId, this.$route.query.projectId)
            break;
          case 'toggleProjectTaskBookmark':
            this.changeBookMarkTask(this.$route.query.companyId, this.$route.query.projectId, this.selectedRow.id)
            break;
          default:
        }
      },
      TESTING(state) {
        // If try to add task to project
        if(this.selectedRow.type === 'project'){
          this.addTaskOpen(state)
        }else if (this.selectedRow.type !== 'project' && state !== 'edit'){
          gridMessageBox.confirm('', this.$i18n.t('general_action'), {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$i18n.t('general_addToParent'),
            cancelButtonText: this.$i18n.t('general_insertTask'),
            center: true
          })
                  .then(() => {
                    // check if user dont have permissions to create task
                    if (!this.projectPermission.createTask) {
                      this.notification("Notification", "User Dont have permission to create task", "info");
                      return
                    }

                    if(state === 'add' && this.selectedRow.type === "task" && this.selectedRow.taskStatus !== 1 && this.firstEntering === false){
                      this.$refs.addParent.open();
                      this.firstEntering = false
                    }else{
                      this.addTaskOpen(state)
                    }
                  })
                  .catch(action => {
                    // check if user dont have permissions to create task
                    if (!this.projectPermission.createTask) {
                      this.notification("Notification", "User Dont have permission to create task", "info");
                      return
                    }

                    if (action === 'cancel'){
                      this.addTaskOpen('insert')
                    }
                  })
        }else{
          this.addTaskOpen(state)
        }
        // this.firstEntering = false
      },
      duplicateTask(state){
        this.$confirm(this.$i18n.t('general_doYouWantToDuplicateThisTask'), '', {
          confirmButtonText: this.$i18n.t('general_yes'),
          cancelButtonText: this.$i18n.t('general_cancel'),
          type: 'info'
        }).then(() => {
          try {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.get(`/api/v1/projectTasks/duplicate?companyId=${this.$route.query.companyId}&projectId=${this.selectedRow.projectId}&projectTaskId=${this.selectedRow.id}`)
                    .then(response => {
                      loader.hide();
                      this.$message({
                        type: 'success',
                        message: 'Duplication completed'
                      });
                      this.setProjectRowDataInput(this.selectedRow.projectId, false, response.data.projectTaskId)
                    }).catch(err => {
                      loader.hide();
                      console.log(err)
                    });
          }catch(err){
            console.log(err)
          }
          }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Duplication canceled'
          });
        });
      },
      async getAllProjects() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/projects/listAllProject?companyId=${this.$route.query.companyId}`)
          this.allProjectList = data.list ? data.list : []
        } catch(e) {
          console.log(e)
        } finally {
          loader.hide()
        }
      },
      async copyTask(state){
        await this.getAllProjects()
        this.selectedProjectForCopy = null
        this.$refs.copyTask.open();
      },
      async copy() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.get(`/api/v1/projectTasks/copy?companyId=${this.$route.query.companyId}&projectId=${this.selectedProjectForCopy}&projectTaskId=${this.$route.query.taskId}`)
          this.$refs.copyTask.close();
          this.$message({
            type: 'success',
            message: 'Copy completed'
          });
        } catch(e) {
          console.log(e)
        } finally {
          loader.hide()
        }
      },
      addTaskOpen(state){
        this.$refs.taskModal.addTask(state)
        // this.$refs['taskModal'].$refs['addTask'].open(state)
      },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   console.log('COMPANY TTT', name)
      //   this.companyNameSelect = name
      // },
      // companyIdFunc(id) {
      //   // alert(id)
      //   this.companyId = id
      // },
      async refreshBlock() {
        try {
          this.valueRegion = '';
          this.valueStages = '';
          this.valueProject = '';
          this.rowData = [];
          this.disabledBtn = true;
          this.activeInfoTab = "first";
          this.activeTaskInfoTab = "first";
          this.getClientsList();
          this.getRegions();
          this.getProjectStages();
          this.project = await this.getProjects(this.$route.query.companyId);
        } catch (err) {
          console.log(err)
        }
      },
      getClientsList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyClients/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.clientList = response.data.list
            this.clientList.unshift({name: 'All', id: 0})
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      getRegions() {
        let loader = this.$loading.show();
        console.log('COMPANYID!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', this.$route)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/regions/list?companyId=${this.$route.query.companyId}&type=project`)
                .then(response => {
                  console.log('---', response.data);
                  this.region = response.data.list;
                  this.region.unshift({name: 'All', id: 0});
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      },
      getProjectStages() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
                .post(`/api/v1/companyStages/list?companyId=${this.$route.query.companyId}`)
                .then(response => {
                  console.log('---', response.data);
                  this.stages = response.data.list
                  this.stages.unshift({name: 'All', id: 0})
                  loader.hide()
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                  loader.hide()
                });
      },
      getContextMenuItems(params) {
        // TODO
        if (params.node.data.id !== this.selectedRow.id && this.selectedRows.length === 1) {
          this.gridOptions.api.deselectAll();
        }
        this.selectCreatedTaskByRightClick(params.node.data.id);
        var _this = this;
        var data = params.node.data;
        var contextMenuItemList = [];
        if (data.type === 'task' || data.type === 'masterTask') {
          if(this.selectedRows.length === 1){
            if(!this.isWorkDay){
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_addTask'),
                disabled: !this.projectPermission.createTask,
                action: function () {
                  console.log("THIS", this);
                  _this.TESTING('add')
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if(!this.isWorkDay && data.type === 'task'){
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_duplicateTask'),
                disabled: !this.projectPermission.createTask,
                action: function () {
                  _this.duplicateTask('duplicate')
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if(!this.isWorkDay && data.type === 'task'){
              contextMenuItemList.push({
                name: 'Copy Task',
                // disabled: !this.projectPermission.createTask,
                action: function () {
                  _this.copyTask()
                },
                icon: '<i class="el-icon-plus"></i>',
              });
            }
            if(!this.isWorkDay) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_editTask'),
                disabled: !this.projectPermission.updateTask,
                action: function () {
                  _this.TESTING('edit')
                },
                icon: '<i class="el-icon-edit"></i>',
              });
            }
            if(data.allowSharing === 1) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_shareTask'),
                disabled: !this.projectPermission.shareTask,
                action: function () {
                  _this.openShareProjectTask()
                  // console.log("Delete")
                },
                icon: '<i class="el-icon-share"></i>',
              });
            }
            if(data.allowSharing === 1) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_unShareTask'),
                disabled: !this.projectPermission.unshareTask,
                action: function () {
                  _this.openUnShareProjectTask()
                  // console.log("Delete")
                },
                icon: '<i class="el-icon-close"></i>',
              });
            }
            if(!this.isWorkDay) {
              if (data.type === 'task') {
                contextMenuItemList.push({
                  name: this.$i18n.t('general_grid_contextMenu_deleteTask'),
                  disabled: !this.projectPermission.deleteTask,
                  action: function () {
                    _this.removeTask();
                    // console.log("Delete")
                  },
                  icon: '<i class="el-icon-delete"></i>',
                });
              }
            }
            if (data.type === 'task' && this.selectedRow.taskStatus === 2 || data.type === 'task' && this.selectedRow.taskStatus === 5) {
              contextMenuItemList.push({
                name: this.$i18n.t('general_grid_contextMenu_addTaskTimer'),
                action: function () {
                  _this.handleCommand('addTaskTimer');
                  // console.log("Delete")
                },
                icon: '<i class="el-icon-time"></i>',
              });
            }
            // if(data.type === 'task'){
            contextMenuItemList.push({
              name: this.$i18n.t('general_grid_contextMenu_inviteUser'),
              disabled: !this.companyLayout.permission.inviteUser,
              action: function () {
                _this.inviteUser();
                // console.log("Delete")
              },
              icon: '<i class="el-icon-plus"></i>',
            });
            // }
          }else{
            contextMenuItemList.push({
              name: this.$t('general_grid_contextMenu_EditTeam'),
              action: function () {
                _this.$refs.ReassignTasksModal.editTaskListOpen();
              },
              icon: '<i class="el-icon-edit"></i>',
            },
            {
              name: this.$i18n.t('general_grid_contextMenu_addUsersToTeam'),
              action: function () {
                _this.$refs.addNewUserToTasksModal.addNewUsersOpen();
              },
              icon: '<i class="el-icon-edit"></i>',
            });
          }
        }
        if (data.type === 'project' && this.selectedRows.length <= 1) {
          contextMenuItemList.push({
            disabled: !this.projectPermission.createTask,
            name: this.$i18n.t('general_grid_contextMenu_addTask'),
            action: function () {
              _this.TESTING('add')
            },
            icon: '<i class="el-icon-plus"></i>',
          });
          contextMenuItemList.push({
            disabled: !this.companyLayout.permission.updateProjects,
            name: this.$i18n.t('project_dropdown_action_remove_BU_project'),
            action: function () {
              _this.removeBUFromProject()
            },
            icon: '<i class="el-icon-edit"></i>',
          });
          contextMenuItemList.push({
            name: this.$i18n.t('general_grid_contextMenu_saveTaskTree'),
            disabled: !this.projectPermission.actionSaveTree,
            action: function () {
              _this.saveTaskTree()
            },
            icon: '<i class="el-icon-star-off"></i>',
          });
        }
        return contextMenuItemList;
      },
      getProjects(companyId) {
        return new Promise ((resolve, reject) => {
          // console.log("MY IDDDD", projectId, regionId, projectStageId, afterCloseModalState)
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${companyId}`)
                  .then(response => {
                    loader.hide();
                    resolve(response.data.list)
                  })
                  .catch(error => {
                    reject(error);
                    console.log('An error occurred:', error);
                    loader.hide()
                  })
        });
      },
      openShareProjectTask() {
        this.$refs.shareProjectTaskModal.$refs.shareProjectTaskModal.open();
      },
      openUnShareProjectTask() {
        this.$refs.unShareProjectTaskModal.openUnShareTaskModal()
      },
      TEST(state) {
        this.projectState = state
        // this.$refs.createProject.open();
        this.$refs.modal.createProjectOpen(state)
        this.$refs['modal'].$refs['createProject'].open(state)
      },
      setValueRegion(id) {
        if (this.valueStages) {
          console.log('---', 'all all');
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&projectRegionId=${id}&companyStageId=${this.valueStagesId}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        } else {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&projectRegionId=${id}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }
      },
      setClients(id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&projectClientId=${id}`)
          .then(response => {
            console.log('---', response.data);
            // this.project = response.data.list
            this.valueRegion = ''
            this.valueStages = ''
            this.checkRegions(response.data.list)
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      setFilter(valueRegion, valueStages){
        console.log('meFilters', valueRegion, valueStages)
        this.clientListId = null
        if(!valueRegion && valueStages){
          // alert('REGION ALL and 1 STAGE')
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&companyStageId=${valueStages}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }else if(valueRegion && !valueStages){
          // alert('STAGE ALL and 1 REGION')
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&projectRegionId=${valueRegion}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }else if (valueRegion && valueStages){
          // alert('1 STAGE and 1 REGION')
          // let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&projectRegionId=${valueRegion}&companyStageId=${valueStages}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    // loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    // loader.hide()
                  });
        }else {
          // alert('STAGE ALL and REGION ALL')
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}`)
                  .then(response => {
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  })
        }
        console.log('valueRegion', valueRegion, 'valueRegion', valueStages)
      },
      setValueStages(id) {
        console.log('---HEREEEE', 'setValueStages');
        this.valueStagesId = id;
        if (this.valueRegion) {
          console.log('---', 'all all');
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&projectRegionId=${this.valueRegion}&companyStageId=${id}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        } else {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}&companyStageId=${id}`)
                  .then(response => {
                    console.log('---', response.data);
                    // this.project = response.data.list
                    this.checkRegions(response.data.list)
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        }
      },
      checkRegions(response){
        this.project = response
        if (this.project.length < 1){
          // alert('keeer')
          this.valueProject = ""
          this.rowData = []
          this.selectedProjectForInfo = false
          this.selectedTaskForInfo = false
          this.activeTab = 'first'
          return
        }

        let isFind = this.compare(response, this.valueProject)

        if(!isFind){
          this.rowData = [];
          this.valueProject = '';
          this.selectedProjectForInfo = false;
          this.selectedTaskForInfo = false
          // this.activeTab = 'first'
        }
        // console.log('this.valueProject', this.valueProject)
      },
      async setProjectRowDataInput(projectId, state, newCreatedProjectTask){
        // check if own tasks selected
        const rowData = await this.setProjectRowData(projectId, state, newCreatedProjectTask);
        const selectedRow = await this.selectCreatedTask(newCreatedProjectTask || 0)
      },
      compare(array, value){
        for (var i = 0; i < array.length; i++) {
          console.log(array[i].id + '/' + value)
          if (array[i].id == value) return true;
        }
        return false
      },
      // SET PROJECTS INTO TABLE
      setProjectRowData(projectId, state, newCreatedProjectTask) {
        return new Promise ((resolve, reject) => {
          if(this.isWorkDay) {
            this.isWorkDay = false;
            this.gridApi.setSuppressRowDrag(false);
            this.getClientsList();
            this.getRegions();
            this.getProjectStages();
            this.seletedProject = projectId;
            this.$message({
              type: 'info',
              message: this.$t('general_workdayClosed')
            });
            // this.changeWorkDay(this.isWorkDay, false, newCreatedProjectTask);
            // return
          }
          this.$store.dispatch('projectChange', projectId);
          if(newCreatedProjectTask){
            this.newCreatedProjectTask = newCreatedProjectTask
          }
          this.valueProject = projectId;
          this.isProject = true;
          localStorage.setItem('selectedProjectId', this.valueProject);
          if(state === "first"){
            this.$router.push(`/projects?companyId=${this.$route.query.companyId}&projectId=${this.valueProject}&taskId=0`)
          }
          this.activeProjectId = projectId;
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projectTasks/list?companyId=${this.$route.query.companyId}&projectId=${projectId}`)
                  .then(async response => {
                    try {
                      this.activeProjectRowData = response.data.newlist.find(val => val.type === 'project')

                      if(this.valueRegion !== 0){
                        this.valueRegion = this.activeProjectRowData.projectRegionId
                      }
                      if(this.valueStages !== 0){
                        this.valueStages = this.activeProjectRowData.companyStageId
                      }
                      this.setFilter(this.valueRegion, this.valueStages);

                      // check if user select own tasks in grid
                      let rowData = [];
                      if (!this.ownTasks) {
                        rowData = await this.buildNewTree(response.data.newlist);
                      }else{
                        const simpleRowData = await this.buildNewTree(response.data.newlist);
                        rowData = simpleRowData.filter(function (val, index){
                          if(val.access){
                            val.filePath = [index];
                            return val
                          }
                        })
                      }
                      this.rowData = rowData;

                      resolve(this.rowData);
                    }catch (err){
                      console.log(err)
                    }
                    // var projectTaskList = response.data.list;
                    // if(this.valueRegion !== 0){
                    //   this.valueRegion = response.data.newlist[0].projectRegionId
                    // }
                    // if(this.valueStages !== 0){
                    //   this.valueStages = response.data.newlist[0].companyStageId
                    // }
                    // this.setFilter(this.valueRegion, this.valueStages);
                    //
                    // this.rowData = await this.buildNewTree(response.data.newlist);
                    //
                    // resolve(this.rowData);
                    // console.log('RESPONSE DATA LIST', response.data.list);
                    // axios.post(`/api/v1/projects/item?companyId=${this.$route.query.companyId}&projectId=${projectId}`)
                    //         .then(response => {
                    //
                    //           // this.rowData = this.buildNewTree();
                    //
                    //           this.rowData = this.buildTree(response.data.item, projectTaskList);
                    //           console.log('!!!!!!!!!!!!!!!!!!!!!', this.rowData);
                              // if(state === 'first' ){
                              //     this.selectCreatedTask(0)
                              //     this.openInfo('first', projectId)
                              // }

                              // else if(localStorage.getItem('fromHeader') === '1'){
                              //   if(localStorage.getItem('selectedProjectTaskId') !== "undefined"){
                              //     // alert('hello')
                              //     let ifFind = this.find(projectTaskList, localStorage.getItem('selectedProjectTaskId'))
                              //     if (ifFind === false){
                              //       this.taskNotFoundOpenModal()
                              //     }
                              //   }
                              //   loader.hide()
                              //   localStorage.removeItem('selectedProjectTaskId')
                              //   localStorage.removeItem('fromHeader')
                              //   if(localStorage.getItem('progressTask') === '1'){
                              //     // setTimeout(() => {
                              //     //   this.selectCreatedTask(0)
                              //     // }, 100)
                              //     setTimeout(() => {
                              //       this.activeTab = 'second'
                              //       let data = {'taskId': localStorage.getItem('selectedProjectTaskIdForProg'), 'projectId': this.$route.query.projectId, 'companyId': this.$route.query.companyId}
                              //       this.getProgressesList(data);
                              //       this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: localStorage.getItem('selectedProjectTaskIdForProg')})
                              //       localStorage.removeItem('selectedProjectTaskIdForProg')
                              //       localStorage.removeItem('progressTask')
                              //     }, 1000)
                              //     // }
                              //   }else if(localStorage.getItem('comment') === 'project'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'projectCommentTab'
                              //       // let data = {'taskId': localStorage.getItem('selectedProjectTaskIdForProg'), 'projectId': this.$route.query.projectId, 'companyId': localStorage.getItem('companyId')}
                              //       this.$store.dispatch('getProjectComments')
                              //       this.selectCreatedTask(0)
                              //       localStorage.removeItem('selectedProjectTaskIdForComm')
                              //       localStorage.removeItem('comment')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('comment') === 'task'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'projectTaskCommentTab'
                              //       let data = {'taskId': localStorage.getItem('selectedProjectTaskIdForComm'), 'projectId': this.$route.query.projectId}
                              //       this.$store.dispatch('getProjectTaskComments', data)
                              //       localStorage.removeItem('selectedProjectTaskIdForComm')
                              //       localStorage.removeItem('comment')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('file') === 'project'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'third'
                              //       // let data = {'taskId': localStorage.getItem('selectedProjectTaskIdForProg'), 'projectId': localStorage.getItem('selectedProjectId'), 'companyId': localStorage.getItem('companyId')}
                              //       this.$store.dispatch('getProjectFiles')
                              //       this.selectCreatedTask(0)
                              //       localStorage.removeItem('selectedProjectTaskIdForFiles')
                              //       localStorage.removeItem('file')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('file') === 'task'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'four'
                              //       this.$store.dispatch('getTaskFiles', localStorage.getItem('selectedProjectTaskIdForFiles'))
                              //       localStorage.removeItem('selectedProjectTaskIdForFiles')
                              //       localStorage.removeItem('file')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('meeting') === 'project'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'nine'
                              //       this.$store.dispatch('getProjectMeetings')
                              //       this.selectCreatedTask(0)
                              //       localStorage.removeItem('selectedProjectTaskIdForMeeting')
                              //       localStorage.removeItem('meeting')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('meeting') === 'task'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'ten'
                              //       this.$store.dispatch('getProjectTaskMeetings', {taskId: localStorage.getItem('selectedProjectTaskIdForMeeting')})
                              //       localStorage.removeItem('selectedProjectTaskIdForMeeting')
                              //       localStorage.removeItem('meeting')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('history') === 'project'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'eleven'
                              //       this.$store.dispatch('getProjectHistory')
                              //       this.selectCreatedTask(0)
                              //       localStorage.removeItem('selectedProjectTaskIdForHistory')
                              //       localStorage.removeItem('history')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('history') === 'task'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'twelve'
                              //       // this.$store.dispatch('getProjectTaskHistory')
                              //       localStorage.removeItem('selectedProjectTaskIdForHistory')
                              //       localStorage.removeItem('history')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('message') === 'project'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'seven'
                              //       // let data = {'taskId': localStorage.getItem('selectedProjectTaskIdForProg'), 'projectId': localStorage.getItem('selectedProjectId'), 'companyId': localStorage.getItem('companyId')}
                              //       this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.$route.query.projectId, 'projectMessageType': '1'})
                              //       this.selectCreatedTask(0)
                              //       localStorage.removeItem('selectedProjectTaskIdForMess')
                              //       localStorage.removeItem('message')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('message') === 'task'){
                              //     setTimeout(() => {
                              //       this.activeTab = 'eight'
                              //       // let data = {'taskId': localStorage.getItem('selectedProjectTaskIdForProg'), 'projectId': localStorage.getItem('selectedProjectId'), 'companyId': localStorage.getItem('companyId')}
                              //       this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.$route.query.projectId, 'projectTaskId': localStorage.getItem('selectedProjectTaskIdForMess'), 'projectTaskMessageType': '1'})
                              //       localStorage.removeItem('selectedProjectTaskIdForMess')
                              //       localStorage.removeItem('message')
                              //     }, 1000)
                              //   }else if(localStorage.getItem('document')){
                              //     setTimeout(() => {
                              //       this.activeTab = 'fourteen'
                              //       this.$store.dispatch('getDocuments', localStorage.getItem('selectedProjectTaskIdForDocument'))
                              //       this.$refs['docs'].selectTab(localStorage.getItem('document'))
                              //       localStorage.removeItem('selectedProjectTaskIdForDocument')
                              //       localStorage.removeItem('document')
                              //     }, 1000)
                              //   }
                              // }else{
                              //   this.openInfo('first', projectId)
                              // }
                              // if (this.selectedRow) {
                              //   // alert('selected ROW')
                              //   //TODO selectedRows reserved
                              //   for (let i = 0; i < this.rowData.length; i++) {
                              //     if (this.selectedRow.id === this.rowData[i].id) {
                              //       this.selectedRow = this.rowData[i]
                              //     }
                              //   }
                              // }
                            //   loader.hide();
                            //   resolve(this.rowData)
                            // })
                            // .catch(error => {
                            //   console.log('An error occurred:', error);
                            //   loader.hide();
                            //   reject(error)
                            // });
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      // setShared2(projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName) {
      //   console.log('projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName', projectId, state, taskId, companyId, sharedProjecttaskNoteId, companyName)
      //   if(this.isWorkDay){
      //     this.isWorkDay = false
      //     this.gridApi.setSuppressRowDrag(false);
      //     // this.gridOptions.suppressContextMenu = false
      //     // let animBlock = document.getElementById('fade-in')
      //     // animBlock.classList.remove("hide")
      //   }
      //   localStorage.setItem('companyId', companyId)
      //   // this.$refs.sharedCompany.sharedCompanyPut(companyId, companyName)
      //   localStorage.setItem('selectedProjectId', projectId);
      //   //TODO commited 03.10
      //   // localStorage.setItem('selectedProjectId', this.seletedProject);
      //   this.sharedProjecttaskNoteId = sharedProjecttaskNoteId
      //   // alert("HELLO")
      //   console.log('shared', 'projectId', projectId, 'state', state, 'taskId', taskId, 'companyId', companyId)
      //   if(taskId){
      //     this.newCreatedProjectTask = taskId
      //   }
      //   this.seletedProject = projectId
      //   // this.isProject = true
      //   // this.getProjects(projectId)
      //
      //   let loader = this.$loading.show();
      //   this.getRegions();
      //   this.getProjectStages();
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //           .post(`/api/v1/projects/list?companyId=${this.$route.query.companyId}`)
      //           .then(response => {
      //             console.log('---PROJECTS', response.data);
      //             this.project = response.data.list
      //             this.valueProject = projectId
      //             if (projectId && response.data.list.length !== 0) {
      //               // for (let i = 0; i < response.data.list.length; i++) {
      //               //   // console.log(projectId, "resp!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", response.data.list[i].id)
      //               //   if (projectId === response.data.list[i].id) {
      //               //     this.valueProject = response.data.list[i].id;
      //               //     localStorage.setItem('selectedProjectId', projectId);
      //               //     // this.setProjectRowData(this.$route.query.projectId)
      //               //     this.valueRegion = response.data.list[i].projectRegionId
      //               //     this.valueStages = response.data.list[i].stage.id
      //               //     // MUST TO CHECK
      //               //     // this.setFilter(this.valueRegion, this.valueStages)
      //               //   }
      //               // }
      //               axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //               axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //               axios
      //                 .post(`/api/v1/projects/item?companyId=${this.$route.query.companyId}&projectId=${projectId}`)
      //                 .then(response => {
      //                   loader.hide()
      //                   if(this.valueRegion !== 0){
      //                     this.valueRegion = response.data.item.projectRegionId
      //                   }
      //                   if(this.valueStages !== 0){
      //                     this.valueStages = response.data.item.companyStageId
      //                   }
      //                 })
      //                 .catch(error => {
      //                   loader.hide()
      //                 });
      //               // console.log('EEEEEEEEEEEEEEEEEEE', projectId, this.project)
      //             }
      //             loader.hide()
      //           })
      //           .catch(error => {
      //             console.log('An error occurred:', error);
      //             loader.hide()
      //           })
      //
      //
      //
      //
      //
      //
      //   console.log('SET PROJECT ROW DATA', projectId)
      //   // console.log('SET PROJECT ITEM', item)
      //   // this.activeProjectId = projectId
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //           .post(`/api/v1/projectTasks/list?companyId=${companyId}&projectId=${projectId}`)
      //           .then(response => {
      //             var projectTaskList = response.data.list;
      //             // response.data.list.forEach(val => {
      //             //   console.log('val.id', val.id)
      //             //   console.log('this.$route.query.taskId', this.$route.query.taskId)
      //             //   if(val.id !== Number(this.$route.query.taskId = taskId)){
      //             //
      //             //     this.taskNotFoundOpenModal()
      //             //   }
      //             // })
      //               if(state === 'createProjectTaskMessage' || state === 'createProjectTaskComment' || state ==='setShared'){
      //                 let ifFind = this.find(response.data.list, taskId)
      //
      //                 if (ifFind === false){
      //                   axios.post(`/api/v1/projects/item?companyId=${companyId}&projectId=${projectId}`)
      //                           .then(response => {
      //                             this.rowData = this.buildTree(response.data.item, projectTaskList);
      //                             this.taskNotFoundOpenModal()
      //                             loader.hide()
      //                             return
      //                           }).catch(err => {
      //                             console.log('err', err)
      //                   })
      //                 }
      //               }
      //
      //             console.log('RESPONSE DATA LIST', response.data.list);
      //             axios.post(`/api/v1/projects/item?companyId=${companyId}&projectId=${projectId}`)
      //                     .then(response => {
      //                       // this.valueRegion = response.data.item.projectRegionId
      //                       // this.valueStages = response.data.item.stageId
      //                       // 30.09 commits
      //                       // if(state === 'createProjectComment' || state === 'createProjectMessage'){
      //                       //   this.selectedRow.id = 0
      //                       //   this.newCreatedProjectTask = 'first'
      //                       // }
      //                       this.rowData = this.buildTree(response.data.item, projectTaskList);
      //                       // console.log("PROJECT TASK LIST", projectTaskList)
      //                       // console.log("PROJECT DATA ITEM", response.data.item)
      //                       // console.log("PUSH TO ROW DATA", this.rowData)
      //                       // console.log('sharedProgressNote',state )
      //                       // alert(state)
      //                       if(state === 'setShared'){
      //                         setTimeout(() => {
      //                           // alert('here')
      //                           this.activeTab = 'second'
      //                           let data = {'taskId': taskId, 'projectId': projectId, 'companyId': companyId}
      //                           this.getProgressesList(data);
      //                           this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: taskId})
      //                         }, 1000)
      //                       }else if(state === 'createProjectComment'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'projectCommentTab'
      //                           this.$store.dispatch('getProjectComments')
      //                           this.gridOptions.api.deselectAll()
      //                           this.selectCreatedTask(0)
      //                         }, 1500)
      //                       }else if(state === 'createProjectTaskComment'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'projectTaskCommentTab'
      //                           let data = {'taskId': taskId, 'projectId': projectId}
      //                           this.$store.dispatch('getProjectTaskComments', data)
      //                         }, 1000)
      //                       }else if(state === 'createProjectFile'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'third'
      //                           this.$store.dispatch('getProjectFiles')
      //                           this.gridOptions.api.deselectAll()
      //                           this.selectCreatedTask(0)
      //                         }, 1500)
      //                       }else if(state === 'createProjectTaskFile'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'four'
      //                           // let data = {'taskId': taskId, 'projectId': projectId}
      //                           this.$store.dispatch('getTaskFiles', taskId)
      //                         }, 1000)
      //                       }else if(state === 'createProjectMeeting'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'nine'
      //                           this.$store.dispatch('getProjectMeetings')
      //                           this.gridOptions.api.deselectAll()
      //                           this.selectCreatedTask(0)
      //                         }, 1500)
      //                       }else if(state === 'createProjectTaskMeeting'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'ten'
      //                           // let data = {'taskId': taskId, 'projectId': projectId}
      //                           this.$store.dispatch('getProjectTaskMeetings', {taskId: taskId})
      //                         }, 1000)
      //                       }else if(state === 'createProjectHistory'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'eleven'
      //                           this.$store.dispatch('getProjectHistory')
      //                           this.gridOptions.api.deselectAll()
      //                           this.selectCreatedTask(0)
      //                         }, 1500)
      //                       }else if(state === 'createProjectTaskHistory'){
      //                         setTimeout(() => {
      //                           this.activeTab = 'twelve'
      //                           this.$store.dispatch('getProjectTaskHistory')
      //                         }, 1000)
      //                       }else if(state === 'createProjectMessage'){
      //                         setTimeout(() => {
      //                           if(this.activeTab === 'seven'){
      //                             this.$refs.MessagesProject.currentTabComponent = 'MessagesReceived'
      //                           }else{
      //                             this.activeTab = 'seven'
      //                           }
      //                           this.gridOptions.api.deselectAll()
      //                           this.selectCreatedTask(0)
      //                           this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': projectId, 'projectMessageType': '1'})
      //                         }, 1000)
      //                       }else if(state === 'createProjectTaskMessage'){
      //                         setTimeout(() => {
      //                           if(this.activeTab === 'eight'){
      //                             this.$refs.MessagesTask.currentTabComponent = 'MessagesReceived'
      //                           }else{
      //                             this.activeTab = 'eight'
      //                           }
      //                           this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': projectId, 'projectTaskId': taskId, 'projectTaskMessageType': '1'})
      //                         }, 1000)
      //                       }else if(state === 'infoProjectTask') {
      //                         setTimeout(() => {
      //                           // alert('hello')
      //                         }, 1000)
      //                       }else if(state === 'ProjectTaskDocument') {
      //                         setTimeout(() => {
      //                           this.activeTab = 'fourteen'
      //                           this.$store.dispatch('getDocuments', taskId)
      //                           // alert('hello')
      //                         }, 1000)
      //                       }else if(state === 'reviewProjectTaskDocument') {
      //                         setTimeout(() => {
      //                           this.activeTab = 'fourteen'
      //                           this.$store.dispatch('getDocuments', taskId)
      //                           this.$refs['docs'].selectTab(sharedProjecttaskNoteId)
      //
      //                           // alert('hello')
      //                         }, 1000)
      //                       }
      //                       if (this.selectedRow) {
      //                         //TODO selectedRows reserved
      //                         for (let i = 0; i < this.rowData.length; i++) {
      //                           if (this.selectedRow.id === this.rowData[i].id) {
      //                             this.selectedRow = this.rowData[i]
      //                           }
      //                         }
      //                       }
      //                       loader.hide()
      //                     })
      //                     .catch(error => {
      //                       console.log('An error occurred:', error);
      //                       loader.hide()
      //                     });
      //           })
      //           .catch(error => {
      //             console.log('An error occurred:', error);
      //             loader.hide()
      //           });
      // },
      selectCreatedTask(id) {
        return new Promise ((resolve, reject) => {
          let that = this;
          let ifUserHaveAccesstoTask = false;
          this.gridApi.forEachNode(function (node, index) {
            // CHECK IF USER HAVE ACCESS TO TE ROW
            if (node.data.id === id && node.data.access) {
              // SET TO TRUE IF HAVE ACCESS
              ifUserHaveAccesstoTask = true;
              // MOVE TASK TO MIDDLE CENTER
              that.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
              node.setSelected(true);
              resolve(node)
            }
          });
          // CHECK IF USER SELECTED TASK WITH ACCESS IF NOT SELECT FIRST TASK WITH ACCESS
          if (!ifUserHaveAccesstoTask) {
            const accessedRows = that.rowData.filter(val => val.access);
            if(accessedRows.length) {
              this.selectCreatedTask(accessedRows[0].id)
            }
          }
        })
      },
      async selectCreatedTaskNotification(id) {
        try {
          return new Promise ((resolve, reject) => {
            this.gridOptions.api.deselectAll();
            let that = this;
            let ifUserHaveAccesstoTask = false;
            this.gridApi.forEachNode(function (node, index) {
              // CHECK IF USER HAVE ACCESS TO TE ROW
              if (node.data.id === id && node.data.access) {
                // SET TO TRUE IF HAVE ACCESS
                ifUserHaveAccesstoTask = true;
                // MOVE TASK TO MIDDLE CENTER
                that.gridApi.ensureIndexVisible(node.rowIndex, 'middle');
                node.setSelected(true, true);
                resolve(node)
              }
            });
            // CHECK IF USER SELECTED TASK WITH ACCESS IF NOT SELECT FIRST TASK WITH ACCESS
            if (!ifUserHaveAccesstoTask) {
              const accessedRows = that.rowData.filter(val => val.access);
              if(accessedRows.length) {
                this.selectCreatedTask(accessedRows[0].id)
              }
            }
          })
        }catch (err) {
          console.log(err)
        }
      },
      selectCreatedTaskByRightClick(id) {
        return new Promise ((resolve, reject) => {
          this.gridApi.forEachNode(function (node, index) {
            // CHECK IF USER HAVE ACCESS TO TE ROW
            if (node.data.id === id && node.data.access) {
              // SET TO TRUE IF HAVE ACCESS
              node.setSelected(true);
              resolve(node)
            }
          });
        })
      },
      // selectCreatedTask1(id) {
      // console.log(this.gridApi.getSelectedRows())
      // alert('hello')
      // this.rowData = []
      // console.log(this.gridApi.getSelectedRows())

      // let that = this
      // this.gridApi.forEachNode(function (node) {
      //   console.log("NODE DATA", node)
      //   console.log("NODE DATA ID COMPARE", id)
      //   if (node.data.id === id) {
      //     that.gridApi.ensureIndexVisible(node.rowIndex, 'middle')
      //     node.setSelected(true);
      //     console.log("NODE SELECTED")
      //   }
      // });
      // },
      openInfo(active, id) {
        this.activeInfoTab = active;
        this.getProjectInfo(id);
      },
      find(array, value) {
        console.log("ARRRAY", array, value)
        for (var i = 0; i < array.length; i++) {
          if (array[i].id == value) return true;
        }
        return false
      },
      onRowDragMove(event) {
        setPotentialParentForNode(event.api, event.overNode);
      },
      onRowDragLeave(event) {
        setPotentialParentForNode(event.api, null);
      },
      onRowDragEnd(event) {
        // CHECK IF DROP TASK TO ITSELF
        if (event.node.id === potentialParent.id) {
          setPotentialParentForNode(event.api, null);
          return
        }

        // CHECK IF USER HAVE ACCESS TO POTENTIAL PARENT
        if(!potentialParent.data.access) {
          setPotentialParentForNode(event.api, null);
          this.notification("Info", "No access", "info");
          return
        }

        this.potentialParent = potentialParent;
        this.event = event;

        switch(potentialParent.data.type) {
          case 'project':
            this.notification("Info", "DnD Action not allowed for project task", "info");
            setPotentialParentForNode(event.api, null);
            // this.openActionModalForProject(event);
          break;
          case 'masterTask':
            // check if potential parent is parent of moved task
            if (potentialParent.id === event.node.parent.id) this.openActionModalForStartedTasks(event);

            else this.openActionModalForMasterTask(event);
            break;
          case 'task':
            // IF TASK NOT STARTED
            if (potentialParent.data.taskStatus === 1) this.openActionModalForMasterTask(event);
            // IF TASK STARTED
            else this.openActionModalForStartedTasks(event)
        }
      },
      openActionModalForProject(event){
        gridMessageBox.alert('', 'Action', {
          confirmButtonText: 'Add to parent',
          center: true
        })
          .then(() => {
          // when select
             this.createParentTask('0');
          // disable highlighted when click btn
            setPotentialParentForNode(event.api, null);
          })
          .catch(action => {
          // when select move task
            setPotentialParentForNode(event.api, null);
          })
      },
      openActionModalForMasterTask(event){
        gridMessageBox.confirm('', 'Action', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Add to parent',
          cancelButtonText: 'Move Task',
          center: true
        })
         .then(() => {
           // check if user have permissions to move tasks
           if (!this.projectPermission.moveTask){
             this.notification("Notification", "User Dont have permission to move task", "info");
             setPotentialParentForNode(event.api, null);
            return
           }

           // when select
           if(this.potentialParent.id !== 0){
             this.createParentTask('0')
           }
           // disable highlighted when click btn
           setPotentialParentForNode(event.api, null);
         })
         .catch(action => {
           // check if user have permissions to move tasks
           if (!this.projectPermission.moveTask){
             this.notification("Notification", "User Dont have permission to move task", "info");
             setPotentialParentForNode(event.api, null);
             return
           }

           // when select move task
            if (action === 'cancel'){
              this.createParentTask('1')
           }
           // disable highlighted when click btn
           setPotentialParentForNode(event.api, null);
         })
      },
      openActionModalForStartedTasks(event){
        gridMessageBox.alert('', 'Action', {
          confirmButtonText: 'Move Task',
          center: true
        })
                .then(() => {
                  // when select
                  this.createParentTask('1');
                  // disable highlighted when click btn
                  setPotentialParentForNode(event.api, null);
                })
                .catch(action => {
                  // when select move task
                  setPotentialParentForNode(event.api, null);
                })
      },
      createParentTask(state){
        const potentialParent = this.potentialParent
        console.log('potentialParent', potentialParent)
        const event = this.event
        if (!potentialParent) {
          return;
        }else if(potentialParent.data.type === "task" && potentialParent.data.taskStatus === 2 && state === '0' ||
                potentialParent.data.type === "task" && potentialParent.data.taskStatus === 5 && state === '0'){
          // this.$refs.dragEnd.close()
          this.notification("Notification", "Task already started", "info");
          setPotentialParentForNode(event.api, null);
          return
        }else if(potentialParent.data.timerCount && state === '0'){
          // this.$refs.dragEnd.close()
          this.notification("Notification", "STOP TIMER", "info");
          setPotentialParentForNode(event.api, null);
          return
        }
        console.log(potentialParent, 'BOOOOOOM');
        let parentId = '';
        if (potentialParent.id === 0) {
          parentId = null
        } else {
          parentId = potentialParent.id
        }
        var movingData = event.node.data;
        var newParentPath = potentialParent.data ? potentialParent.data.filePath : [];
        var needToChangeParent = !arePathsEqual(newParentPath, movingData.filePath);
        var invalidMode = isSelectionParentOfTarget(event.node, potentialParent);
        if (invalidMode) {
          console.log("invalid move");
        }
        let isPutChild = true;
        for (let i = 0; i < potentialParent.data.filePath.length; i++) {
          if(movingData.id.toString() === potentialParent.data.filePath[i]){
            // this.$refs.dragEnd.close()
            this.notification("Notification", "YOU SHALL NOT PASS!!", "info");
            console.log(movingData, 'MOVING DATA');
            console.log(potentialParent, 'Potential PARENT');
            isPutChild = false
          }
        }

        console.log(isPutChild, 'IS PUT CHILD');
        if (needToChangeParent && !invalidMode && isPutChild) {
          var updatedRows = [];
          moveToPath(newParentPath, event.node, updatedRows);
          // TODO COMMIT 28/02/2020
          this.gridApi.updateRowData({update: updatedRows});
          this.gridApi.clearFocusedCell();
          console.log('potentialParent.data.orderIndex', state);
          this.dragTaskEnd(this.$route.query.companyId, Number(this.$route.query.projectId), movingData.id, parentId, state, potentialParent.data.orderIndex)
          // this.notification("Success", "CHANGE PARENT TASK", "success");
        }
        setPotentialParentForNode(event.api, null);
      },
      // moveTask(){
      //   alert('Move TASK')
      // },
      dragTaskEnd(companyId, projectId, selectedRowId, parentId, state, orderIndex) {
        // alert(selectedRowId)
        // this.$refs.dragEnd.close()
        if(state === '1'){
          // check if in same tree drop
          const parentOfHoveredTask = this.rowData.filter(val => val.id === parentId)[0];
          parentId = parentOfHoveredTask.parentProjectTaskId;

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/projectTasks/changeParent?companyId=${companyId}&projectId=${projectId}&projectTaskId=${selectedRowId}&move=${state}&projectTaskOrderIndex=${orderIndex}`, {
            newParentProjectTaskId: parentId
          })
                  .then(response => {
                    if(response.data.success){
                      this.notification("Success", "Moved Task", "success");
                      loader.hide();
                      // this.$refs.dragEnd.close();
                      this.setProjectRowData(projectId, false, selectedRowId)
                    }
                    console.log('AFTER DRAG TASK');
                    loader.hide()
                  })
                  .catch(error => {
                    loader.hide()
                    // this.notification("Notification", error.response.data.message, "info")
                    // if (error.response.data.statusCode == 401) {
                    //   localStorage.clear();
                    //   this.$router.push('/login')
                    // }
                    console.log('An error occurred:', error);
                  })
        }else{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/projectTasks/changeParent?companyId=${companyId}&projectId=${projectId}&projectTaskId=${selectedRowId}&move=${state}&projectTaskOrderIndex=${orderIndex}`, {
            newParentProjectTaskId: parentId
          })
                  .then(response => {
                    if(response.data.success){
                      loader.hide()
                      this.notification("Success", "TASK ADDED TO PARENT", "success");
                      // this.$refs.dragEnd.close();
                      this.setProjectRowData(projectId, false, selectedRowId)
                    }
                    console.log('AFTER DRAG TASK');
                    loader.hide()
                  })
                  .catch(error => {
                    loader.hide()
                    // this.notification("Notification", error.response.data.message, "warning")
                    // if (error.response.data.statusCode == 401) {
                    //   localStorage.clear();
                    //   this.$router.push('/login')
                    // }
                    console.log('An error occurred:', error);
                  })
        }
      },
      onGridReady(params) {
        params.api.sizeColumnsToFit();
        // this.gridColumnApi.moveColumns(["myIndex"], 0);
      },
      onSelectionChanged(api) {

        // check if really row selected or deselectAll()
        if (!this.gridApi.getSelectedRows().length) return;

        this.disabledBtn = false;
        this.selectedRows = this.gridApi.getSelectedRows();
        this.selectedRow = this.selectedRows[0];
        // this.$route.query.projectId = this.selectedRow.projectId
        // this.$route.query.taskId = this.selectedRow.id
        this.activeProjectId = this.selectedRow.projectId;
        let data = {'taskId': this.selectedRow.id, 'projectId': this.activeProjectId};
        // TODO убрал активный проект
        // this.activeProjectId

        this.$router.replace(`/projects?companyId=${this.$route.query.companyId}&projectId=${data.projectId}&taskId=${data.taskId}`);

        console.log('SELECTED ROWS', this.selectedRows);
        console.log('SELECTED ROW', this.selectedRow);
        if (this.selectedRow.type === 'project') {
          this.isProject = true;
          this.getProjectLayout(this.$route.query.companyId, this.selectedRow.projectId);
          if(this.activeTab === 'taskInfoTab'){
            this.activeTab = 'first'
          }
          if(this.activeTab === 'four'){
            this.activeTab = 'third'
          }
          if(this.activeTab === 'projectTaskCommentTab'){
            this.activeTab = 'projectCommentTab'
          }
          if(this.activeTab === 'second'){
            this.activeTab = 'first'
          }
          if(this.activeTab === 'eight'){
            this.activeTab = 'seven'
          }
          if(this.activeTab === 'twelve'){
            this.activeTab = 'eleven'
          }
          if(this.activeTab === 'ten'){
            this.activeTab = 'nine'
          }
          // Documents
          // if(this.activeTab === 'fourteen'){
          //   this.activeTab = 'first'
          // }
          // Estimate
          // if(this.activeTab === 'estimate'){
          //   if (this.activeEstimateTab == 'materialTask') {
          //     this.activeEstimateTab = 'materialProject'
          //   }
          //   // TODO materialProject -> timeProject
          //   if (this.activeEstimateTab == 'timeTask') {
          //     this.activeEstimateTab = 'materialProject'
          //   }
          // }

          // accountTHINK
          if(this.activeTab === 'accountTHINK'){
            if (this.activeAccountTHINKTab == 'estimateTask') {
              this.activeAccountTHINKTab = 'estimateProject'
            }
            // TODO materialProject -> timeProject
            if (this.activeAccountTHINKTab == 'purchaseTask') {
              this.activeAccountTHINKTab = 'purchaseProject'
              let loader = this.$loading.show();
              this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId})
              this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
              loader.hide()
            }
          }

          // scm
          if(this.activeTab === 'scm'){
            if (this.activeSCMTab == 'purchaseTask') {
              this.activeSCMTab = 'purchaseProject'
              let loader = this.$loading.show();
              this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId})
              this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
              loader.hide()
            }
            if (this.activeSCMTab == 'receiveReportsTask') {
              this.activeSCMTab = 'receiveReportsProject'
            }
            if (this.activeSCMTab == 'inspectionReportsTask') {
              this.activeSCMTab = 'inspectionReportsProject'
            }
            if (this.activeSCMTab == 'requestVendorInvoiceTask') {
              this.activeSCMTab = 'requestVendorInvoiceProject'
            }
            if (this.activeSCMTab == 'vendorInvoiceTask') {
              this.activeSCMTab = 'vendorInvoiceProject'
            }

            if (this.activeSCMTab == 'purchasingControlTask') {
              this.activeSCMTab = 'purchasingControlProject'
            }
            if (this.activeSCMTab == 'managingTask') {
              this.activeSCMTab = 'managingProject'
            }
          }

          // crm
          else if (this.activeTab === 'crm') {
            if(this.activeCRMTab === 'estimateTask'){
              this.activeCRMTab = 'estimateProject'
            }
            if(this.activeCRMTab === 'quotationTask'){
              this.activeCRMTab = 'quotationProject'
            }
            if(this.activeCRMTab === 'salesOrderTask'){
              this.activeCRMTab = 'salesOrderProject'
            }
            if(this.activeCRMTab === 'invoiceTask'){
              this.activeCRMTab = 'invoiceProject'
            }

            if(this.activeCRMTab === 'sellingTask'){
              this.activeCRMTab = 'sellingProject'
            }
            if(this.activeCRMTab === 'deliveringTask'){
              this.activeCRMTab = 'deliveringProject'
            }
            if (this.activeCRMTab == 'managingTask') {
              this.activeCRMTab = 'managingProject'
            }
          }

          // aTHINK
          else if (this.activeTab === 'aTHINK') {
            // if(this.activeAccountTHINKTab === 'budget'){
            //   this.activeAccountTHINKTab = 'budget'
            // }
            if(this.activeAccountTHINKTab === 'cashAdvancesTask'){
              this.activeAccountTHINKTab = 'cashAdvancesProject'
            }
            if(this.activeAccountTHINKTab === 'expensesTask'){
              this.activeAccountTHINKTab = 'expensesProject'
            }
            // if(this.activeAccountTHINKTab === 'receivePaymentTask'){
            //   this.activeAccountTHINKTab = 'receivePaymentProject'
            // }
            if(this.activeAccountTHINKTab === 'payVendorsTask'){
              this.activeAccountTHINKTab = 'payVendorsProject'
            }
          }
          switch (this.activeTab) {
            case 'first':
              console.log("INFO PROJECT TAB SELECTED")
              switch (this.activeInfoTab) {
                case 'first':
                  console.log("PROJECT DETAIL")
                  this.getProjectInfo(this.selectedRow.id);
                  break;
                case 'second':
                  console.log("PROJECT TEAM TAB SELECTED")
                  // this.$store.dispatch('getCostType')
                  break;
                case 'third':
                  // this.$store.dispatch('getProjectClientsGridData')
                  break;
                case 'four':
                  this.$store.dispatch('getProjectVendorsGridData')
                  break;
                case 'five':
                  this.$store.dispatch('getProjectHistory')
                  break;
                case 'about':
                  this.$store.dispatch('about', 'project')
                  break;
                case 'toDo':
                  // TODO
                  break;
                case 'budget':
                  // TODO
                  this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'});
                  break;
                case 'permissions':
                  this.$store.dispatch('getProjectPermissionsList', this.$route.query.projectId);
                  this.$refs.infoTab.loadPermissionData();
                  break;
                default:
              }
              break;
            case 'second':
              console.log("PROJECT PROGRESS TAB SELECTED")
              break;
            case 'third':
              console.log("PROJECT FILES TAB SELECTED")
              this.$store.dispatch('getProjectFiles')
              break;
            case 'projectCommentTab':
              console.log("PROJECT COMMENTS TAB SELECTED")
              this.$store.dispatch('getProjectComments').then(list => {
                if (list.length && this.getStateId) {
                  const selectedComment = list.filter(val => val.id === this.getStateId);
                  if (selectedComment.length) this.$refs.projectCommentTab.selectActiveCommentNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'seven':
              this.$store.dispatch('getMessagesDirectories', {'type': 'project', 'projectId': this.activeProjectId})
              this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.activeProjectId, 'projectMessageType': '1'})
              break;
            case 'nine':
              console.log("PROJECT MEETINGS TAB SELECTED")
              this.getProjectInfo()
              this.$store.dispatch('getMeetings', {companyId: this.$route.query.companyId, parentId: this.$route.query.projectId, typeId: 1, taskId: null, page: 1}).then(list => {
                if (list.length && this.getStateId) {
                  const selectedMeeting = list.filter(val => val.id === this.getStateId);
                  if (selectedMeeting.length) this.$refs.projectMeetingTab.selectActiveMeetingNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'eleven':
              console.log("PROJECT HISTORY TAB SELECTED")
              this.$store.dispatch('getProjectHistory')
              break;
                  // case 'estimate':
                  //   switch (this.activeEstimateTab) {
                  //     case 'timeProject':
                  //       // TODO
                  //       break;
                  //     case 'materialProject':
                  //       this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'})
                  //       break;
                  //   }
                  //   break;
            case 'accountTHINK':
              switch (this.activeAccountTHINKTab) {
                case 'estimateProject':
                  // TODO
                  this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'})
                  break;
                case 'purchaseProject':
                  this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId})
                  this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
                  break;
              }
              break;
            case 'scm':
              switch (this.activeSCMTab) {
                case 'purchaseProject':
                  this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId})
                  this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
                  break;
                case 'receiveReportsProject':
                  // TODO
                  break;
                case 'inspectionReportsProject':
                  // TODO
                  break;
                case 'requestVendorInvoiceProject':
                  // TODO
                  break;
                case 'vendorInvoiceProject':
                  // TODO
                  break;
                case 'purchasingControlProject':
                  // TODO
                  break;
                case 'managingProject':
                  // TODO
                  break;
              }
              break;
            case 'crm':
              switch (this.activeCRMTab) {
                case 'estimateProject':
                  // TODO
                  break;
                case 'quotationProject':
                  // TODO
                  break;
                case 'salesOrderProject':
                  // TODO
                  break;
                case 'invoiceProject':
                  // TODO
                  break;
                case 'sellingProject':
                  // TODO
                  break;
                case 'deliveringProject':
                  // TODO
                  break;
                case 'managingProject':
                  // TODO
                  break;
              }
              break;
            case 'aTHINK':
              switch (this.activeAccountTHINKTab) {
                case 'cashAdvancesProject':
                  // TODO
                  break;
                case 'expensesProject':
                  // TODO
                  break;
                case 'receivePaymentProject':
                  // TODO
                  break;
                case 'payVendorsProject':
                  // TODO
                  break;
                case 'budget':
                  // TODO
                  this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'})
                  break;
              }
              break;
          }
          // this.activeInfoTab = 'first';
        } else if(this.selectedRow.type === 'masterTask' || this.selectedRow.type === 'task'){
          this.isProject = false;
          this.getTaskLayout(this.$route.query.companyId, this.selectedRow.projectId, this.selectedRow.id);
          if(this.activeTab === 'first'){
            this.activeInfoTab = 'first'
            this.activeTab = 'taskInfoTab'
          }
          if(this.activeTab === 'third'){
            this.activeTab = 'four'
          }
          if(this.activeTab === 'projectCommentTab'){
            this.activeTab = 'projectTaskCommentTab'
          }
          if(this.activeTab === 'seven'){
            this.activeTab = 'eight'
          }
          if(this.activeTab === 'nine'){
            this.activeTab = 'ten'
          }
          if(this.activeTab === 'eleven'){
            this.activeTab = 'twelve'
          }
          if(this.activeTab === 'second' && this.selectedRow.type === 'masterTask'){
            this.activeTab = 'first'
          }
          // if permission selected before
          // if(this.activeTab === 'first' && this.activeInfoTab === 'permissions'){
          //   this.activeInfoTab = 'first'
          //   this.activeInfoTaskTab = 'first'
          // }
          // Documents
          // if(this.activeTab === 'thirteen'){
          //   this.activeTab = 'fourteen'
          // }

          // Estimate
          // if(this.activeTab === 'estimate'){
          //   if (this.activeEstimateTab == 'materialProject') {
          //     this.activeEstimateTab = 'materialTask'
          //   }
          //   if (this.activeEstimateTab == 'timeProject') {
          //     this.activeEstimateTab = 'timeTask'
          //   }
          // }

          // accountTHINK
          if(this.activeTab === 'accountTHINK'){
            if (this.activeAccountTHINKTab == 'estimateProject') {
              this.activeAccountTHINKTab = 'estimateTask'
            }
            // TODO materialProject -> timeProject
            if (this.activeAccountTHINKTab == 'purchaseProject') {
              this.activeAccountTHINKTab = 'purchaseTask'
              let loader = this.$loading.show();
              this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
              this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
              loader.hide()
            }
          }

          // scm
          if(this.activeTab === 'scm'){
            if (this.activeSCMTab == 'purchaseProject') {
              this.activeSCMTab = 'purchaseTask'
              let loader = this.$loading.show();
              this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
              this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
              loader.hide()
            }
            if (this.activeSCMTab == 'receiveReportsProject') {
              this.activeSCMTab = 'receiveReportsTask'
            }
            if (this.activeSCMTab == 'inspectionReportsProject') {
              this.activeSCMTab = 'inspectionReportsTask'
            }
            if (this.activeSCMTab == 'requestVendorInvoiceProject') {
              this.activeSCMTab = 'requestVendorInvoiceTask'
            }
            if (this.activeSCMTab == 'vendorInvoiceProject') {
              this.activeSCMTab = 'vendorInvoiceTask'
            }

            if (this.activeSCMTab == 'purchasingControlProject') {
              this.activeSCMTab = 'purchasingControlTask'
            }
            if (this.activeSCMTab == 'managingProject') {
              this.activeSCMTab = 'managingTask'
            }
          }

          // crm
          else if (this.activeTab === 'crm') {
            if(this.activeCRMTab === 'estimateProject'){
              this.activeCRMTab = 'estimateTask'
            }
            if(this.activeCRMTab === 'quotationProject'){
              this.activeCRMTab = 'quotationTask'
            }
            if(this.activeCRMTab === 'salesOrderProject'){
              this.activeCRMTab = 'salesOrderTask'
            }
            if(this.activeCRMTab === 'invoiceProject'){
              this.activeCRMTab = 'invoiceTask'
            }

            if(this.activeCRMTab === 'sellingProject'){
              this.activeCRMTab = 'sellingTask'
            }
            if(this.activeCRMTab === 'deliveringProject'){
              this.activeCRMTab = 'deliveringTask'
            }
            if (this.activeCRMTab == 'managingProject') {
              this.activeCRMTab = 'managingTask'
            }
          }

          // aTHINK
          else if (this.activeTab === 'aTHINK') {
            if(this.activeAccountTHINKTab === 'cashAdvancesProject'){
              this.activeAccountTHINKTab = 'cashAdvancesTask'
            }
            if(this.activeAccountTHINKTab === 'expensesProject'){
              this.activeAccountTHINKTab = 'expensesTask'
            }
            if(this.activeAccountTHINKTab === 'receivePaymentProject'){
              this.activeAccountTHINKTab = 'receivePaymentTask'
            }
            if(this.activeAccountTHINKTab === 'payVendorsProject'){
              this.activeAccountTHINKTab = 'payVendorsTask'
            }
          }

          switch (this.activeTab) {
            case 'taskInfoTab':
              switch (this.activeTaskInfoTab) {
                case 'first':
                  this.getTaskInfo();
                  break;
                case 'second':
                  console.log("TASK TEAM")
                  this.$store.dispatch('getCostType')
                  // this.$store.dispatch('getRateReport')
                  break;
                case 'third':
                  // this.$store.dispatch('getTaskClientsGridData', this.selectedRow.id)
                  break;
                case 'four':
                  this.$store.dispatch('getTaskVendorsGridData', this.selectedRow.id)
                  break;
                case 'five':
                  this.$store.dispatch('getProjectTaskHistory')
                  break;
                case 'about':
                  this.$store.dispatch('about', 'projectTask')
                  break;
                case 'toDo':
                  this.$store.dispatch('toDo', 'project');
                  break;
                case 'progress':
                  if (this.selectedRow.type === 'masterTask') {
                    this.activeTaskInfoTab = 'first';
                    this.getTaskInfo();
                  } else {
                    this.getProgressesList(data);
                  this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRow.id})
                  }
                  break;
                case 'documents':
                  this.$store.dispatch('getDocuments', this.selectedRow.id).then(data => {
                    if (this.getStateId && this.getStateId === 'sop' ||
                        this.getStateId && this.getStateId === 'policy' ||
                        this.getStateId && this.getStateId === 'healthsafety' ||
                        this.getStateId && this.getStateId === 'riskAssesment' ||
                        this.getStateId && this.getStateId === 'general' ||
                        this.getStateId && this.getStateId === 'commercial' ||
                        this.getStateId && this.getStateId === 'envirenmental') {
                        this.$refs['taskInfoTab'].$refs.docs.selectTab(this.getStateId);
                        this.$store.dispatch('setStateId', null)
                    } else {
                      this.$store.dispatch('setStateId', null)
                    }
                  });
                  break;
                case 'budget':
                  // TODO
                  this.$store.dispatch('getCostType')
                  this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
                  break;
                default:
              }
              break;
            case 'second':
              console.log("TASK PROGRESS TAB SELECTED")
              this.getProgressesList(data);
              this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRow.id})
              break;
            case 'four':
              console.log("TASK FILES TAB SELECTED")
              this.$store.dispatch('getTaskFiles', this.selectedRow.id)
              break;
            case 'projectTaskCommentTab':
              this.$store.dispatch('getProjectTaskComments', data).then(list => {
                if (list.length && this.getStateId){
                  const selectedComment = list.filter(val => val.id === this.getStateId);
                  if (selectedComment.length) this.$refs.projectTaskCommentTab.selectActiveCommentNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                } else {
                  this.$store.dispatch('setStateId', null)
                }
              });
              break;
            case 'eight':
              if(this.$refs.MessagesTask){
                this.$refs.MessagesTask.currentTabComponent = 'MessagesReceived'
              }
              this.$store.dispatch('getMessagesDirectories', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id})
              this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
              break;
            case 'ten':
                this.getTaskInfo()
                this.$store.dispatch('getMeetings',{typeId: 4, companyId: this.$route.query.companyId, taskId: this.selectedRow.id, parentId: this.activeProjectId, page: 1}).then(list => {
                if (list.length && this.getStateId){
                  const selectedMeeting = list.filter(val => val.id === this.getStateId);
                  if (selectedMeeting.length) this.$refs.projectTaskMeetingTab.selectActiveMeetingNode(this.getStateId);
                  this.$store.dispatch('setStateId', null)
                }else {
                  this.$store.dispatch('setStateId', null)
                }
              })
              break;
            case 'twelve':
              this.$store.dispatch('getProjectTaskHistory')
              break;
            // case 'fourteen':
            //   this.$store.dispatch('getDocuments', this.selectedRow.id)
            //   break;
                  // case 'estimate':
                  //   switch (this.activeEstimateTab) {
                  //     case 'timeTask':
                  //       this.$store.dispatch('getCostType')
                  //       break;
                  //     case 'materialTask':
                  //       this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
                  //       break;
                  //   }
                  //   break;
            case 'accountTHINK':
              switch (this.activeAccountTHINKTab) {
                case 'estimateTask':
                  // TODO
                  this.$store.dispatch('getCostType')
                  this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
                  break;
                case 'purchaseTask':
                  this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
                  this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
                  break;
              }
              break;
            case 'scm':
              switch (this.activeSCMTab) {
                case 'purchaseTask':
                  this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
                  this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
                  break;
                case 'receiveReportsTask':
                  // TODO
                  break;
                case 'inspectionReportsTask':
                  // TODO
                  break;
                case 'requestVendorInvoiceTask':
                  // TODO
                  break;
                case 'vendorInvoiceTask':
                  // TODO
                  break;
                case 'managingTask':
                  // TODO
                  break;
              }
              break;
            case 'crm':
              switch (this.activeCRMTab) {
                case 'estimateTask':
                  // TODO
                  break;
                case 'quotationTask':
                  // TODO
                  break;
                case 'salesOrderTask':
                  // TODO
                  break;
                case 'invoiceTask':
                  // TODO
                  break;
                case 'sellingTask':
                  // TODO
                  break;
                case 'deliveringTask':
                  // TODO
                  break;
                case 'managingTask':
                  // TODO
                  break;
              }
              break;
            case 'aTHINK':
              switch (this.activeAccountTHINKTab) {
                case 'cashAdvancesTask':
                  // TODO
                  break;
                case 'expensesTask':
                  // TODO
                  break;
                case 'receivePaymentTask':
                  // TODO
                  break;
                case 'payVendorsTask':
                  // TODO
                  break;
                case 'budget':
                  // TODO
                  this.$store.dispatch('getCostType');
                  this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
                  break;
              }
              break;
          }
        }
      },
      getProjectLayout(companyId, projectId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projectLayout/getData?companyId=${companyId}&projectId=${projectId}`)
                  .then(response => {
                    this.bookmarkListProject = response.data.bookmarks;
                    this.projectPermission = response.data.permission;

                    //check drag and drop from permissions
                    if (this.isWorkDay || this.ownTasks) this.gridApi.setSuppressRowDrag(true);
                    else this.gridApi.setSuppressRowDrag(!this.projectPermission.moveTask);

                    if (response.data.document) {
                      // check if document set later
                      if (response.data.document.date) {
                        this.openLaterConfirmDocumentModal(response.data.document);
                        loader.hide();
                        return
                      }
                      // get document data to redirect
                      this.documentList.companyId = response.data.document.companyId;
                      this.documentList.projectId = response.data.document.projectId;
                      this.documentList.projectTaskId = response.data.document.projectTaskId;
                      this.documentList.taskType = response.data.document.taskType;

                      switch (response.data.document.type) {
                        case 'riskassesment':
                          this.documentList.type = 'commercial';
                          this.documentList.level = response.data.document['riskassesment.level'];
                          break;
                        case'envirenmental':
                          this.documentList.type = 'general';
                          this.documentList.level = response.data.document['envirenmental.level'];
                          break;
                        case 'sop':
                          this.documentList.type = response.data.document.type;
                          this.documentList.level = response.data.document['sop.level'];
                          break;
                        case 'policy':
                          this.documentList.type = response.data.document.type;
                          this.documentList.level = response.data.document['policy.level'];
                          break;
                        case 'healthsafety':
                          this.documentList.type = response.data.document.type;
                          this.documentList.level = response.data.document['healthsafety.level'];
                          break;
                      }

                      // this.documentList.type = response.data.document.type
                      this.signInDocumentOpenModal(response.data.document.id);

                    }else {
                      if (this.$session.has('documentId')) this.$session.remove('documentId');
                    }
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      getTaskLayout(companyId, projectId, taskId){
        return new Promise ((resolve, reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
                  .post(`/api/v1/projectTaskLayout/getData?companyId=${companyId}&projectId=${projectId}&projectTaskId=${taskId}`)
                  .then(response => {
                    this.bookmarkList = response.data.data.bookmarks;
                    this.projectPermission = response.data.permission;

                    //check drag and drop from permissions
                    if (this.isWorkDay || this.ownTasks) this.gridApi.setSuppressRowDrag(true);
                    else this.gridApi.setSuppressRowDrag(!this.projectPermission.moveTask);

                    if (response.data.document) {
                      // check if document set later
                      if (response.data.document.date) {
                        this.openLaterConfirmDocumentModal(response.data.document);
                        loader.hide();
                        return
                      }
                      this.documentList.companyId = response.data.document.companyId;
                      this.documentList.projectId = response.data.document.projectId;
                      this.documentList.projectTaskId = response.data.document.projectTaskId;
                      this.documentList.taskType = response.data.document.taskType;

                      switch (response.data.document.type){
                        case 'riskassesment':
                          this.documentList.type = 'commercial';
                          this.documentList.level = response.data.document['riskassesment.level'];
                          break;
                        case'envirenmental':
                          this.documentList.type = 'general';
                          this.documentList.level = response.data.document['envirenmental.level'];
                          break;
                        case 'sop':
                          this.documentList.type = response.data.document.type;
                          this.documentList.level = response.data.document['sop.level'];
                          break;
                        case 'policy':
                          this.documentList.type = response.data.document.type;
                          this.documentList.level = response.data.document['policy.level'];
                          break;
                        case 'healthsafety':
                          this.documentList.type = response.data.document.type;
                          this.documentList.level = response.data.document['healthsafety.level'];
                          break;
                      }

                      if (!this.$session.has('documentId')) {

                        this.signInDocumentOpenModal(response.data.document.id);

                      } else {
                        const documentId = this.$session.get('documentId');
                        const documentIdFromRequest = response.data.document.id;

                        if (documentId !== documentIdFromRequest) {
                          this.signInDocumentOpenModal(response.data.document.id);
                        } else {
                          this.$session.remove('documentId')
                        }
                      }
                    } else {
                      if (this.$session.has('documentId')) this.$session.remove('documentId');
                    }
                    loader.hide()
                  })
                  .catch(error => {
                    console.log('An error occurred:', error);
                    loader.hide()
                  });
        })
      },
      signInDocumentOpenModal(documentId){
        this.$alert(this.$t('modal_documents_youHaveDocumentsThatRequireAction'), this.capitalizeFirstLetter(this.documentList.type), {
          confirmButtonText: this.$t('general_ok'),
          showClose: false,
          callback: action => {
            switch (action){
              case 'confirm':
                this.$session.set('documentId', documentId);
                this.$store.dispatch('setStateId', this.documentList.type);
                this.signDocument();
                break;
              case 'cancel':
                this.$session.remove('documentId');
                break
            }
          }
        });
      },
      openLaterConfirmDocumentModal(document){
        this.$refs.laterDocumentModal.openModal(document)
      },
      getProjectInfo() {
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios.post(`/api/v1/projects/info?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
        //         .then(response => {
        //           this.selectedProjectForInfo = response.data.info
        //           // if (this.selectedRow.type === 'project') {
        //           //   this.isProject = true
        //           // }
        //           if (response.data.info.startDate.toString().length < 8) {
        //             this.selectedProjectForInfo.startDate = '0' + response.data.info.startDate.toString()
        //             this.selectedProjectForInfo.startDate = moment(response.data.info.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           } else {
        //             this.selectedProjectForInfo.startDate = moment(response.data.info.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           }
        //           if (response.data.info.deadlineDate.toString().length < 8) {
        //             this.selectedProjectForInfo.deadlineDate = '0' + response.data.info.deadlineDate.toString()
        //             this.selectedProjectForInfo.deadlineDate = moment(response.data.info.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           } else {
        //             this.selectedProjectForInfo.deadlineDate = moment(response.data.info.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           }
        //           console.log('SELECTED Project ROW INFO', this.selectedProjectForInfo);
        //         })
        //         .catch(error => {
        //           // if (error.response.data.statusCode == 401) {
        //           //   localStorage.clear();
        //           //   this.$router.push('/login')
        //           // }
        //           console.log('An error occurred:', error);
        //         });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projects/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`)
                .then(response => {
                  console.log('---/projects/extendedInfo', response.data.extendedInfo);
                  response.data.extendedInfo.projectCompanyUserList.sort(function (a, b) {
                    if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectCompanyClientList.sort(function (a, b) {
                    if (a.companyClient.name.toLowerCase() > b.companyClient.name.toLowerCase()) {
                      return 1;
                    }
                    if (a.companyClient.name.toLowerCase() < b.companyClient.name.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectCompanyVendorList.sort(function (a, b) {
                    if (a.companyVendor.name.toLowerCase() > b.companyVendor.name.toLowerCase()) {
                      return 1;
                    }
                    if (a.companyVendor.name.toLowerCase() < b.companyVendor.name.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  this.projectInfo = response.data.extendedInfo

                  // if (response.data.extendedInfo.startDate.toString().length < 8) {
                  //   this.projectInfo.startDate = '0' + response.data.extendedInfo.startDate.toString()
                  //   this.projectInfo.startDate = moment(response.data.extendedInfo.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // } else {
                  //   this.projectInfo.startDate = moment(response.data.extendedInfo.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // }
                  // if (response.data.extendedInfo.deadlineDate.toString().length < 8) {
                  //   this.projectInfo.deadlineDate = '0' + response.data.extendedInfo.deadlineDate.toString()
                  //   this.projectInfo.deadlineDate = moment(response.data.extendedInfo.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // } else {
                  //   this.projectInfo.deadlineDate = moment(response.data.extendedInfo.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // }
                })
                .catch(error => {
                  // if (error.response.data.statusCode == 401) {
                  //   localStorage.clear();
                  //   this.$router.push('/login')
                  // }
                  console.log('An error occurred:', error);
                });
      },
      getTaskInfo() {
        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios.post(`/api/v1/projectTasks/info?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}`)
        //         .then(response => {
        //           this.selectedTaskForInfo = response.data.info
        //           console.log('SELECTED TASK ROW INFO', this.selectedTaskForInfo);
        //           if (response.data.info.startDate.toString().length < 8) {
        //             this.selectedTaskForInfo.startDate = '0' + response.data.info.startDate.toString()
        //             this.selectedTaskForInfo.startDate = moment(response.data.info.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           } else {
        //             this.selectedTaskForInfo.startDate = moment(response.data.info.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           }
        //           if (response.data.info.deadlineDate.toString().length < 8) {
        //             this.selectedTaskForInfo.deadlineDate = '0' + response.data.info.deadlineDate.toString()
        //             this.selectedTaskForInfo.deadlineDate = moment(response.data.info.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           } else {
        //             this.selectedTaskForInfo.deadlineDate = moment(response.data.info.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
        //           }
        //           // console.log("START DATE1!!!!", this.selectedTaskForInfo.deadlineDate)
        //           // console.log("START DATE2!!!!", start)
        //         })
        //         .catch(error => {
        //           // if (error.response.data.statusCode == 401) {
        //           //   localStorage.clear();
        //           //   this.$router.push('/login')
        //           // }
        //           console.log('An error occurred:', error);
        //         });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/extendedInfo?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}`)
                .then(response => {
                  console.log('---UUUUUU', response.data.extendedInfo);
                  response.data.extendedInfo.projectCompanyUserList.sort(function (a, b) {
                    if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectTaskCompanyUserList.sort(function (a, b) {
                    if (a.userFullName.toLowerCase() > b.userFullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.userFullName.toLowerCase() < b.userFullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectTaskCompanyClientList.sort(function (a, b) {
                    if (a.name.toLowerCase() > b.name.toLowerCase()) {
                      return 1;
                    }
                    if (a.name.toLowerCase() < b.name.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectTaskCompanyClientPersonList.sort(function (a, b) {
                    if (a.companyClientPerson.fullName.toLowerCase() > b.companyClientPerson.fullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.companyClientPerson.fullName.toLowerCase() < b.companyClientPerson.fullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectTaskCompanyVendorList.sort(function (a, b) {
                    if (a.name.toLowerCase() > b.name.toLowerCase()) {
                      return 1;
                    }
                    if (a.name.toLowerCase() < b.name.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.projectTaskCompanyVendorPersonList.sort(function (a, b) {
                    if (a.companyVendorPerson.fullName.toLowerCase() > b.companyVendorPerson.fullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.companyVendorPerson.fullName.toLowerCase() < b.companyVendorPerson.fullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.sharedProjectTaskCompanyUserList.sort(function (a, b) {
                    if (a.sharedCompanyUser.user.fullName.toLowerCase() > b.sharedCompanyUser.user.fullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.sharedCompanyUser.user.fullName.toLowerCase() < b.sharedCompanyUser.user.fullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  response.data.extendedInfo.tempSharedProjectTaskCompanyUserList.sort(function (a, b) {
                    if (a.sharedCompanyUser.user.fullName.toLowerCase() > b.sharedCompanyUser.user.fullName.toLowerCase()) {
                      return 1;
                    }
                    if (a.sharedCompanyUser.user.fullName.toLowerCase() < b.sharedCompanyUser.user.fullName.toLowerCase()) {
                      return -1;
                    }
                    return 0;
                  });

                  this.taskInfo = response.data.extendedInfo
                  console.log('response.data.extendedInfo', response.data.extendedInfo)
                  // if (response.data.extendedInfo.startDate.toString().length < 8) {
                  //   this.taskInfo.startDate = '0' + response.data.extendedInfo.startDate.toString()
                  //   this.taskInfo.startDate = moment(response.data.extendedInfo.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // } else {
                  //   this.taskInfo.startDate = moment(response.data.extendedInfo.startDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // }
                  // if (response.data.extendedInfo.deadlineDate.toString().length < 8) {
                  //   this.taskInfo.deadlineDate = '0' + response.data.extendedInfo.deadlineDate.toString()
                  //   this.taskInfo.deadlineDate = moment(response.data.extendedInfo.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // } else {
                  //   this.taskInfo.deadlineDate = moment(response.data.extendedInfo.deadlineDate.toString(), 'DDMMYYYY').format('DD MMMM YYYY')
                  // }
                })
                .catch(error => {
                  // if (error.response.data.statusCode == 401) {
                  //   localStorage.clear();
                  //   this.$router.push('/login')
                  // }
                  console.log('An error occurred:', error);
                });
      },
      getProgressesList(data) {
        this.$store.dispatch('getProgressesList', data).then(list => {
          if (list.length && this.getStateId) {
            const progressItem = list.filter(val => val.id === this.getStateId);
            if (progressItem) {
              this.$refs.taskInfoTab.$refs.projProgressTab.selectActiveProgressNode(this.getStateId);
            } else {
              this.$store.dispatch('setStateId', null)
            }
          }
        })
      },
      // editTaskListOpen(){
      //   let loader = this.$loading.show();
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axiostaskInfo
      //           .post(`/api/v1/projectTasks/directories?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&operation=updateList`)
      //           .then(response => {
      //             this.editTaskList.editAssignedTo = response.data.projectCompanyUserList
      //             this.editTaskList.editedTaskTeam = response.data.projectCompanyUserList
      //             this.$refs.editTaskList.open();
      //             loader.hide()
      //           })
      //           .catch(error => {
      //             console.log('An error occurred:', error);
      //             loader.hide()
      //           });
      // },
      // editTaskListSubmit(){
      //   let projectTaskIdList = []
      //   for (let i = 0; i < this.selectedRows.length; i++){
      //     projectTaskIdList.push(this.selectedRows[i].id)
      //   }
      //   let loader = this.$loading.show();
      //   axios
      //           .post(`/api/v1/projectTasks/updateList?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`, {
      //             projectTaskIdList: projectTaskIdList,
      //             changeCompanyUserList: this.editTaskList.changeEditedTaskTeam,
      //             companyUserIdList: this.editTaskList.editedTaskTeamId,
      //             changeLeaderCompanyUser: this.editTaskList.changeAssignedTo,
      //             leaderCompanyUserId: this.editTaskList.editAssignedToId
      //           })
      //           .then(response => {
      //             this.$refs.editTaskList.close();
      //             this.notification("Success", "Edit task list", "success");
      //             loader.hide()
      //             let id = this.activeProjectId
      //             this.newCreatedProjectTask = response.data.projectTaskId
      //             this.setProjectRowData(id)
      //           })
      //           .catch(error => {
      //             // Handle error.
      //             // this.notification("Notification", error.response.data.message, "warning")
      //             console.log('An error occurred:', error);
      //             // if (error.response.data.message === "invalid_email_value") this.notification("Notification", "Invalid email value", "warning");
      //             // if (error.response.data.message === "invalid_password_value") this.notification("Notification", "Invalid password value", "warning");
      //             loader.hide()
      //           })
      // },
      refreshPurchase(){
        // if(this.activeTab === 'accountTHINK'){
        //   switch(this.activeAccountTHINKTab){
        //     case 'purchaseProject':
        //       this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId})
        //       this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
        //       break;
        //     case 'purchaseTask':
        //       this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
        //       this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
        //       break;
        //   }
        // }

        if(this.activeTab === 'scm'){
          switch(this.activeSCMTab){
            case 'purchaseProject':
              this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId})
              this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId})
              break;
            case 'purchaseTask':
              this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
              this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
              break;
          }
        }
      },
      loadList(projectId){
        this.setProjectRowDataInput(projectId, 'first')
      },
      editTaskListClose(){
        this.editTaskList.changeAssignedTo = false
        this.editTaskList.changeEditedTaskTeam =false
        this.editTaskList.editAssignedTo = []
        this.editTaskList.editedTaskTeam = []
        this.editTaskList.editAssignedToId = null
        this.editTaskList.editedTaskTeamId = []
      },
      closeAddNewTask() {

      },
      shareTask() {
        console.log('---', 'share');
      },
      async removeTask() {
        try {
          if(this.selectedRow.type === 'masterTask') return this.notification(this.$t('general_warning'), this.$t('modal_notification_cantDeleteMasterTask'), "warning");

          // check if current task has documents
          const documents = await this.$store.dispatch('getDocuments', this.selectedRow.id);
          let ifDocumentsAttached = false;
          if (documents.envirenmental || documents.healthsafety || documents.policy || documents.riskAssesment || documents.sop) ifDocumentsAttached = true;

          this.$confirm(ifDocumentsAttached ? this.$t('modal_project_afterDeletingProjectTaskAttachedDocumentsWillBeDeletedTooContinue') : this.$t('modal_project_thisWillPermanentlyDeleteTheProjectTaskContinue'), this.$t('general_warning'), {
            confirmButtonText: this.$t('general_ok'),
            cancelButtonText: this.$t('general_cancel'),
            type: 'info'
          }).then(() => {
            this.$message({
              type: 'success',
              message: this.$t('general_deleteCompleted'),
            });

            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios.post(`/api/v1/projectTasks/delete?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRow.id}`)
                    .then(response => {
                      // this.notification("Success", "Delete project task", "success");
                      console.log('deleted task', response.data);
                      let id = this.activeProjectId;
                      if (response.data.success) {
                        this.setProjectRowDataInput(id, 'first');
                      }
                      loader.hide()
                    })
                    .catch(error => {
                      loader.hide();
                      console.log('An error occurred:', error);
                    });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('general_deleteCanceled'),
            });
          });
        } catch (err){
          console.log(err)
        }
      },
      deleteConfirm() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTasks/delete?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRow.id}`)
                .then(response => {
                  this.notification(this.$t('general_success'), this.$t('general_deleteCompleted'), "success");
                  console.log('deleted task', response.data);
                  let id = this.activeProjectId
                  if (response.data.success) {
                    this.$refs.success.open();
                    setTimeout(() => {
                      this.$refs.success.close();
                    }, 1000);
                    console.log("success");
                    this.setProjectRowData(id, 'first');
                  }
                  loader.hide()
                })
                .catch(error => {
                  loader.hide()
                  // if (error.response.data.statusCode == 401) {
                  //   localStorage.clear();
                  //   this.$router.push('/login')
                  // }
                  console.log('An error occurred:', error);
                });
      },
      saveTaskTree() {
        this.$refs['modal777'].$refs['saveTaskTreeProject'].open()
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      handleClick(tab, event) {
        let data = {'taskId': this.selectedRow.id, 'projectId': this.activeProjectId};
        if(tab.name === 'first'){
          this.activeInfoTab = 'first';
          this.getProjectInfo(this.selectedRow.id);
          this.logRequest('log_p_info')
        }else if (tab.name === 'taskInfoTab') {
          this.activeTaskInfoTab = 'first';
          this.getTaskInfo(this.selectedRow.id);
          this.logRequest('log_p_task_info')
        }else if(tab.name === 'second'){
          this.getProgressesList(data);
          this.$store.dispatch('getTimerList', {projectId: this.activeProjectId, projectTaskId: this.selectedRow.id})
          this.logRequest('log_p_task_progress')
        }else if(tab.name === 'third'){
          this.$store.dispatch('getProjectFiles');
          this.logRequest('log_p_files')
        }else if(tab.name === 'four'){
          this.$store.dispatch('getTaskFiles', this.selectedRow.id);
          this.logRequest('log_p_task_files')
        }else if(tab.name === 'projectCommentTab'){
          this.$store.dispatch('getProjectComments', this.selectedRow.id);
          this.logRequest('log_p_comments')
        }else if(tab.name === 'projectTaskCommentTab'){
          this.$store.dispatch('getProjectTaskComments', data);
          this.logRequest('log_p_task_comments')
        }else if(tab.name === 'seven'){
          this.$store.dispatch('getMessagesList', {'type': 'project', 'projectId': this.activeProjectId, 'projectMessageType': '1'});
          this.$store.dispatch('getMessagesDirectories', {'type': 'project', 'projectId': this.activeProjectId})
          this.logRequest('log_p_messages')
        }else if(tab.name === 'eight'){
          this.$store.dispatch('getMessagesList', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id, 'projectTaskMessageType': '1'})
          this.$store.dispatch('getMessagesDirectories', {'type': 'task', 'projectId': this.activeProjectId, 'projectTaskId': this.selectedRow.id})
          this.logRequest('log_p_task_messages')
        }else if(tab.name === 'nine'){
          this.$store.dispatch('getMeetings', {typeId: 1, companyId: this.$route.query.companyId, taskId: null, parentId: this.activeProjectId, page: 1});
          this.logRequest('log_p_meetings')
        }else if(tab.name === 'ten'){
          this.$store.dispatch('getMeetings', {typeId: 4, companyId: this.$route.query.companyId, taskId: this.selectedRow.id, parentId: this.activeProjectId, page: 1});
          this.logRequest('log_p_task_meetings')
        }else if(tab.name === 'eleven'){
          this.$store.dispatch('getProjectHistory');
          this.logRequest('log_p_history')
        }else if(tab.name === 'twelve'){
          this.$store.dispatch('getProjectTaskHistory');
          this.logRequest('log_p_task_history')
          // }else if(tab.name === 'fourteen'){
        //   this.$store.dispatch('getDocuments', this.selectedRow.id)
        }else if(tab.name === 'estimate'){
          if(this.selectedRow.type === 'project'){
            this.activeEstimateTab = 'materialProject';
            this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'});
            this.logRequest('log_p_estimate')
            // TODO
          }else if(this.selectedRow.type === 'masterTask' || this.selectedRow.type === 'task'){
            this.activeEstimateTab = 'materialTask';
            this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
            this.logRequest('log_p_task_estimate')
          }
        } else if(tab.name === 'accountTHINK') {
          if(this.selectedRow.type === 'project'){
            this.activeAccountTHINKTab = 'estimateProject';
            this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'});
            this.logRequest('log_p_accountTHINK')
          }else if(this.selectedRow.type === 'masterTask' || this.selectedRow.type === 'task'){
            this.activeAccountTHINKTab = 'estimateTask';
            this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'});
            this.logRequest('log_p_task_accountTHINK')
          }
        } else if(tab.name === 'scm') {
          if(this.selectedRow.type === 'project'){
            this.activeSCMTab = 'purchaseProject';
            this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectId',  id: this.selectedRow.projectId});
            this.$store.dispatch('getPurchaseList', {stateId: 'projectId',  id: this.selectedRow.projectId});
            this.logRequest('log_p_scm')
          }else if(this.selectedRow.type === 'masterTask' || this.selectedRow.type === 'task'){
            this.activeSCMTab = 'purchaseTask';
            this.$store.dispatch('getPurchaseOrderList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
            this.$store.dispatch('getPurchaseList', {stateId: 'projectTaskId',  id: this.selectedRow.id})
            this.logRequest('log_p_task_scm')
          }
        } else if (tab.name === 'crm') {
          if(this.selectedRow.type === 'project'){
            this.activeCRMTab = 'sellingProject';
            this.logRequest('log_p_crm')
          }else if(this.selectedRow.type === 'masterTask' || this.selectedRow.type === 'task'){
            this.activeCRMTab = 'sellingTask';
            this.logRequest('log_p_task_crm')
          }
        } else if (tab.name === 'aTHINK') {
          if(this.selectedRow.type === 'project'){
            this.activeAccountTHINKTab = 'budget';
            this.$store.dispatch('getProjectMaterialDirectoriesProj', {id: this.$route.query.taskId, operation: 'create'})
            this.logRequest('log_p_aTHINK')
          }else if(this.selectedRow.type === 'masterTask' || this.selectedRow.type === 'task'){
            this.activeAccountTHINKTab = 'budget';
            this.$store.dispatch('getCostType');
            this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
            this.logRequest('log_p_task_aTHINK')
          }
        }
      },
      async putProjectIntoTable(projectId, regionId, stageId){
        this.valueStages = stageId
        this.valueRegion = regionId
        // Load Project List
        await this.getProjects(this.$route.query.companyId)
        await this.setProjectRowDataInput(projectId)
      },
      closeTaskModal(){
        this.formAddTask.taskName = 'My Task';
        this.formAddTask.aboutThisTask = null;
        this.formAddTask.taskStage = [];
        this.formAddTask.taskStageId = '';
        this.formAddTask.taskPriority = [];
        this.formAddTask.Date = []
        this.formAddTask.taskPriorityId = ''
        this.formAddTask.assignedTo = []
        this.formAddTask.assignedToId = ''
        this.formAddTask.taskTeam = ''
        this.formAddTask.taskTeamId = []
        this.formAddTask.projectClientList = ''
        this.formAddTask.projectClientListId = []
        this.formAddTask.projectVendorList = ''
        this.formAddTask.projectVendorListId = []
        this.formAddTask.typeTask = ''
        this.formAddTask.typeTaskId = ''
        this.$refs['formAddTask'].resetFields()
      },
      inviteUser() {
        this.$refs.inviteUserModal.openModalFromBasic('getProjectList', this.$route.query.projectId, this.selectedRow.id);
      },
      // buildTree(project, projectTaskList, parentProjectTaskId, filePath) {
      //   if (!_.isArray(filePath)) {
      //     filePath = [];
      //   }
      //
      //   var resultProjectTaskTree = [];
      //   // DECLARE MANAGER (LEADER) OF PROJECT
      //   let ifUserManager = false;
      //
      //   if (project) {
      //
      //     var startProject = '';
      //     var endProject = '';
      //     if (project.startDate.toString().length < 8) {
      //       startProject = '0' + project.startDate.toString()
      //     } else {
      //       startProject = project.startDate.toString()
      //     }
      //     if (project.deadlineDate.toString().length < 8) {
      //       endProject = '0' + project.deadlineDate.toString()
      //     } else {
      //       endProject = project.deadlineDate.toString()
      //     }
      //     startProject = moment(startProject, 'DDMMYYYY');
      //     endProject = moment(endProject, 'DDMMYYYY');
      //     var projectDaysTotal = moment.duration(endProject.diff(startProject)).asDays();
      //
      //     var todaysdate = moment();
      //     // console.log("Todays day", todaysdate)
      //     // console.log("POINT", endProject)
      //     var tillProjectEnd = moment.duration(endProject.diff(todaysdate)).asDays();
      //     // console.log("till the project end", tillProjectEnd)
      //
      //     filePath = ['0'];
      //     let leader = {};
      //     //SIMPLE BUILD
      //     if(project.leaderCompanyUser){
      //       leader = project.leaderCompanyUser === null ? null : project.leaderCompanyUser.user;
      //       leader.companyUserId = project.leaderCompanyUser.id
      //       //IF SOCKETS BUILD
      //     }else if(project.leader){
      //       leader = project.leader === null ? null : project.leader.user;
      //       leader.companyUserId = project.leader.id
      //     }
      //
      //     // CHECK USER ACCESS TO PROJECT START
      //     const companyUserId = this.companyLayout.companyUserId;
      //     const even = (element) => element.id === companyUserId;
      //     ifUserManager = project.companyUserList.some(even);
      //     // CHECK IF USER LEADER OF PROJECT NOT JUST MANAGER
      //     if(!ifUserManager && leader.companyUserId === companyUserId) ifUserManager = true;
      //     // CHECK USER ACCESS TO PROJECT END
      //
      //     resultProjectTaskTree.push({
      //       id: 0,
      //       name: project.name,
      //       filePath: filePath,
      //       // daysTotal: Math.floor(projectDaysTotal),
      //       daysTotal: countDaysTotal(project.startDate, project.deadlineDate),
      //       projectId:project.id,
      //       daysRemaning: Math.ceil(tillProjectEnd),
      //       progress: Math.floor(project.progress),
      //       type: 'project',
      //       orderIndex: 0,
      //       access: ifUserManager,
      //       taskStatus: -1,
      //       myType: 'folder',
      //       leader: leader
      //     });
      //   }
      //
      //   for (var index = 0; index < projectTaskList.length; index++) {
      //     if (toId(projectTaskList[index].parentProjectTaskId) == toId(parentProjectTaskId)) {
      //       var newfilePath = filePath.concat([projectTaskList[index].id].toString());
      //       var childElementList = this.buildTree(null, projectTaskList, projectTaskList[index].id, newfilePath);
      //
      //       var startTask = '';
      //       var endTask = '';
      //       if (projectTaskList[index].startDate.toString().length < 8) {
      //         startTask = '0' + projectTaskList[index].startDate.toString()
      //       } else {
      //         startTask = projectTaskList[index].startDate.toString()
      //       }
      //       if (projectTaskList[index].deadlineDate.toString().length < 8) {
      //         endTask = '0' + projectTaskList[index].deadlineDate.toString()
      //       } else {
      //         endTask = projectTaskList[index].deadlineDate.toString()
      //       }
      //
      //       startTask = moment(startTask, 'DDMMYYYY');
      //       endTask = moment(endTask, 'DDMMYYYY');
      //       let myDaysTotal = moment.duration(endTask.diff(startTask)).asDays();
      //
      //       var tillTaskEnd = moment.duration(endTask.diff(todaysdate)).asDays();
      //
      //       if(projectTaskList[index].status === 4 && childElementList.length === 0){
      //         // console.log('projectTaskList[index]', projectTaskList[index])
      //         // console.log('deadlineDate', projectTaskList[index].deadlineDate)
      //         // console.log('MYdeadlineDate', endTask)
      //         // console.log('WHEN WAS HOLDED', projectTaskList[index].endedDate)
      //         var dateString = moment.unix(projectTaskList[index].endedDate).format("DDMMYYYY")
      //         // console.log('MY WHEN WAS HOLDED', Number(dateString))
      //
      //         dateString = moment(dateString, 'DDMMYYYY')
      //         tillTaskEnd = moment.duration(dateString.diff(endTask)).asDays()
      //         console.log('tillTaskEnd', tillTaskEnd)
      //         if(tillTaskEnd > 0){
      //           tillTaskEnd = '(+' + Math.ceil(tillTaskEnd) + ')'
      //         }else{
      //           tillTaskEnd = '(' + Math.ceil(tillTaskEnd) + ')'
      //         }
      //         // console.log('DIFFERENCESSSSSSSS!!!!!!!!!!!!!!!!!!!!!!!!!:::::', tillTaskEnd)
      //       }else{
      //         tillTaskEnd = Math.ceil(tillTaskEnd)
      //       }
      //
      //       // CHECK USER ACCESS TO TASK START
      //       const companyUserId = this.companyLayout.companyUserId;
      //       const even = (element) => element.id === companyUserId;
      //       const ifUserInTaskTeam = projectTaskList[index].taskTeamList.some(even);
      //       console.log('ifUserInTaskTeam', ifUserInTaskTeam, projectTaskList[index].name)
      //       // CHECK USER ACCESS TO TASK END
      //
      //       if (childElementList.length > 0) {
      //         let row = {
      //           id: projectTaskList[index].id,
      //           name: projectTaskList[index].name,
      //           filePath: newfilePath,
      //           allowSharing: projectTaskList[index].allowSharing,
      //           // daysTotal: Math.floor(myDaysTotal),
      //           daysTotal: countDaysTotal(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
      //           projectId:projectTaskList[index].projectId,
      //           orderIndex:projectTaskList[index].orderIndex,
      //           parentProjectTaskId: projectTaskList[index].parentProjectTaskId,
      //           // daysTotal: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
      //           // daysRemaning: daysBetween(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
      //           daysRemaning: tillTaskEnd,
      //           access: ifUserInTaskTeam,
      //           progress: Math.floor(projectTaskList[index].progress),
      //           type: 'masterTask',
      //           sharedCount:projectTaskList[index].sharedCount,
      //           timerCount: projectTaskList[index].timerCount,
      //           taskStatus: projectTaskList[index].status,
      //           myType: 'folder',
      //           leader: projectTaskList[index].leader === null ? null : projectTaskList[index].leader.user
      //         };
      //         resultProjectTaskTree.push(row);
      //
      //         resultProjectTaskTree = resultProjectTaskTree.concat(childElementList);
      //       } else {
      //         let row = {
      //           id: projectTaskList[index].id,
      //           name: projectTaskList[index].name,
      //           filePath: newfilePath,
      //           allowSharing: projectTaskList[index].allowSharing,
      //           // daysTotal: Math.floor(myDaysTotal),
      //           daysTotal: countDaysTotal(projectTaskList[index].startDate, projectTaskList[index].deadlineDate),
      //           projectId:projectTaskList[index].projectId,
      //           orderIndex:projectTaskList[index].orderIndex,
      //           parentProjectTaskId: projectTaskList[index].parentProjectTaskId,
      //           daysRemaning: tillTaskEnd,
      //           access: ifUserInTaskTeam,
      //           progress: Math.floor(projectTaskList[index].progress),
      //           type: 'task',
      //           sharedCount:projectTaskList[index].sharedCount,
      //           timerCount: projectTaskList[index].timerCount,
      //           taskStatus: projectTaskList[index].status,
      //           myType: 'folder',
      //           leader: projectTaskList[index].leader === null ? null : projectTaskList[index].leader.user
      //         };
      //         resultProjectTaskTree.push(row);
      //       }
      //     }
      //   }
      //   for (let i = 0; i < resultProjectTaskTree.length; i++){
      //     resultProjectTaskTree[i].myIndex = i.toString();
      //     // GIVE ACCESS TO MANAGERS OR LEADER
      //     if(ifUserManager){
      //       resultProjectTaskTree[i].access = true
      //     }
      //   }
      //   console.log('resultProjectTaskTree', resultProjectTaskTree, ifUserManager);
      //   return resultProjectTaskTree;
      // },
      buildNewTree(list) {
        console.log('LIST 1', list);
        // console.log('user', this.user);
        // console.log('user', this.companyLayout);
        // CHECK IF USER COMPANY OWNER
        const companyLeader = this.companyLayout.isLeader
        // DECLARE MANAGER (LEADER) OF PROJECT
        let ifUserManager = false;
        // CHECK USER ACCESS TO PROJECT START
        const companyUserId = this.companyLayout.companyUserId.toString();
        const even = (element) => element === companyUserId;
        ifUserManager = list[0].userList.some(even);
        // CHECK IF USER LEADER OF PROJECT NOT JUST MANAGER
        for (let i = 0; i < list.length; i++) {
          if (ifUserManager || companyLeader) {
            list[i].access = true
          }else if (!ifUserManager && i === 0) {
            list[i].access = false
          }else if (!ifUserManager && i > 0) {
            // check if user creator of task bu not in team
            // if (this.user.user.id === list[i].creatorId) {
            //   list[i].access = false
            // }else {
              const ifUserInTaskTeam = list[i].taskTeamList.some(even);
              list[i].access = ifUserInTaskTeam
            // }
          }
          // add my index
          // list[i].myIndex = i
        }

        // list.sort(function (a, b) {
        //   if (a.myIndex === 0 || b.myIndex === 0) {
        //
        //     return 1
        //
        //   }else {
        //
        //     const aNum = a.myIndex.split('.');
        //     const aFirstNum = aNum.splice(0, 1);
        //     // console.log(Number(aFirstNum[0]+ '.' + aNum.join('')));
        //
        //
        //     const bNum = b.myIndex.split('.');
        //     const bFirstNum = bNum.splice(0, 1);
        //     // console.log(Number(bFirstNum[0]+ '.' + bNum.join('')));
        //     if (Number(aFirstNum[0]+ '.' + aNum.join('')) > Number(bFirstNum[0]+ '.' + bNum.join(''))){
        //       return 1
        //     } else {
        //       return -1
        //     }
        //
        //   }
        // });
        console.log('LIST 2', list);

        return list;
      },
      setNewPermissions(permissions){
        this.projectPermission = permissions
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      openGant(){
        this.$refs.gantChartModal.openModal()
      },
      openScheduler() {
        this.$refs.schedulerModal.openModal({entityId: this.$route.query.projectId, type: 'proj'})
      },
      logRequest(action){
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': action,
          'paramsLog': {
            projectId: this.$route.query.projectId,
            projectTaskId: this.selectedRow.id
          }
        })
      },
      changeBookMarkProject(companyId, projectId) {
        this.$confirm(this.bookmarkListProject.info ? this.$t('project_removeBookmark') : this.$t('project_addBookmark'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          const data = this.bookmarkListProject
          data.info = !this.bookmarkListProject.info
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bookmarks/setProject?companyId=${companyId}&projectId=${projectId}`, data)
              .then(response => {
                if (this.bookmarkListProject.info) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
              });
        }).catch((err) => {
          console.log(err)
        });
      },
      changeBookMarkTask(companyid, projectId, taskId){
        this.$confirm(this.bookmarkList.info ? this.$t('project_removeBookmark') : this.$t('project_addBookmark'), this.$t('general_info'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let data = this.bookmarkList
          data.info = !this.bookmarkList.info
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/bookmarks/setProjectTask?companyId=${companyid}&projectId=${projectId}&projectTaskId=${taskId}`, data)
              .then(response => {
                if (this.bookmarkList.info) {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkAdded'), "success")
                } else {
                  this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
                }
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
        }).catch((err) => {
          console.log(err)
        });
      },
      // doesExternalFilterPass(node){
      //   if (this.searchInputGrid) {
      //     return node.data.name.toLowerCase().indexOf(this.searchInputGrid.toLowerCase()) > -1
      //   } else {
      //     return true
      //   }
      // },
      // isExternalFilterPresent() {
      //   // console.log('hello-world')
      //   // console.log('this.searchInputGrid', this.searchInputGrid)
      //   return true
      // }
    },
    beforeDestroy() {
      console.log("DESTROY Project")
      // localStorage.removeItem('selectedProjectId');
    },
    watch:{
      valueProject(val) {
        if (val) {
          this.statusPeriods = true
        } else {
          this.statusPeriods = false
        }
      },
      rowData(val){
        // alert(this.newCreatedProjectTask)
        if (val.length === 0) {
          this.disabledBtn = true
        }else{
          this.disabledBtn = false
        }
        //TODO selectedRows after create
        setTimeout(() => {
          if (typeof this.newCreatedProjectTask == "number") {
            // alert(typeof this.newCreatedProjectTask)
            // alert('rowdata changed 1')
            this.selectCreatedTask(this.newCreatedProjectTask)
            this.newCreatedProjectTask = 'first'
          } else if (this.selectedRow.id && !this.newCreatedProjectTask) {
            console.log('this.newCreatedProjectTask', this.newCreatedProjectTask)
            // alert('rowdata changed 2')
            this.selectCreatedTask(this.selectedRow.id)
          }
        }, 100)
      },
      '$route'(to, old) {
        // console.log('TOOOO', to)
        // console.log('Old', old, this)
        // if (to.query.state === 'sharedProj'){
        //   // alert('Project')
        //   this.getProjects("first")
        // }else if(to.query.state === 'projectTask'){
        //   // alert("task")
        //   this.getProjects("first")
        // }
        // this.setShared2(to.query.projectId, 'setShared', to.query.taskId, to.query.companyId, to.query.progressId, 'companyNmae')
      },
      selectedRow(val){
        if (val.type === 'project'){
          this.businessUnitSelected = false
        }else{
          this.businessUnitSelected = true
        }
      },
      // searchInputGrid(val) {
      //   this.gridApi.onFilterChanged();
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .sweet-modal-overlay {
    z-index:1000;
  }
  .projects {
    background: #DfE8F0;
    z-index: 0;
    height: 100vh;
  }

  .content {
    display: flex;
    height: 100vh;
    padding-top: 50px;
  }

  .el-tabs{
    height:calc(100% - 73px);
  }
  // [ Wrapper ] start
  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 0 10px 10px 10px;
  }
  .wrap {
    display: flex;
    width: 100%;
    height: 100%;

    &__tree {
      width:100%;
      height:100%;
      max-width: 700px;
      min-width:700px;
      min-height:100%;
      padding: 0 10px 0 0;
      &.activeted{
        width:auto;
        height:100%;
        min-width:auto;
      }
    }
    &__info {
      max-width:100%;
      width: 100%;
      min-width:50%;
      padding: 0 0 0 10px;
    }
  }
  // [ Wrapper ] end

  // [ Nav tree ] start
  .nav-project {
    display:flex;
    justify-content: space-between;
    padding: 20px 0;
    max-height:73px;
    overflow: hidden;
    width: 100%;
    &__item {
      margin: 0 0 5px 0;
    }
    &_first-row{
      display:flex;
      justify-content: flex-start;
    }
    .el-select {
      margin-right: 10px;
    }
    .el-autocomplete {
      margin-left: 10px;
    }
  }
  .nav-tree {
    &__item {
      margin: 0 0 5px 0;
    }
    .el-button {
      margin-right: 10px;
    }
  }
  .wrap__info{
    height:100%;
    .el-button {
      margin-right: 10px;
    }
  }
  .project-tooltip-item {
    font-weight: bold;
    span {
      font-weight: normal;
      margin-left: 10px;
    }
  }
  .project-info-menu {
    max-width: 400px;
  }
</style>

<style lang="less" scoped>
  /*@import "../../node_modules/ag-grid-community/src/styles/ag-grid.scss";*/
  /*@import "../../node_modules/ag-grid-community/src/styles/ag-theme-balham/sass/ag-theme-balham.scss";*/
  .btn-wrap{
    position:relative;
    .star{
      color:#F56C6C;
      position:absolute;
      left: -20px;
      font-size:19px !important;
      font-weight:inherit;
    }
  }
  .demo-ruleForm{
    text-align:left;
  }
  .aboutButton{
    margin-left:150px;
    margin-bottom:15px;
  }
  .flex-center{
    display: flex;
    justify-content: center;
  }
  .flex{
    display: flex;
    justify-content:space-between;
  }
  .two-columns > div{
    max-width:45%;
    width:100%;
  }
  .el-form-item{
    .el-select{
      width:100%;
    }
  }
  .flex-end{
    display:flex;
    justify-content: flex-end;
  }
  .text{
    display:flex;
    justify-content:center;
  }

  .draggble{
    display:flex;
    flex-direction:column;
    text-align:center;
    align-items:center;
    justify-content: center;
    .btn{
      width:120px;
      margin:5px 0;
    }
  }
  .task-not-found-block{
    text-align:center;
  }
  #fade-in {
    /*transition: all .50s ease;*/
    /*width: 100%;*/
    /*height:32px;*/
    /*opacity: 1;*/
    /*overflow:hidden;*/
    .inputs{
      /deep/.el-input__inner{
        width:100px;
      }
    }
    .inputs-projects{
      /deep/.el-input--small .el-input__inner{
        width:200px;
      }
    }
  }
  /*#fade-in.hide {*/
  /*overflow:hidden;*/
  /*opacity: 0;*/
  /*transition: all .50s ease;*/
  /*width: 1px;*/
  /*height:32px;*/
  /*}*/
  .work-day-block{
    z-index:1;
    /*width:100%;*/
    .close-work-day-btn{
      margin-right:10px;
    }
  }
  .vuedrag{
    /*width:100%;*/
    height:100% !important;
    position:relative;
  }
  .vdr.active:before{
    outline:none;
  }
  /deep/.vdr-stick-mr{
    /*background-color:transparent;*/
    /*border:none;*/
    /*box-shadow:none;*/
    /*&:before{*/
    /*font-family: "Font Awesome 5 Free";*/
    /*content: '\F337';*/
    /*position: absolute;*/
    /*font-weight: 900;*/
    /*right: -9px;*/
    /*font-size: 25px;*/
    /*top: -10px;*/
    /*}*/
  }
  .ask-before-exp{
    display:flex;
    flex-direction:column;
    text-align:center;
    align-items:center;
    justify-content: center;
    .btn{
      width:120px;
      margin:5px 0;
    }
  }
  .ask-before-purch{
    display:flex;
    flex-direction:column;
    text-align:center;
    align-items:center;
    justify-content: center;
    .btn{
      width:120px;
      margin:5px 0;
    }
  }
  // GRID START
  /deep/.timerBlock{
    width: 28px;
    height: 28px;
    position:relative;
    margin-top: calc(50% - 18px);
    & #badge{
      z-index:1;
      position:absolute;
      top: -5px;
      right: -4px;
      & .el-badge__content{
        font-size:10px;
        height: 17px;
        padding: 0 5px;
      }
    }
  }

  /deep/.timerRender{
    width:100%;
    height:100%;
    position: absolute;
    border-radius: 20px;
  }
  /deep/.no-access{
    background-color: #ebeef5 !important;
  }
  /deep/.ag-theme-balham .ag-cell.ag-cell-inline-editing{
    height:100%;
    .ag-input-text-wrapper{
      height:100%;
    }
  }
  // GRID END
</style>

<style lang="less">
  .ag-cell-value{
    span{
      display:flex;
      flex-direction:row-reverse;
      justify-content:flex-end;
      align-items:center;
    }
  }
  .header-center{
    display: flex;
    justify-content: center;
  }
  .collapse-btn{
    position:absolute;
    z-index:2;
    top:9px;
    right:12px;
    color: #409EFF;
    font-size: 14px;
    font-weight: 500;
    &:hover{
      cursor:pointer;
    }
  }
  .own-btn{
    position:absolute;
    z-index:2;
    top:9px;
    right:119px;
    color: #409EFF;
    font-size: 14px;
    font-weight: 500;
    &:hover{
      cursor:pointer;
    }
  }
  .ag-theme-balham .ag-icon-expanded{
    margin-bottom: 4px;
  }
  .hover-over {
    background-color: #e5e5ff;
  }

  .el-autocomplete {
    width: 250px;border-bottom: 2px solid #DCDFE6;
  }

  .el-tabs--border-card>.el-tabs__content {
    height: 90% !important;
    overflow-y: auto;
  }

  .importProject {
    width: 100%;
    &__label {
      width: 100%;
      color: #409EFF;
      padding: 7px 15px;;
      border: 1px solid #b3d8ff;
      border-radius: 3px;
      cursor: pointer;
      &:hover {
        background: #409EFF;
        border-color: #409EFF;
        color: #FFF;
      }
    }
  }
  .txtRender {
    color: black !important;
  }
</style>
